import { Component, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';

import { AgGridModule } from 'ag-grid-angular';
import { ExcelExportParams } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham, themeQuartz, themeMaterial, themeAlpine, GridApi, ExcelStyle, ProcessHeaderForExportParams, GetRowIdFunc, GetRowIdParams } from 'ag-grid-community';
import { LicenseManager, SideBarDef, GetDetailRowDataParams, SizeColumnsToFitGridStrategy, GridState, PivotModule, AllEnterpriseModule } from 'ag-grid-enterprise';
import { IntegratedChartsModule, ExcelExportModule, ColumnMenuModule, ContextMenuModule, CsvExportModule, ClientSideRowModelModule } from 'ag-grid-enterprise';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';

import { ContainerActionsComponent } from "../container-actions/container-actions.component";
import { GridRowActionsComponent } from '../grid-row-actions/grid-row-actions.component';
import { SaveModalPopupComponent } from '../save-modal-popup/save-modal-popup.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { BookmarksComponent } from "../bookmarks/bookmarks.component";

import { UserService } from '../../shared/services/user.service';
import { FieldDisplayNameMap, GridHelperService, valuationSummaryScenario } from '../../shared/services/grid-helper.service';
import { AppraisalDataService } from '../../shared/services/appraisal-data.service';
import { LookupService } from '../../shared/services/lookup.service';
import { SignalrRefreshService } from '../../shared/services/signalr-refresh.service';

import { Appraisal, ApprovalState, ApprovalStatus, LookupItem, TransformationResult, UnitOfMeasure, UserRoles } from '../../models/appraisal';

import { validateCurrency, validateYear, validateNumber, validatePercentage, validatePeriod, validateZipCode, ValidatorFn, ValidatorsMap, validateCashflowWalt, validatePercentageLoose, validateNACurrency } from '../../shared/validation-config';
import { environment } from '../../../environments/environment';

import {
  canonicalizeValuationScenario,
  getValuationScenarioValidationPath,
  getValuationScenarioValidator,
  getValueByPath,
  isRowInvalid
} from '../../shared/utils/row-validation.util';

import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { forkJoin, Subscription } from 'rxjs';
import { Router } from '@angular/router';
export const logos = {
  CW: 'data:image/png;base64,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',
  Te: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACHYAAALjCAIAAADyMofaAAAACXBIWXMAAC65AAAuuQFP9mjDAAAAEXRFWHRUaXRsZQBQREYgQ3JlYXRvckFevCgAAAATdEVYdEF1dGhvcgBQREYgVG9vbHMgQUcbz3cwAAAALXpUWHREZXNjcmlwdGlvbgAACJnLKCkpsNLXLy8v1ytISdMtyc/PKdZLzs8FAG6fCPGXryy4AADnL0lEQVR42uzd37Mc53kf+PwZCxwwlxYBECBzI1nevQzt2putWD9utioVSZUbWQDprYhwtmKB2hsBTlkWICu2COViBSi1sQUo2SqB4lZsgLkwAcoXISk7FgjfhCCVCnEOfpACIBJnZvaZeec0Gj0/zvR0z0zPzOdTo6M5hwdzZnq6e7rfbz/P+w86AAAAAAAAlPQPLAIAAAAAAICyRCwAAAAAAACliVgAAAAAAABKE7EAAAAAAACUJmIBAAAAAAAoTcQCAAAAAABQmogFAAAAAACgNBELAAAAAABAaSIWAAAAAACA0kQsAAAAAAAApYlYAAAAAAAAShOxAAAAAAAAlCZiAQAAAAAAKE3EAgAAAAAAUJqIBQAAAAAAoDQRCwAAAAAAQGkiFgAAAAAAgNJELAAAAAAAAKWJWAAAAAAAAEoTsQAAAAAAAJQmYgEAAAAAAChNxAIAAAAAAFCaiAUAAAAAAKA0EQsAAAAAAEBpIhYAAAAAAIDSRCwAAAAAAACliVgAAAAAAABKE7EAAAAAAACUJmIBAAAAAAAoTcQCAAAAAABQmogFAAAAAACgNBELAAAAAABAaSIWAAAAAACA0kQsAAAAAAAApYlYAAAAAAAAShOxAAAAAAAAlCZiAQAAAAAAKE3EAgAAAAAAUJqIBQAAAAAAoDQRCwAAAAAAQGkiFgAAAAAAgNJELAAAAAAAAKWJWAAAAAAAAEoTsQAAAAAAAJQmYgEAAAAAAChNxAIAAAAAAFCaiAUAAAAAAKA0EQsAAAAAAEBpIhYAAAAAAIDSRCwAAAAAAACliVgAAAAAAABKE7EAAAAAAACUJmIBAAAAAAAoTcQCAAAAAABQmogFAAAAAACgNBELAAAAAABAaSIWAAAAAACA0kQsAAAAAAAApYlYAAAAAAAAShOxAAAAAAAAlCZiAQAAAAAAKE3EAgAAAAAAUJqIBQAAAAAAoDQRCwAAAAAAQGkiFgAAAAAAgNJELAAAAAAAAKWJWAAAAAAAAEoTsQAAAAAAAJQmYgEAAAAAAChNxAIAAAAAAFCaiAUAAAAAAKA0EQsAAAAAAEBpIhYAAAAAAIDSRCwAAAAAAACliVgAAAAAAABKE7EAAAAAAACUJmIBAAAAAAAoTcQCAAAAAABQmogFAAAAAACgNBELAAAAAABAaSIWAAAAAACA0kQsAAAAAAAApYlYAAAAAAAAShOxAAAAAAAAlCZiAQAAAAAAKE3EAgAAAAAAUJqIBQAAAAAAoDQRCwAAAAAAQGkiFgAAAAAAgNJELAAAAAAAAKWJWAAAAAAAAEoTsQAAAAAAAJQmYgEAAAAAAChNxAIAAAAAAFCaiAUAAAAAAKA0EQsAAAAAAEBpIhYAAAAAAIDSRCwAAAAAAACliVgAAAAAAABKE7EAAAAAAACUJmIBAAAAAAAoTcQCAAAAAABQmogFAAAAAACgNBELAAAAAABAaSIWAAAAAACA0kQsAAAAAAAApYlYAAAAAAAAShOxAAAAAAAAlCZiAQAAAAAAKE3EAgAAAAAAUJqIBQAAAAAAoDQRCwAAAAAAQGkiFgAAAAAAgNJELAAAAAAAAKWJWAAAAAAAAEoTsQAAAAAAAJQmYgEAAAAAAChNxAIAAAAAAFCaiAUAAAAAAKA0EQsAAAAAAEBpIhYAAAAAAIDSRCwAAAAAAACliVgAAAAAAABKE7EAAAAAAACUJmIBAAAAAAAoTcQCAAAAAABQmogFAAAAAACgNBELAAAAAABAaSIWAAAAAACA0kQsAAAAAAAApYlYAAAAAAAAShOxAAAAAAAAlCZiAQAAAAAAKE3EAgAAAAAAUJqIBQAAAAAAoDQRCwAAAAAAQGkiFgAAAAAAgNJELAAAAAAAAKWJWAAAAAAAAEoTsQAAAAAAAJQmYgEAAAAAAChNxAIAAAAAAFCaiAUAAAAAAKA0EQvAgrW7X1r9O+1Ou91O3wIAAAAATSZiAVi0XsbysJuudO+2LRAAAAAAWAYiFoBFa/e/9upXOiloAQAAAAAaTsQCsGDtTqvbGqybq6Qvvf+JWQAAAACg2UQsAAvXSg3CUpew9s6kLAAAAABAk4lYABasnX1t57qEiVgAAAAAoNlELACLttMirNWvZNnudD7uz8sCAAAAADSViAVg0bJZWDofp+KV+3/2HywVAAAAAGg4EQtAA7T7OUsqXfnwM1+6/ez/1rrxi3Z/3vtW7hfTr3V/0qt0iWym1WprLAYAAAAA8yZiAWiE1CUsgpJoE/bhP/nirb3P3P61X//olb+I//Swn6b0f6sr+9pq73zXsgwBAAAAYJ5ELABN0c1RemnJnc998dbGU+9vHLy599D94ycjPtnulq5sd9OW7q+0UqDSr13pT98CAAAAAMyViAVg8XbagbVTZBIRy819T23ue+rWnkM3N/bfffaz7f/2i/zvZmUr7SxoAQAAAADmS8QCsGjtnYykN/VK+OVnv3Rrz8GbG09GLcvW3kO3Ng5vfiKahl2KQpZ2//dbO//wYap9aStkAQAAAID5ErEALFqrN6dKZCQ7BSl3PvOFbgnLxoGb+w5Hr7CoaLm9N7KWg788/q/Tb/ezll5vsRS3tJSyAAAAAMB8iVgAFmwnG+klLb1eYRGx7NSvPHWzm7VEx7Cn40785O5nv9S6e7fw75WwAAAAAMD8iVgAFq/92P/1I5bbGwd6tSxP3dw4GBUt6db9yZOf3v6rn6bpWB72ClnSvCwAAAAAwDyJWABq18omsO/9X39e+snd/ewXu5UrI26b+w5sbhx+8Id/0usS1inmK+3tVmd75+/pHwYAAAAAsyJiAahZO/c13RsShIw1PmLpFbXE1/23P/uFTjQNa+WKYB797VZ/1hbvBwAAAADMhogFoGY7M6NE9LG93b9TZxVLr5Al5mU5eGvvM9E07KPXr3T/RPePPNzJVFrtR39PDzEAAAAAmAkRC8CMRBFJCld6IUeZjGXXRmEx730vYtkfHcPizr1vfuexKKXXnKyb7rQ/VsYCAAAAADMiYgGoXb9JV6ZszLFLo7C9hyJZiTvvbxyMfGXriUPRNOzO577Yuvth+uupT1i7o00YAAAAAMyQiAWgZu2due7T7WEKOmqtYolGYenr7b39jmHx9faT//P2z/7uUVOydsdcLAAAAAAwOyIWgLq1O9s3ftGNVyLkaLf7X8vYbS6Ww7f2RCHLM7c3Dtx8ots07FavXdhW9A3bd+DBmR+0OzvdyboTw3g/AAAAAGAmRCwANXt48S839386Qo7+fCjla0kmmO7+wM19T3WDlu68LPtv7TkYWUu3tKXbQOzAL7/wXOfuHQUsAAAAADBTIhaAXRTnq293hsyz0u/K1br3tRMpBekM/s7Edo1YRk7TsnEwgpb4eveTv7X9N3/7aDqWR19buocBAAAAQC1ELAC72ZlYpdWtSOlNZd+tTGl1diaV7//OO//97rOfj8qShUUsew72OoZ1n0B83dy3/96/PZse8OHO02hP94QAAAAAgAEiFoBdbHdDlY9SQNHNKlK20q9sSXPadz565S+2PvHr3QqSJw4sKmLpNQ07+P7GwW6+snG4O1nLvkMffvHI9gf9pmE7T6PVq7l56J0FAAAAgCpELAC7aW/3vqZsopWCil5MsZ1+fP/4yf+x72CaCiWadC0uYnkqMpXULixmZLm5t19Pc/uTv/nwb/52p79Zr1FYWxkLAAAAAFQlYgHYxaMZTfqNweLrx/3vb7y79eznbu99JspHItXo5hn7Di0wYnl/75O9oOXpbhVLFLXsefrmxv7bew/f2rf/wZmz/bZmKTECAAAAAKoRsQDsot3rFdaf9H7n2/i/j6789M4nPhXJSmQYaZ753lQo+xcVsaQCmpvdWVji/pO9H0bqc/hmfLv36chdfvmlo527d3eeT8s7CwAAAABViFgAdtHuz7zS2kkmunfuf/M7/d5ce5+KLmGRZPSCligZeWpREcvORPf7o5Im7kfiEhPDxPPpJi7d/3S4W2rzW7/d+pu3s3ZnAAAAAMDURCwAk+u12rp793YvAuk1BzvcrRTZu//9ffvj295cLAurYtmZf6UXpfQSl0h9urU1e/eneWJSpcvW/k99/Gf/0XsJAAAAABWJWAAy3VqVNBV8f0L4nS/t/k+7zcFufeJ/idKQm/t2CTzyjzuviGXU7XAuEOr2ENvc+Ef3f/f/fNQ0rPsK80+ylX/SESu1dRUDAAAAgAEiFoC+3kz23aghBSq9bloPs7nuW+2P7v/hn3TLQfYduN2b2X55IpanomNYmqYlUpYouOm2ONv4R3f+8ee2/+vf9ktzcs8y/2xbOymTxmIAAAAAUCBiAXgklWu0d755FD/c+fDuZ/55NAGLmU56QcVTSxaxbOyPFmG39hyKSe+jBCdSlm4tSxTiPPnp+3/2H/oRUvZid+abedj/vvVoOQAAAAAAO0QsAJlWv5KlvZ2v2/j4tZ9GFJEmt+8GFb12W5vL0ygsnmqKVe7sO/j+3gORsqSXkLUR++XR3291m4a12vkl0a3kaXX6wUtr29oBAAAAAI8TsQDs6HUH2+4lDTuFHZ373/xOL1bpzWWyr1/CEnFFhBbLErHEM+9GLBsHo8VZpCxRy5I6hvWKcg5uPdG9f/vZf7L9s2vt/jJo5Z52a5oXAAAAAABrQMQC0JemXXnUJezu3btf/Eq3y9a+fiHIZjeWOBhfb+05uLVbu7DiI5dRexVLPNt42pGy9FqEHez9pJu1bD1x8P093V+I/3T3E5/66N//v932YFnK0itgiZoeCQsAAAAADBKxADzSaveDlod/c+32J38z1xnscLcEZM/B3nT3kU/s33ys19YSVLFEyhJf49adl+WJA70Z7w9v7Xk66lpS6JJ+cv/4v86WRZqMBgAAAAAYSsQC0Nct3egnCq373/x2v9Qjcoi9B1PW0s0kusUrBzY3nomvSxSxpJeQvu60ODvcfSH7DqQXdXtv+jYCpAN3n/1868a7vYKeh905WbrP6KFCFgAAAAAoELEADHH/D/8k67I1XbCRf7TFRizlI5n9W09++v4r/6n3vB/u9E9rPZqaJZMqXQAAAABgLYlYAIZY74ilO3FLvPAPj3+j93T6M963c6+nN1lLq9OfrgUAAAAA1pGIBWCIdY5Ysg5p3Rlcnv1M551f7LyAVvZi2vmfAAAAAMBaErEADLH2EcuhW3sO3dx3uPuTJz/10SuX0stot7fTa9lOL6qthgUAAACA9SViARhi3edieaLbK6xXy9JdAjf3HvrVv/qDyFe6ZSv9wpXoELYtYgEAAABgnYlYAIZY7yqWA+/viTsHImuJoOXmxsHNf3jw5sb+O89+vn3nTv/FdL+25CsAAAAArDMRC8AQ6xyxRIuwnelYuh3DYkaW7qQs6dsnP/3xaz/tPcfWQ2sJAAAAAOtNxAIwxJrPxRK3iFXSa7/ZXwKHU4HLrT0H7//Rv2m3ez3CerUs1hYAAAAA1pOIBVh67U4WYrRyaUYrZQDb0c+qlwe0y0Qda13FMjp6iaZhtzcOdJuGfe5L2x/cbafl3Hk07/3O+6CFGAAAAACrT8QCrIBWL0rp3ctNwP6ws939Ye/7skP+IpbBWzQN633dH0FLFLXc+cSnPn7tan+pt1PK8rCbaHW2BSwAAAAArAMRC7AKWr0B/l7dShRVtLb73avyPaxaWdwyCRHL0CqWW3v339o4kOZrSa3D7n3zT3oLvd1+/KVKWQAAAABYeSIWYEWkdmHb2TdpjL9fX1G6lkXEMnjrFa90p2a5uS/NyxLztRyO2Vk+/MyXWnfv9mdn6fTqWAQsAAAAAKwBEQuwCh7lKO3Oo6KK/lQh7Sxu6UycdohYBm8RqHQrV/Y8vfkPD97eG4nLk/Ft5C43o4HY/t/41V/9tJ0tZZOxAAAAALAGRCzACug1BOsnKK1HyUpMDRI/aXenBulFLq22iKXSXCwHo2YlGoVtRtDS7Rh2uLdwDkTckpZSLLR+KUu783iXNgAAAABYQSIWYOm12+3HWoF1//fwo5cvf/zvf9wrZ9npW9Xe3vmN3YlYhs7FEhHL+xsH72wc6nYJ2/d0hC63e1OzbHUTl24nsftfeq59+wMlLAAAAACsAxELsPTaxW8ffvi1P+gWVXzzO/1sJdWw9Cdqmai6QsQyrFFY3J6JBXJzY380DYt85WZv4dzc+3TKV3oZzP47n/qt7Z/9ndUSAAAAgJUnYgGWR68JVTvrBNYLS9qPpv3o/mT7nffuPvv5Xj+rbsTy+L8uQcRSpoHY/lTgEinLrT2HNp/4RPQQ+9X3zhXSrMi5tjvZtDmt/M97hUYaiwEAAACwZEQswBLpZyrZBPb96KLdn4jlwSuvfvDkJ1O+srX3kIhlbg3EYsb7KGrpfrv3mW73sH1x//AHX3yuc/dW1sOtszMdTrITt8RMOa1ugZHmYgAAAAAsGxELsDR6s9ZvpzKIR0UPO7URH7z4jc3eBOy92UFUsczxtudgbykd7i2uA6mHWNSyRFHLnU/9rztNw1qdR5Pi7NxLFS2t3E8AAAAAYHmIWIDl0c7+v9Xu95bqzbLyzi/u/ON/0hviP3BzX3w93O1YJWKZayHLgW7QsnE4NQ2LWpboGBZzt3S/3Tj84My/yyKW7rw47X620psjp5XKXAQsAAAAACwdEQuwNLolLJ2sFqI/F8uvfvKftp78jRSrxIB+r37l8Na+p6OQQsQyp3xl4/D7+/b3ApVDm71alrj15mU5uPVEt8Al7v/yS89v37nT2SlFyrq9Pexsm4UFAAAAgCUlYgGWTLuXtLRjcL7VefDNP02lEpGspIKJuBNj+mleEBHLfG7dhmAb3blY4r2IWzfiikZhvRlx3t/olrbED+Pbu5/8rdbP/q5XuZLSsket3tpTLCMAAAAAWDQRC7A8Wu2dcfhW54MP7nz+n3YrJJ44EDUrm3t6JRT9GUEObz1xKAb3RSxz6xIWIUqkLFHLEve7b0rvvYi3IOZl6ccwT3QTl81PfPrjP/uP/SXSand2aln67cIAAAAAYKmIWIDlsTOHx/ZfXd36tU/vDPEf3tp4cvOJf5QaUvUmAtnfq6VQxTKnWy/cOnCzV7DS/cmeg71Cov29/3SwV9HSbSaW6lri1z78P/5V64M7sVC2I2LpZyt6hQEAAACwfEQsQOP02kZ1G0n1Z7PvBxTdUfhoMHX/j/5NSj6iQuJ2ry3YqKF/EUtjb3ee/fz23/7XwqLZ3pluJ/+mq24BAAAAoLFELEATtTvZnPbhYWor1bp7987nvhRVETejCVVvfvWb+56JblQiluW6dWdt2Xdoa/+nfvX//Gh7p1dYu6e3sLYfJSvd/3tocwAAAACgmUQsQCO1d772x98726+9dvvXfn2zO5X6oWgOdrM3p310nYpCFhHL8t32HLrZy8Y++N3f3+41DUuLqd1tHbbd+7bVbqtgAQAAAKDRRCxA46Q+UduPGka17n/rj9PM9re6gcqB7swf/cntn+olLiKWZbr1Zmo51Hvv9t/ZePrus5//6G//bmcRPWw/ytf6BS4AAAAA0EwiFqCB0th6r0PU3TvdvGHvMzfTnOr7DndLWHrFK91GYXv7xRAiliW6pbcs8pXNJw5FKVJkZrd/7ZMf/fl/7KR2Ydki63YL687HY3sAAAAAoJlELEDztPv1Kw//5m9v7//1mG0lih5i9o67ew7HFPe92ONAGqnv1bWY7n7Zqli63d4Obu15upe1HOh9uz/eyl/+7r/KFlSWtbT78/EAAAAAQOOIWIDGafdqF9p/8/PuyPvGwTsb0VTqwM2N/d1eYRsHe5nH4V71Q3c6llt794tYlu12uB+SRcewfU9v/U8HulVKvS5wH/7j3374znvZIut9EbEAAAAA0FAiFqB5etNxfPxXf93tJRWxyr7uFPdxp5t27DkYzcFiXL7bK2zvLhGIiKXZ07Hs7/V8i7f4QIrNUtu32/t/41c/+U+KVwAAAABoPhEL0FAfv/bTNBY/dcghYlmu21aaWWdft3Tp/vF/vTPvfSurZWm3U+OwttIWAAAAAJpAxAI0lIhl/SKWg72KpYO9bw/c+c3Ptv/be52dpKUXrbS6U7T0frJtCwEAAABg0UQsQEOJWNbt1ptrZ//WE4fe33i6u9ijk9iTn/7olUudTpaztB4t0LZNBAAAAIAFE7EADSViWcOIJebaSQv89t7D3cRl76EoZ7l//ES3dqW9nS3JdreYBQAAAAAWTMQCNJSIZT1v3RnvNw68v9FtF7a5EUHLgZt7n7777Gc77/wiLcedchbTsQAAAACwYCIWoKFELOtXxXIgzcUSX+P+VreEpV/Xcnvfodu/9usfv/IXnfZOIYstBAAAAIBFE7EADSViWbv6lb2HIl+JFmFbe/enRmG9opb9tzYOR2lLhC7xk3vf/M5jk7IAAAAAwOKIWICGErGsYRXL7b3dRmGbvUwl7ke40rsdiNZhcWezd/+D3/5C586HNhAAAAAAFk7EAtSoX1vQjjvdu612Z/qOTiIWt0KBy80nuvOydOtanvx0rB7d9a3d6bUOa7XT7Czah0G222m35/avYJU2mVFbga3D3nK5no81dg0XQpXXu4YrjG3EYmzCsko/HPxacYF7X2D+RCxAbVrpc7zVvRN3t/s/eDjdo4lY3Pr5yr7+apAaiN3a+0x31paNg/f/6E/Tst1J8lrtnXUQ1uT0rK6x4MIZ3eAJ3pgHXO1TuEnOdZd6aGMp3r4qeeHk/9ZgxJLuBlf15VQcK1/eRTTmk4i5bR1rtditaRZa83duux6oA00gYgFqPHCIUe7tXNTS3hn/noaIxS13O9BbE+Lr/u6bspFmajl85zNfaN2924v1erVTsAZjJZP8pFN+ZHmK8zSndsx//R/1X2vZClZv/GIlN9LJL/W1ySzjIpow3WeS/Zi9x3xe9ahPkJX8XLBVzu1NKfxw6LeFQH0p1kBYYSIWoNaDg3ZvmLvVTuPd7c70A98iFrd0SxO0dBuFxXux52Dcv9nLV3pvzYGt/Z/66LW/bj9azoIW1n0/XGXkcei/HXPCtg6ncCv/qhv+csYPMYzfEMrmLqPGL1ZysGamy98msMDnsDK5oJ5X1T++LcCFvN5mLr1ZVMs56q5x51alXlwyDQ0hYgFq0+r0xzP6sUr33vbUjyZiccvegpiLJQUtUb8Sd27vO3hr3/4IXbb2PB334ye//Nafth1Rspan/UN/4f79+2/3XL58+eWxLl68mH5za2ur1HnammxwDRxfruUpDe04sXRvzdCnfe3atbTmx7o9uLanH/74xz9+9dVX05ofG8tKDlXMYsSwCZlT7X+9OS/KUUxd2+AaXsdd40fVOq+NK/95KoFr1H5+zI4uDk7efPPN7KDl9OnTZ8+ezY5q4jjn3XffHX8s5J2ChRCxADVKJSw782LElxvvTv1YIha3dHt/X0zBEhOxHLy971A3bulWtBza6RX21P/YeyD92oef+VL7g19OPfcPLOlpf/ynFKjESdeZM2dOffv0V44eiduR546mW7qffjjqlv3m1148Ho/w45cvxqldCl3KTsLZqIW2Js1S6mpsskQjFNlz3tzcvHr16g8vnI/19qvHXshW5t858pVstc++HdwQsg3kGydPxCNc/MnLr129cuO9dztLPpvFJCM4q7E51PiimhMdGQa1KBbyktd5NHYN556p/sIN39f7XkRqEgczcTRy9PnnCkcvQw9d4vat06fiuCUOWtreIGgGEQtQ75FCZ6dT08MPj5+IqGDqRxKxuO3cDr+/EfnKwZvdZOWZ3rz3h7qzs2wc3tq7f/OJp29uRAbT+51P/mbnnXdthazDydi9B/evvH71++fOHv/6i/nTrWzIuHBn19vQX3vh94699L0zf3n50uatrW6d4vKkLFeuXCmUL/Tv/KTcLdKm+JqV+DRKpAvx9OL28is/Kfu6BpdMWKKRrzfeevPPz/8wEsFRa+/ghjAYKBZ+LY1lpKGNf/HCV1PiEteKdpb2su6UvHardnqr8dS3H/fqfyLKatSoTfc55TbSqW/JYrfx69evD26PU++v0ouKd38ZV9pYzQrLIXujp7n1HqeZO/Dad5Lpa8XtPf3bJn8izOjDNG1uFXcmly5dWpPPhWw9iUXnyHy645nsfuygYk819GB+6BFL4efpTvzz8z+6cHNrsz1stwDMjYgFqPG4oZNqCLbfuXHn2c9HtcGdz3zRdPcdEUu1W+QokbJEphJRStSyxHQsqZbl9kbUrxy+2YtbunUt3ejl4EdXfmpLZIXFmVicw588ebIwQDx0+Hh8fDLJiHP+d9L5W1xktxQnbFk1z5jFMvnt2vW3G/iq41lN/YqG1jk1/329cePGuXPnXnihW62SspDBd3ZwZd51bGLoL2f/Kf5c1IdFaDfYUqzhYvzryJEjk9SxTXI7depUo15d9Rf1aB04ciQFEosS45VD19LpNup0//jx40u3xsa12LUsh/w/PHr06GLf3HmK8tPqS6x//8iReLQ1WW6xhtSyM4lb9Khs+DFSvZ8L67Nx1Tda0s4f0schzaijl6F7wqGXT+V/P45+I7Mf/FvAfIhYgCmODrqzrfQmt8//pJO6g330yl/cevLTt7rD3wdUsUzxpzsilonnaCmsIXEnVhsbKEt6rjXmdChGyuK8/cQfnJyw8ddMb1E6kK6Va/KCTRHLFNU8SzSIUGVUaOh5e5Pf0Li2PbpnLHC1T7fvnnkpqseWZeQirjIeGiBNGbF8+3SjXl0t6WlDtvF4p2rZsRfe7ug5s1wDbbGND7122yjw5B98Qwdna9/kV2zoNn2Y1rK+xYN0uzZNNt/GUn8upH8oYplOHNVnb8QsbnFJRKHASNwC8yFiAabR2plupd3PD1rp3ofHv9GrJ4iCg4Mx5H37s19s9/uGlSZicROxsJIGz3PGzJUafYriGre45DBaGNU1VFrLpZpp/OWtt94a80IWODQjYlnGiKWwCaSvEa68+OKLC08W88sqJn25cOHCqAYpzZnkRsSybhHLYMoShV8L3A9P/kEQ37766qvxhL/8ld/ZtS5TxDJ0ecYV8RWX22BnxfyUbCusYsSSNZnM5rR78OBBY9s0iVjmvJcbPLCJcvA4qpnF8Xx+w48Cvug/tutZBlAvEQsw3VFD3LZ3prbvdOOW//be7Wc/0xvm7rZvurXnUJqBfOq/IGJxE7Gwqmdck/xCNCY6ffr0YOeuhQ80F55SNBCLGcJLvbQ5ELEsaRXLoyGAXie0VLmSPdt80LjYTSDNQBtbaGHdaNTIhYhlDSOWwn7vxIkTS/HJeOvWrUguhzbDEbFMuNs8e/ZsxUOFwaaL8ZjrcGBWPWJJHwrZg0RvycGPg1artUqfCyKW6Q5346qRWdTqjWqXGuXvEZTKVGBuRCzANLYf/zaag209+RtpHvLbe596f9+TabaMO5/5wtR/QsTiJmJh3c6+0s+jAXqa93LUOdjCq1gGn1JctpnNhj3daWe9RCxLXcVy78H96HGUf8Jp9CouE053FnVLycpgOVdUmzVwDRGxrG2jsPyKGk0ms+2rIVfWD15SHS348sOC2UxLGoVNetpy/35kVNlbP92iG/xX8ZjxyKpYpjhAKhwRrV51o4hliiPeNPPK7C6ZKkR92VbczAkFYSWJWIBpbHdjg4/T/V++eLI3IfmB3szkBzc3Dt/ed6g3P/lTdz73z6b+EyIWNxEL6yZOVgvztOdv9Y461Tg6nz23mGC50DpszKnmTIlYlnculuihEYnd+EnsGxIx5jtyROvztJ40ZyBDxLKeVSyFh3rh945t3mruVczxxOJTY2gnTBHL5CJIq2XpFXZu8cn+V1deW4dDr4rrW/q3+dU4xrVjUpYFHgXN+nNBxLLrnq1wJ8tXsvWk3ktG8uF69ieydzkyPykLzIGIBZhCqz/DygcfbD37udt7D8fQ9t29aaS7O8t9L3E5fDMqWj6riqX0n+6IWEQsrN9pWFy2//1zZwfPe4cmBE1IWQYbHWR3ontSfpqKhZzUiViWNGJ5/fXXBzOV5lRxjYoYs29f+t6ZNHtBx1wsMyZiGbNnzgba0g+jRqQ9sE42ZLgtZq3IItWsz1W9/XPWYRQ4Kl+rdx8auruIR+6s+uQN1RuFDaZT8TUaXcahXaM2t46IZSHjJp12OsIvJB/d25HnZnEVyNC0dZJac6AiEQsw3aBg56O/ev3Wk5+6ve/p2xv7o3Jlc+OZm/v6VSz9jmH7Dt75/D+d+phSxOImYmFNxPWncaFxYVxscDC39oGnepv+F55nnMYvsC+NiGUZI5Y0BjE0vWvIdPejJkbKfxvb8o9fvrhKQ2kiljm8UzX2KcrKCvO3N956s0HnELmPhpdffnnM/PaDL0TEMujnb1/bNZkutQqllozZfmNwAa5Y4lJXo7DBnW18qHVWdI4uEcuue7nsaxwS5Jv49Zf80efjVmPEMnRHWjgGbtQHAawkEQtQ/qAhEohvfifClW6gsm9/pCm9FmH77+w52BvpPnxzY3+vluXQ7c/986n/iojFTcTCyrt37153TvsjQ851GxWljLlEbsw4eFzCGU2fVLHMdFRoZSKWH/zgB2PWqKalLEOzlvykx7HyF7rELO9QmohlDu9UjSO8Q6u+olIkJtUoDP8tfAgyPiB2ff4ill1F8dwkE6tM9/meTd4+dAR5NdQYsQyG8TG7XqNerIhlziLVGF6VHuHKkee6Kcvsj9Lz/etir+tNgdkRsQBjzn7S/7V6R9L9n7Xu3v3l5//3qFmJBKU7tL3n4PtPpNHtA4U0ots97LNfnPqPi1jcRCys1A51YDzijTfeSMUrK3yL07krry+gNYGIZbkilrjUd9c2XMt469ZyPX416zzHJUUsazsXy9BNPhVXNWdkvJ3bUc/05a/2KHB0JpxDqBzT+azwMpxFxJItujjMu7m1Of6wMKvrWqLPBRHLROMJ9+/HYXAsqy8349KodP1HPm4H6iViAcad/MSsK/kjvo9e++toDpbyla0nDkW+cmfj0M2Ng1HOcnvvUyIWEYuIBQZPnoc6f/58vm/ACqcs8epiks+o15nnwhexLFHEcvbs2cHJWldmozjxBycXNTuLiEXEUrim/p133pnwE2oOH4uXXr08nwaYKzYKXIhsL1y4MIf92A8vnF/ho7WZRizpU6A92Ru6RJ8LIpZJvPTSSws/pBlsbRo7DW8NzIiIBRh/zNfq5gPtXnOwP/o3t/buTxOupHwlBrXf3+g3B+s1DROxiFhELLDLOXNcPhaDlQ1sfzTTC+hiiCHmfZ3bIIKIZVkilkuXLg3taFGYl2ip1/+4iDXrFaOKpS4iluV6EwtrfnZx9xxS1dUbBc4WZlqMc9iJRSnGCl/5PqOIJf+AgxlVvnJlGT8XRCy7r1d/f70hVbnFWe6OPHrjVmxeJVg4EQsw5hA+ZQOtzgcf3PncP7vZHcg+fHvv4dQfrDui/US3hCXuxNfBLETEMt2f7ohYRCys1iBI3jvv3ogi/cIs2Sufr2TTgMfsFPM5nROxLEXEEi9haKayYqVd6bVsbm4u6dXKIpY5vFMz/TjIb1kRajbhMzGm95jbh+BKVrEkr129MredWPyt8Yc3SzwUPssqluxh8zONL3ABiljmJmbAasLRfjZFXP5pnDp1KlsVpSxQIxELMO4gPj5yH1756639n+onK700pd8fbN9TqUVYNrotYhGxiFhgjBs3bmQXnK58f7ChA3xzm2lTxNLYiCWLGeKa6OPHjw+2sDj6/HOrlD6m0Y2Yj3p5h9JELHN4p+YQsWTTHc+5HKGQLMad/Ij2HErWVriK5fjXX5zPrjL+SowXd1b0mvf5RCzH/uXvpU2vULyiUdhKSvHn4BHOYg/C80dZhYkSBS1QCxELMPoIPpKG7/3fUblya+NARCyRqfQmXDkQ89vf7PcH697ihyIWEYuIBcYPhUT9SspX8q3nV38ilqPP5wcauv1GXnhhDufkIpZmRiz5c/g0HdGYjuErs2nEyFo2F5FGYXURsUyXssQtpgdY4AdijDLHYH2htkYVS9n9Z/j529fmmRPH12vX317JAdnZRSyFZRh70cHltqRzdIlYdj0Kbcih/qi3u7s2Pr4SSlmgOhELMO5QPsKVO3v239x7qD8Fy07NSrqTBS3pjohFxCJigaGuX78ebbIGe7as/lwsR57rpizxdec1njhxYg7XUItYGl7FkrUIG3Mx+wpsF+klZBOxzJmIRcQyKmVZyOtN2/7FixfTc5hbb8BVHQX+7pmX5raTTH8oqvFWsq3QrKe7j1u2tsfGPrhRLOPngohljCjXLuxymzMRS/4/RfNebxbUS8QCjLO5b//W3kMxch0pS8Qt3VHsjWeikCUqV9L89rkB7sMiFhGLiAWGnmuleX2HnnGtfhVLSll630bOpFFYvaNCSzoXy7dOnxpTtpKv9Fr22+Asx0s3lCZimcM7Nbe5WNKd6NGXVVbNRxpKjv3/0aNHxzexEbFMsjC3trYWMkq7eWtr9Q7SZj3dfWE3Fdfc5DeKJf1cELGMEZ/7jSpVH3pMFd+e/cE5bxbUS8QCjJMfyO51DNt9yFvEImIRsUC27Ud/sFS/Mus234OxzagUZ/Dsetfz7UnOEgvnk0P/+tzOxkUsTY5Y8rPc17L+D80sB1fIwT83tGhm6PYyRbvzNJA9WLNluvtaiFim7hWT7hSupp/P+pma58x5eHElR4FjDHdul2jk96I/fvni6i3MOTQKy9/imPDeg/sdEcvqHvlnE91Psnh3PYx5tBnGZUtHj9ZY7BurYluXMKiViAUYR8QiYhGxwC5nU4+fluTPVeJ6zziBmcW1bKPqYIamLOPHkUddaFn4dvyMxJNMMFOYWnOmRCxNjlhOnz5d6BFUfbx4zAWbY9LHwS0lTQM7/vHHD0E2Z/hJxCJiGRzCyza9+Lq5uTnPj8irV6/Oemb79aliyR9azHO67CjJXb2juDlHLHE782+/t6hxbRHLrN3c2szvctNed5Ljh/zOOfuvscWd/9GFmAYp7a7j6xtvvRk/yV+8Nd2b2H8H//66twxqJGIBxhGxiFhELDDdCEhcvf6Nkydm2ghlsKN9uqVh4lHDzaPG2bOTwKFD0pNXsQz9V+fOnZvngIKIpbERS+pRXn1oYLDxRSHnmzBiHHUN6agYZsKUMb6+/PICqgRmMZQmYpnDOzWfRmGFFTX/ns56tYwPxCwVELFUObSIr1euXFnIdNnpFn99xQ7Y5hyxpD/0l5cvLWpvI2KZqbicqOxn09Cjl7hFsdqogqfYo545c6biJ2C+Lk0VC9RCxAKMI2IRsYhYYPKBj7zBqWhnVMWSj1XGhApDw48xVS9lzw/HdCGPqoX88pnDiZyIpbERy4ULF+oa3BnVXiO+Hv/6izHdS1zpGcMHMaKU3WKrjHUjNfEY+hyGFsRM0XP/5MmT+Xmhl7ohjIhlDu/UPBuF5QP1GA2c6cqZPXg0/V/U9GMrNgocizRdvbGQKpa4xV9fsQHZ+VexpNu7v3hveT8XRCzj9+dZVcoUpXvp97Msc8y2FlcvVdyu5xm0wzoQsQDjiFhELCIWKDucFF9jYHdMb6Iab4W+RulO/DCNoJ34g5Nx+hRjWz/5/15JY83pa1wZFz/P5xD5EpbJ52gZNRKdH7+O55CfjkIVS72jQksXsUTXi1HNtaZ7/vkffve733399ddjfcuXTBVyjvQ1ficWYApdhha7FFaeUiUscYtinaGr+jyHMEQsIpYxPSTTLbbHBw8ezHq1TNMvLaRL2OqNAmd7/nkuzMIubiUX6ZyrWLqTdX39xXR0tIyfCyKWUeLyjrIH/4WrNOIWF6NMeLpx+o+/PfVxVPoI6AhXoD4iFmAcEYuIRcQCE8pOeK5fv16xKGSKuSjS/WPHjsVFbdHy/r333ss/pcHTp+w/bW1tvflmt7PzqLZmEz7toZUxcfKWb/c/t7M4EUszI5boJ56NtA5tOz71qPHLr/zkl/fvTbfNhtgEzp49G42MUtY4NFwZPxdRPqS8eLERM0KLWEQs+cm0Cg0kszuRwc96/xxDydlmooqloni/CpdEzOFW2F2f+3c/WKVFOv8qlmzH9dL3zizp54KIZZS4rmj8pIm7HkLHkXz+yqT8Ectgdey1a9eqfA7Ocx4+WAciFmAcEYuIRcQCpcR50fHjx6coBJkuYkkDH5FkxCVvceH84NhxqVGziFsuvXo5ZS2D43Hjh5iHBi03btyo8nymJmJpZsQS5VO19M3Lz0IUq+uokpHC5jDJ77z11lsvvfRSoT5skmebbS9xBeuEf3FZhtJELHN4p2Y9F0u2vQxN0OPlz25djVe3qPqV1YtY4pKFoU0+5zwpS3zdvLW1Mkt1UVUsaXt87eqVZfxcELGM+WwqtZEOXowVF3wUjh8K++dWq5X/TxHqTF0NnIrSVLFAXUQswDgiFhGLiAVKifHZo0ePDj2DncUJfJxZFc7Ps2vcdu1T1L0/YvcUoyffP3e2MKn4hDPeP2ok/frVoSeHcyBiaWbEEu/L4GxA0w0NZPlK4WLP8bP+7Loqpl+I9T9a6kVRy4Tbb/af4p+MGnmcf+giYhGxjJnxPv9tzE40o5cWkcDkUb2IZVcvv/zyLGZ3m6JwNlbalVmqC6liybbE+NTILkZZos8FEcsoZRfv4ET3UVY75uChNXDgnm9NPMWbGHUw3jWoi4gFGEfEImIRscAkY7Lp68/fvlbzWfqR5/q3wpn5kSNRK5M/uZ3F0G0MXseATj5oKY6MP/708meJ58+fX+CbImJpZsRS7yhVjAvPtJF9Wv+jRGxUX75C+hLZ6qVLl5qzhohYRCyT7w3iObQ67eofhflv27ld8aJKWJZ3FHhIQtzppNx38pV/6J5qMDYuNV1E1gW08DyX90L4+VexFPbMca3AvQf3Bw8pZ7FIRSzzPM4pHDlPUsUyxVKNSCYOP7yJ0AQiFmAcEYuIRcQCEw6CdFuE9TrO1xuxRAeiQsQSQxuXL1+e20uLy5CjXXh+LOZRD7Gdp1c4V48pxBf7vohYmhCxFApKop1XzSOnf399zHBkXWK7jjGpwaBl8P6ZM2catYaIWEQspeoOx7d+GrOJjSoXiwrLmc5Jtg5VLPllG8szPnwLDd8mry6dZB2YMK1JzyFmfVuN/kILaRTWD+Z3jqayKZGW5XPB6PwoQyu/J+wVlu7EhI7j9waF7S5+f7qIJW3Is75aC9aKiAUYR8QiYhGxwKQnrhcv1n+K3ksv8uMpMYw7dBrMmY7sdHozakbdTOFC/v63jydA0btsPs9wDBHLYiOWoQMBb7zxRr0t8uY2EhCvIlbpKMwaNUCWgs+ZltQscChNxDKHd2pRpR75XXqaRmjo9jthh73HDqTv34+Si1EVYCKWKUStQ2Ha+cnbEI35V6XClfw7GM9nNcZkF9goLN7Q7Ns33npzDsPcIpZZG186tushWRxU/PznPx91NJWf7j4TVSzV30ThCtRCxAKMI2IRsYhYYBIxUXw2P0Q6Z669YXfcCsUrczgjKpTpxCSchWvlCmM3MdAci2Lhb4eIpWlVLJ3HZxGofovm43PbCjJxmX8MQw9OJxNfC83Tm0DEImKZZE6j/J/Or8altqzBOZAuXLgw9AJtjcKmW6pZDDD5Rr3r1fRlJ4ob7Hr0zrs35nlAMtMP03lWsWRRWYynZ5VJg1N5aRS2jMZ0E51wa/3hhfPjZ5Ub+gky9f7fmwg1ErEA44hYRCwiFphEZA8zms43PVqce1+7/vbQIZjZ9ewe+sjRG2TwGszs9u4v3pv/tN6DRCwNmYslvxpEmVeNG0XaHGa9mg19/BiGjigxv+gKLcKGXmc6fyIWEcuut0ddHx8vxtr1g2D89pIfs07vUaH8QsQy4W4nu//9c2fLRiNjSohKRTWjZn+J+6m9VUP2eBU/TOdcxVJYkulQKhUGzfSjTcQyt+PPqavEYp659sQHJCF+v8pxYBOui4KVIWIBxhGxiFhELLCrmK1kpoNHka+ka0XHz4M6t5QlJtVIU1MUrmm98npTOrOLWJpTxZKtEpFD1LhRZM3KW63WTAc6h67SMQydLtJPoyGFFmEN2QpELCKWUo3C0v24gLrK9pLESPHgmP6iXuOyV7HE15gLfXBVnzwXKXw7RcOxwkdG/nN/6Dzty2Uhc7GM+ja/AapiWUaRhuYPPrNtbfI0NB1OT7gaxOUm072P2ZP0lkGNRCzAOCIWEYuIBXZ17ty5KXpuTHgKFPnKjRsje3EsalAjUpZjx47l56L48/M/bM47ImJpSBVLfkU9depUbZfeH53TBK1DN7f8WxBbQeGZmItlPkQsNV5KXyg0iZm3pt644vfTtGSDu99CUzIRy+S7oMFGQGULWbI7L33vzGtXr2TNqSZ/nKG/ED+M57bsh3CLmu5+MLhKd2badlLEMmuRjpSNlgdXiezSjV33DzEv3XRvYvpXWeEUUAsRCzCOiEXEImKB8aLEPgZ8Z9RuPopFbrz37mIHd0aJ4Cfin2zUplFXropYGhWxpBXp9OnTtQ1RHRnypswo25j8YVWxzJOIZRaFLOnryZMnp16T4wMxpe9Dr9ZXxTKdGG8dGoeUzVdSi8V4U9Nn93TvS+GX47kt++JtQsRSaAw7yfD6Yj8XRCyjxIQ6ZZfwYFF4fI1K2V3/VmHKqynexNTrD6iLiAUYR8QiYhGxwHhxfjKm2H/S25Hnoh6k+/XxqeOjWKTJbTciZYknGdfQPXjwoFHPU8TSwOnua4xY8tPdM+uhNBHLHN6pBUYsQ2+lShPyW3oUqzXqhSzvXCzZ17govkojoPzmf/zrL6Y/cf78+RqroGKGtqXeVc5/LpZdF2nsb0vNxjH/zwURyxgnTpyYoqff4G14PdPOKjDhniG/Hxh835d944WmEbEA44hYRCwiFhg68JHuxJWG2cTXVQb7Ur7Sve2c+UQfj+jm0fzm5hECxUJo2jMUsSw8Yhks6aiziqU3nUCpv76GRCwilioFlFGPMmbGr6FbVgwIZp9fzXk5yzgKnF+83zp9qtLRRW5OiMuXL/fP727dGtqlaroHj2e41DvbhkQshXHwfMw5vmXlQj4XRCxjXLp0aXAe+ykL2W/cKLzj6X4hXxnz+IUtPT83TNyJuSS9X1AjEQswjohFxCJigTGnuH95+dJgQ+1pzldz4Ur6ev5HF5ZujLjGUYCKRCxNm4ulU3cVS9xiCHj8GrjmRCwilqn3DzEMN+E7nm10UcsYA4KzmJNsPRuFpQUbFzFUGQRPb2V2P99+6rtnXip8SlaZyyc/Y9zSaVQVS/5+mhWp3s81EcscRG5R/bwgbV+pnL3w+C+/8pPxHeeGhqyDv5y/VMXhE9RCxAKMI2IRsYhYYNQYbppnMo1fVDw/z882HF+jm0ehE7eTn1JELA2JWPJlWFnT8LqGorIh4OZke40iYhGxVLya/o23+m1qWq3W+E/D8MML5xuYryx7xPL9c2erH1qkRzh37rFJF956662KO4csv4lbPM/l3fc2p4qlcGcWk7KIWOYjNrfq5wVZzW62GkSSHUVjha1vwpQligsLjxxXiTlqgnqJWIBxRCwiFhELDI4opTvvvHtjsD9Y9ROquHUnpB12wtOos6Amn5KJWBpYxXLx4sXah6IKg4bLtZbOfIGLWEQs1TaxmMk8RvTym9KoDSqKGPID+vleNCKWqT9eY1w1jYpOtzwL+/nr168X3sS4mKOug5a4pVHgZdzlNrOKJX370vfO7Lr1LeRzQcQyfvuNKtvqK1X2z2NTjVqWaPR37NixtINNe4YJH7/Qgy7bn6Td+2AXMmBqIhZgHBGLiEXEAoMDH+3e/8VFuzVMdD9w9WK6GrT5g8UiliaMCi3LdPdx/+WXX659KCq+nj17dunWz/kQsYhYKlaxxNf4mJtk44qCzuLocEwwJmKptv9MK0bFRkPpfrxB+WH69DWLvatMxJJ9/fHLF5d0V9nA6e7zx4SXXr3cru9zTcQyN6mQZfrt6+jzKQvJhyJHjx4djEx2nYsl++f5r/H0VABD7UQswDgiFhGLiAWGji61Ou24rGzwPKfiaEX0hYh5aCcctm7O0mgaEUsDq1iqPOHxryVGD/PNyg0T1DuUJmKZwzvVtIgl/zXqNYduVtlPYgj4sSmUjz7fzVeOPCdiqfipGlVEaalmHYGmvnTjypUrg29iXGifPX71C0Ti2S7prrIhEUvWx2lwp/3uL95r2ueCiGVXsX3FTCpV5mhMO9JC8DY0h5twOpb8lp4mune8BPUSsQDjiFhELCIWGDoCcuO9dwunOtnlZlUapseV/ku9WBryTEQsjZqLpb/J9FoJzWggOE0GECMazVwhF0LEImKppUdNfkrkzrBh+myW+/7bsTMyKGKp4urVq7VsuXGLNyg6AvXfuMd3imd/cK6W6SLS1zfffHMZF3UDq1gKBzARX917cF+jsKU7JM4K0aarYunuRXsRy2CyMvmbOLSV8ahyeaAiEQswjohFxCJigaFilsgaT8hdVlYvEUsDq1g6O8PidQ36D73FiGFcdF92+1nJLa7GiCX+bWxTC19G+beplumvVixiSc2aanzT87Mit0e8F2fOnKll2on8nMwRCZz/0YX+pf1Hj65wxDJmz5M+xaoPgmfdFIf+rVg4dc3FkoLYZdyT1hKxDBYWFC6gqdjwLTa0Wj6wRCxz3rRPnDiRLeRUjlZxfZiiGqZ/y2Wu9+7d8x7BLIhYgHFELCIWEQuMH/6od3S4I1+p790RsTQtYon3ZXCa1llEldE67NKlS2n65c6I2Vwn39BqnGp4nmoZSsv+7bdOn2rCEsieQ71DVCsTsVy7/nbMnlJLvpK/E0Nym7e2Bt+Lt95668iR6XsiDd0RxQO+8dabKStagfxs8lU6L5sru+JCSP92fHlf1o5sigcvzPEQt5tbm0t3wFAxYhn8LMuv3oVa5yqP//rrrzfkc0HEMrnoYjpkL1d5054iYsn+4quvvupEA2ZExAKMI2IRsYhYYKjaL0BLLe+nGP9lkIilmRHLn5//YeFPz2KIIT9y9N0zL115/WpqklPYuIZua6u03VUfSsv/w9OnF98orFDFUmPKskoRS1yeHPOE1TJknN9IY1MqHirfv//7x7+Wn0Bi6uv98z85depUfu1dz0ZhMRN1YWaOqVOQfIu/obNbx1Q6VfLXwpPMNyBaluOZuhqFPTYj0bB8pcomGbdIOrNZx6ZepCKWOX9Uxf3YxEbVOc0jZXl8NpduqZnzC5gZEQswjohFxCJigcFTpmvXrtV+FrS8U8U2kIilmRFLjP+O6g5UY7iSDU1m73uMbcV8Epf/86sxH8xSDPnVoq4qluZELHn1XgW8MnOxpBeSdX+qOHReuJNm2si2naxcZuoCiMGV84XfO5a6ZUYVy2rkZ1MMyEZ2FcuhelvF9E8iY+6MDZLjz/2LF75avU1Wek/jmUekvVy7yroilvQIUUM5dBi9etQdt3jwrDpzgZ8LIpay2/VL3zszeEQ6nyqW/NoYKV3F9QcYT8QCjCNiEbGIWGDQ5cuXa78AP5rdW7B1EbE0M2IJcYY/h5GFoQ1b0i0u8I+ZCWIq6TTQMCZrWfYYpt6htEZNd9/eaRSmiqXwTmUvJIpOqgzpZiPm+QeJbScbnou0st5CmXSL/n7p8V9++eW6RiGXZRQ4q7RL17zn0+KpbxF4jNqV5X8YTUqrRGWFz9l4/vk/0fwdaV2NwtItNudC+lj9cDHWhOwR4sGb87kgYpnw+CFyx7iOqrDVzKlR2M6bFXuDtbrKBBZCxAKMI2IRsYhYYPCEJK5Hqz72Ubi99957FnJdRCyNjViiAU5h9HDWvcLG/JUobbnwH370xhtvFKZ+3XVEcinU1SiseBX2kcfGxOd5m11zlZWpYrl+/XpaUWNEL+LMWmbyyH/YxSz06TlHVdPU229+8uc0dpx+EvP9ZBtamotlDRuFxcuPKGvwOvfplkY2HD807ci+zU8XMV2VWyGKa3WWaW9Z13T36RFefuUn8fJPnjyZRtLT5pOv2Sr9yEefL6wJ8Zm1wM8FEct05w4RbxSq06r0jpsiB71y5Yq3A2ZNxAKMI2IRsYhYYFD0aqh3mO/FF1/Mj4C4vqwiEUszI5ZYsSNKnNFc94P9WMZP+VBYPWKdiQvnC9d4LvX2WG+jsHk2NpmwZ465WMa8kFhpY9L4iuOn+T1ntsxvvPdu1FxWb0RWePAIhFKLsNktk6UQ3diGboDT3QoT3Q8d+U0iEqg+p072hN/82Vvp8VutVvOXefUqlvxCiM+ReMxY8injrOGTbme68izs7G4st7YW+LkgYpnwgKdwJ23dMzr+Gb9+vnb1ilMMmAMRCzCOiEXEImKBQbXP1B2X9luqNRKxNLaKJcS16rOb7nXXxxyasuR/EtMSRCexNO3EUg9G1FLFMueu8bvMJv3c818++tyuxUkahWXOnDkTRUcVI5BCIVHsXdO12HWlLP0WYa9ezm9rhbV3JSOWofuWrDyo+h4y3v1RZSuD30bvxFp6M2ZTai/RrrKWRmHZmnzx4sX+w/799aFB9XQRS6plyR4tSjAX9bkgYplaXMNRuEJrPlUsaUImYA5ELMA4IhYRi4gFCqKlxtRD9kMHB/MN6KmFiKXJEUtMej8+7Vj4LT2ZuFI4pigotGRZootA6xpKW4fbykQs165dy6+c3YnTX3hh1PT1DSlIiq+RKxSWSZQCrMabW0qUJtRSvdcvJdnJiQf3YIM/jM5yWRej6nNFxD+8ubW5LIu9roglfY3NeXA1zoeUdd0uXLiwwM8FEUthaxp/VBALKi4uGVVZO4vrS7L5V+KcRdkKzI2IBRhHxCJiEbFA4Qwqmt1XOTXNj1xkd+Lsa7ClAFMTsTS2UVj2BhUakRfeo9rnOqqyrGKQOupaYsPPv4rmz9ciYlHF0tlpTVPY1hrS8y3LMvMtwgpj02sVsXz/3NmKVUFpzo80IUqpHVT8p2yS9sG1ZYpb5NPLcjAzu4glOxqZxZB6Yd2ecGmLWOo9nhm/2OO/Rsu4mL5xcD2ZxU64cGgXFTPx16e+LsTJCExBxAKMI2IRsYhYoODy5csVJzYYnPg0OwVySlMLEUtjq1jSGh6n/XFx5dBORA1JAganoEijltHO6N6D+7sOVjZhDRGxrOd094OP320XNmIiosXmK+l+fKQObjVrGLF0S45ys2FPtzCzb3/88sVRe6RR30YNTf7gpOLgeyRnURmzFIc0M41Y8m9r7RtdPHI8fqmPHhFL7cczQ3+eXP7Pr8aGMCpZmcVOOHvMMXuAqV8XsCsRCzCOiEXEImKBwllHDP3Ucmqa3b724vFOmYYD7ErE0uRGYWn1juZ4hbixOV2MhjZWym4xqhWXexdmG25gFZqIZZ2nuy8O8r7wQioOyxcoNCHIHDVpx5pELPndRcS3U8+ZlL2t2T/PdlCl9kipvjBfyFLlapK/vLwcHVBnGrF0eqXPs/hoS+/7YJO9+XwuiFjGH7HHdSSjpp1LRbq1fy7nHyo/ub0zC5gnEQswjohFxCJigcIpShr6qTLuUBgQyY8xOQWqhYilyRFLJrpn5DvbxP380ENz5ooYOllx3I9OODGO2Z5swGX+RCzrORfL0DUw2oUNtuZb+Pb1L1746q1bt4Y+4TWsYokiuZRtTPEaC4O2sWuabqd05cqVulbFrFlZ849qZh2xdGqNUQf/dGwsk7/LIpY5iP1wVrwypn5lRlUscYtN7969e6POYkqd8ng3oRQRCzCOiEXEImKBwslGNF2pPkSVP78adRkvUxOxNLxRWP+j9v79b5w8MbRB+WIbGeXHQfJp6NCfn//RhVFjGYslYlHFkpfahTUhX8k2pajbGDWKt24Ry7Xrb0/9UTVYDljlJaeuVrWsIfEgP3/7WvMX/hwilljJT//xt2c0m1GplVzEMouDmfxPooJkSDnskefGlMnO4uglDq4mec5jXpraepiCiAUYR8QiYhGxQMG3vvWtqa+1Hxz0H3VC7pSmChHLUlSxdHopy4kT3ZTly1/5ncHpBBpSxTK43ApddGJQMkZVmra5iljWc7r7UT3rYltLF1Y3JGWJLjpjlsk6RCz5ccxU0lexQDbdyU90XxgqneSgIqZwqLhu5J9MvK61rWIZvwHW2xgq3vT8pCxz+FwQsQzdos+dO1csfj36fBwuxNfsJ+n4YRafy4WLQr5/7uwUJxeD//Xq1aveXJiQiAUYR8QiYhGxQMG3v/3tikPAhX87KmJhaiKWhlexjKplaVS4Mupq06FLL5Wj3dzabM4aImJZwyqWUY3CktQurAlz3cdY89btW2OWyVpVsWxublbMV4bOgFLqivVM7MRq+ejMHiEmpWj48p9dFUth2aZapdqrwdLXKFOb5JxTxDI7ka8cPXo0P3Nbql/ppywj5nib0dFLup8qBSu+qFSt6/2FSYhYgHFELCIWEQsUxOSidU10P76KhamJWJaliqX/mXv/fmxWYxpoPDZg0dRh+jRwHKPYo8bX5kzEolHYoKzR5a6fTTUOARcu645RyMuXL4/fTNYqYvnhhfN1baSxC5qwmmGMKD2pcZx3cHC2aXUtc2gUlr3wixcvFpfSzhB89UUd4+nt3ZaziKWiUWtvTIA0uw/ZKo+cjkkGr26Z5HVF/Ur2OFdev6q2HnYlYgHGEbGIWEQsUBy+P3Wq+tWm+ZuIpf73SMSyVBFLfpxxcEx2DjPE1jgCEm06LlxoxJCiiEXEMujBgweFbkWPko/nn5vFRjH4uuIzdNdNY30ilsI7UnE1GJzofooR5LfeeqvKfqOw2xmV+jRnuHY+EUs2xp2OT/KzdHS7SEXKUiHIzNpD3Xjv3fyfa7VaM/pcUMWSX87nz5/PvwuzqKad+pGPHTt248aNCbe4/O+88cYbhb979aevN3MThuYQsQDjiFhELCIWKJxRpMvtaxx+ErHUTsSyjBFLp9fI6Ktf/Wo21Ft44xpbxTK4PKMHenvR44kiFhHLqK1s16ZD9c4NkP8TMXHRYOeowa1jTSKWeOFXrlxJS6lKxJW9fe+8e6P6riYe4WsvHp96f1tYkeJOvMZOySlh5v9hOocqlv45Zm9SluLinaqKJZsXMHu0bFKWUQtZxFLv9htfo7yj9nylcGiRPyiqpbitsHoMri2RyqS1tPBk4sXm/4mUBQpELMA4IhYRi4gFisP3p05VvLozP92liGUm75GIZTkjljT89P3vfz81NM8PJDU8JyisY/GEY4KZuD69MH4xz/EIEYuIZeggWtwZ7AQ165Uke+QJZwpZnyqWFGbUUsIS+5xahoxDdHKb+mnkJ9xOX2Pcf9SQbhOGaGcdsQy+9vxfrCXqKAT8c/hcELEkUTaUfejPooplaK/FKQ5OYudw7969wU0vv3Jm9+M3IwsvbMvZnZ+/fa0jXIERRCzAOCIWEYuIBQqyKpapL/BM16tmZyyRB1iq9RKxLGPEkj9jj1eXTXpUuH6zgVHB0EGQ+Hr27NnFDtyLWEQsQ7eydB397GZhGbW3Of3H3x416Fx4nusQscSrvn79ei0twrILzKtcWp7/V7GGVKxiKXwbM7039oBhDlUsg+/Ij1++WHGOsfzhTb5dWLdsaKfUYPBPi1hq3H5jM/n941+rKyIddb5Qyyd4/POYuH7XDT9t+ydPnswf0qT0KPtJpC+p8xgwSMQCjCNiEbGIWKBwHhJnKVOP2g+9Kk3EUjsRy/JWseTFqFzhrWxsxDJ00CoNauQHPVWxiFiGvlPziVjyq1++XVi2Atfe6ya/7h37l7938+bN8ePOmTWpYvnTl75b1wKPcc98L6DqKUvsu6qMvxc+ZaJwqjPikvmGfJjOKGIZnA2lcKAy9efaqM+d1Bjq3XffHbq0RSxVNorO41UgZ/7t94rL5Mhzszu0qFg9H7fYr+76MuPSkMG+ZN3pgnLPJPY2sYI514BBIhZgHBGLiEXEAsXhsIsXKw7ZF06ZooeGpVovEctqRCzZK82Goho7HcvgUs0W7NWrVxc1cC9iEbEURtDyw4X5dmEzWj3yD5u1CBszfJlZh4jl5tZmNpdGxcHuuP3wwvldl2opUWEzXeQ2+E/Sy8zPwbNWjcJGrfbRSbIw3UX1GdGzj55oDFWYfqPez4U1r2KJd/CNt9587JgkwpUjz8W6PuvpWKZo3Jf/9rWrVwY3wywIPH/+fHGtTi/qyHNDYzynG1AgYgHGEbGIWEQsMGrop66ZYOOrpVovEcuSRixjhttiODLGELPuRs3MVwrXnP7OzvWem5ubCxm4F7GIWMa496DfLqyW/eT4D7vYJ7fKHA6vQ8QSO7RRhwRTLOrNW1u1P8O4/qP6KpE9QozeTrKrX9SH6TwjlmwhpE5xtUzEMngVQn6B1/65sM4RS7xxEY+lrePRAqw7YonHj5xssPC9ellMPhpp96Q7cTlITINXXDd2XtdgnleonAM6IhZgPBGLiEXEAgVxElL7Zb+D14KZSbKKQv+NqYcSGjuIkB+aqWVgaIlyvitXrrz00kvPPffcmL7/gxnS0G5js04gsr/4rdOn5r+gqg+lFf55lWkD6rntXE5b+xu3nhFL+jirsoccX8KV/3nZ3v2rGrHkP9kLFQxV9uSp3Wjthw3Z0U4tt3i9zTzIWVTE0l/VX/nJqL9efZOMSov240s7zQFT1+OvbRXLFDuooccqQ1eh48ePp+LXuDgjTTtffc6e/J3YEgcT2TgNmeRPFHbvo4qlYG2JWIBxRCwiFhELFEYEKl51OPQWZ1Pzn6phhcWI9qhx9pUZRLh27VrFfCW1j0h3GtutbtQWce/evddffz3rdDRq8GLXO2NGPeq9ij/erzkvulquVp7p8pkiYilcJlzX81nbiKXTC6Srt77MT7U9+O6MmQCgxhHMhkcshYkxUriV7YQrrgBjpjev8lSjzimN8Na1P8w3KWqOBUYsaVFndbdjLguYbgKPePuiADS/ShQ+F0QsU2waESocO3as4toyWDuY3q/UUDF7y95590b1SCzfkDDd8tFI/K3IV/IVjRNOsPTlr/xOfD1x4rGHcgLCmhOxAOOIWEQsIhYonDbEZWW1X/Ye88p2GtadfKkNziI73ZuVBg0Lg+MLf3fSE4ihjerdRbKB0YWUWZQdlBz+eX3/fgwvRtaSBgjy/crzQxiD47+7xi31Bi2nT5+e/8B9vVUsC09ZZld7tM4RS8yQEeN6FSe6j38+uOlllzlPsUxWsoolfyFFagE0ftLyEq/x769fu/52fFTFi42rQOLrte6XctI/z+53H/D62/kP0+q3E39wsoEfNHOOWAanT09R1mDVYPVB/Ngw0zLP1r1UxVJX4dp6VrGkPfZ0UUe2px08/IjDmKEVIbUUkw3O1nPmzJn+QdSvHsRKsuv6kP+3hZcQ/1wtCyQiFmAcEYuIRcQCgyfGtY8zfu3F4xZvjSIwqKWjUTofvnjx4q4D/fOXqlhqGRJqbMQyfmSqMzCDdwz3RPf5kydPjo9Phl5A+tzvPj+7QpaFDPXWUsWSXf06NKNqwsw3GoVVfyGXL1+u5ZL2oW3lsjaYpXaeq90oLKKLwqhljXOe19XzbUZz8/z87WudtZ+LZfDl5ydXq2V/mz1I3I9Zfwb3NuZime7YI7KEQou/qQtK8g+SildG/d04sJl6RzH04zLdOfuDczFFVjbjyyRBe/qFeBWFh8qOIV0ixpoTsQDjiFhELCIWGDTJBV9Tz1WrY1h1qfVNXb3C8l1uGvK+xNPIRoVqac+dWvkvxQDHmP/0qL/NvXtx4WcMH0QDtPxSGjq6Mev6jOxhs4tG5zZwX0sVS4MahY2urRGxVHkhseGkYoUUKld/U7L+V3HJ/IQbcsFqT3f//XNnR81eU1fKUvHRspqk2jf52C037e1Y4HT3+Y0iks5R5QLTPaX8512kep1cFYu5WKY+/Jg6kB4acsTXCGxuvPfuqCr27NvvnnmpyvHe0Cmy0uU1pdaHURevxJ0ox3f+AiIWYBwRi4hFxAJDx0dqH3q49OplC7YuaS6WuoaupphIYA7eeOONivlK1kik4RHL+NP1Xf9r9EHqxi1nzw7thjR45eaMpmNJd+bZTKOWKpasAVTkyjFIF1egR0uitxcqnkM8kxpLWEQsnV67sF178U8+1336SaErlCqWJC6nGFWGVUteXn1ofsLr2ae+xcrWqHdkIRHL0MHoiOGr964c2g8zPv7Sp0++ikXEMsVxSBSdV6kmKby5UUESO4Rd85VOr3om9qi1NPzM10hNsdPI195lj5MeMw60nICw5kQswDgiFhGLiAUGRRxS+6BDnDu1XfxVkzQLel1DV2mmnKad6qchyCqXNA5t8rAswxyjfj50qCK7Hz2LYoApa4tR10QIu07nk41XRtgzz4H7Gl9a00K4eiMxEUtn5yL6io1o8jMN3LhxI219U0wztsJzsYx6uytOv1FjTlxvfjm4quRDiCYc8ywwYhkcRi9UXlb/iC/MB5bNI6JR2BQHHu+8807FXCq/t4zD/piGZ/LjnJgJ8tixYxXXh3x6WrZQtTDhVqGpYPo2LkFzDsI6E7EA44hYRCwiFhiUGqnXPgCR9QqjxsHlij0x4pTy1KlTnSa1CEtfY4aYWhrup1uEUks0zDHF7+cvGW73LiSPoDRFcUMnnZ5RV6t59gqrpVFYdktbQXPUm4qJWJKs/q/Kep4faB6adE5ihediySY2r7e1V/UHrKuqZtTtyzuPGfVSnSZdULLYRmGFb6Nn1NDZwmp4bkeOxGFDNAoTsUzt/I8uVM+90tfYCt5598aoK6tGbR35OXuq7B+qT7k0eMiUhTeR1rtcjLUlYgHGEbGIWFY+YmmnN6jd/6bd3p7mPWPVDZ4t1NhFPXuQ1LZ+ec9MmvPMs+s0KzapT//kxf/r6w1c2qmjSF3rXoy8rOemHS1rYjjgxIkTjy2WI89FtlbLIH66rj+79jNGVdpz3ApWvorFdPc1vpDUVS+ukh7VuH/k7chz2SaTfj8KxSoukxWLWLIPx6hja8icRoudS+nqT19vzs5kURHLKKlOenAQvFAoNt1nfTb3hohlihPGVAJbsaFiunP9+vXpnsaVK1cee8C07z3y3MK36+wF/vDCeaeNrC0RCzCOiEXEsvpVLP2MpdX7Jr62Wo++hSFDJEmaHHhwjC9fR1/21h1+Ld9QpZnLZ7EKg8v5GZinOyV+8OBB015jnOrXMkSSvjZzvpl5iutJYx7mUb3Lq/ReL0wcPbdiNRGLiGWa4d1Ll4Ze8jzu6e2M8WW/E1fiV3waq1rFUn2/vezhSlqXqodwNWpUxJIOM/IVlnVNtFPLdSfrPN39/V89qN5GL/3Dn/zkJ1WeUkx5ko4runnb0ecXHrHk16jUKEwVC2tLxAKMI2IRsaxDFUuveKXdzt6ptiIWdj/d+svLl4ZO+VjxFD0uTyuc1C31GemiZLNh19VqIz+OsPBXl+Y2yE9WX31UaJ5zhDRZXMUfU+8U4tLqEyTkV8I33npzPq9FxCJiKbXHzvZs8V4X5mPfZVfTC1eyf5LKMStayYglnsmsZ5JfipRl8FN14e9Lo6pYOjuTsoyasKeuVajK46xhFct/efONWo4nv/bi8XTVThWpqeOjDWqniHCxm3bTjhNg/kQswDgiFhHLOlSxbOffqraIhYnEvNlDmxpXPEWJk+rBAa/l0oSnnSbLqX7h5+CgYUPelLf//no24llLH+2pe1asntQuqTh+US3Nyi/qWgagJyFiEbFMvsfO79li/Y+SylKfbtlYbUzgXMsyWcmIJerk0oKa0WTyS5SvxO3cv/tBQ96XpkUsaWNMB5lD45C6Un9VLKXekXhn02FAlflLul3yKl/REs8nQrjY2TYhr82WRpSmxbNSv8KaE7EA44hYRCzrMxdLu/Mw+oM5NGTXs6zMiy++mJ1gpAveK56ip1tq2bSMq2JznvO9B/cHh5WrTPfdkPHlbAlnk81MvcqlkYKsUGNzc3OdN+rsa/7bQkP8Ktt1fhxkbm3KRSwiluk2hBATFE13AcGNGzdqWSarF7HE4OMs5pBfulv+YKn6tfy1aGAVS9oY02fQqILIKseZ1fefa1jF8qcvfbf6h2mUsNR1qBw72xd+71hD9irxuqKRmpNoELEA44hYRCzrELG0unUsrax4xQEiE45GnT9/fuiEDRVPWePy4Xv37i31kukselNq90ZgB2eLnXq68vj6y/v3GrJ/aOca+lcf/U/313m/V3jt+fmQrrx+tZaIIt9zLOpj5vO6RCwilql31/FtYb6xXZ9e/EKN1wesXsSS5eJrG7QU6vlqTCMqambEkuQnZal4ychgYqqKpZRU21pxE4gThxqPWFLvwYVv2pH0xGx2hUtVYD2JWIBxRCwilrWY7r6Xr3Q6D9v9lMVc94w7t8nOIqKNQ5zbfPkrv1M47526WiK7/9JLL63YsPW8/3rvZLh6G7d80/OrP329IQs25kuvZXAk+xpjqSKWUcPN5390ocYhrXlmFSIWEUupfXXhTlS2pUukJ1x/omvN4ENNbcUillggcZW3Epas42JaDt0r+huwM2lOxDL4MRTFT/k1p+LOPP/PI/g3F0uptyZfMjJ149kal1haQ167emWxjQdTvtKEI39oAhELMI6IRcSyBlUsrfQG3fvD0513/ns3aLHls9upbyZfTFDLNJj9U9+jR998880lWjhXrlxp1pvV63pfyzQ58x8Z31U0D6k+zpL/t98/d9bWPfJ44P79GEGYOl8pNNCfZ9M5EYuIpeK28JeXL02ynNN/rXeUbcUilph9oTDGvbZVLIUP5agUXPi709gqlrQpxZY1uCevMrdcLaVUa1jFUsvyn8VBSxzuLnB/8sZbbzakfh2aQMQCjCNiEbGsfhVLV7ds5e7n/umtT/zGR6/8RfaT+NrtIfaotKXlsJHBwe78wEH1cfzsTrQLi2KFUmPBix0fjHO8wWqABYoRusEebhUbasU70n91AzuDmb7qwunr8a+/ONh0pcr6FvMuLPbNihcVTfmz+WAGT9cXu1JFZ4+6aobiplFYLUQs83khqV3Y+Hwlm0Ks3h34skcsj2p6Hq+qXM98ZbBat9A4cYE7+SY3Cusfal66VONM9XW9m+sWseSnVZvuuCtNxDKLVf3UqVOjzibqfccf+3rkSITHzgQhT8QCjCNiEbGsQxVLunP7s1+IR9jae+jD499I79nOG9fq/5r+YQyIadUjCykM4k93YpOfAzbdokQmrqBf4Kj3mP+UDXzHJajpOceZ5w9+8IPxzf3nNowSf+X69evVTzIL72wTqj2ivKn61dCFk/AFjpJkvVC+8Y1vHDt2LJ7JqDVk/llLtp7/7Gc/y8+nUjGoU8VS12iXiGVGLyS/lW1tbWXtcbLhxcI4Y3xU1b5Mlj1iye+vogohNWWqfpywAinL4Nfoudo/2m4t5ji7+RFL+O6Zl2qZ9F7EUuVDp+IFVfkLLGo8mEkXqUR+k7WAm13Kkt/5L/zqHGggEQswjohFxLIWVSy9d+iD3/7irb3PbO47EA91+9nPdO582Gl/vPMbrf6hsDIWBmQNqerqSZU/fzt37rHSkPlf5jn4F/P5Sr5/Rbo1qpalromF82eVMeC4wIUfTp48mV9V0rBdxZmH55xbDO6A0+BRejLRm6iwwtc4wUPZJ5nuXLt2rWIVVH6jVsVS49YtYpnDC8m3Cxs6phxD5LVXni1pxDL0IoPUxudRI9Dnn1vbGVmGrkLZcc6c9/OZpYhY4kKEVMDaqLdyDSOWKkeVcUnWjI5Swo0bN6ZuajrFux+brRNAGCRiAcYRsYhY1qRRWMx3f+dzX7y5sf/23u6q3i1nefLTH135aXr/2ulr9/9UslAU3Y0KM7jWMg6b/TBGZxb10sYXstx4791sMuT88x/6hBcySh7XVtc1vjy0y9NMR4WGPmBcM1jIV6rPwb7YPi3xJ3944XyhO3wkLoX6rcWGi3F/6uU8eNHx6T/+9twG7kUsIpZaNoTYS+QXeH7PE09+FtcBrEDEkr6NXdnadgYbP9d6/odxDf4CP4aWImIJkWU2ZyKf9YlYsnUyX7M+9UKb6VPNVznXXi2XL2E8e/Zsx7QrMIyIBRhHxCJiWaO5WD77xdv7Dm1uHI5eYd1Cln0Ht/YefPCH3/n/2XvfJzmO887z3zAGwL5cEwMOSL+xRMe9uQjJey93Zfku4iJ2bWn3XkgakNqwAO2GRUBvToA3LBOk7A1hwLizAChiZc7QvjtiuHG7muFGHDGA5I3FjEhLA/hemAP4wpwZ/BA5GJGY7r5vVXYncqqqe7ors351f76RahWa01WVWVlVmc8nn+dpmyws7fYefAX1keJH+XuxZPIVU9zFYjVxZFEYLhs9JmFf0ATMzL4qnxLPv7ng71dk5pPudVFuz3KuhRuz25jq/uDUN4KnvX1r8VqFV+r6jZV0RbTxzW9+U74jVU3gE8ZiuS7lpllphooXSxCBWMqsiNJQGfNioi/1CxHmf+eOTS4Wexv2Szk+sZRlAJYo+cnfFMTSifP/eS7oAbHkvp3dxFS5x11uNFSffp65xEcb6iHFRSM0ey4iMiRCYyMQC0JokEAsIJZJQCztuMTNPh2XZ01SFn3KqeWjL3xp75eP9Gd70d9CWVCGZIENHqDcmnTNYk8bgKvC6aXdVn7LpDPEyZfcAM12jVun0mVustH7m7TSxiCZGhUhLT2zLbrx7fTeBgfzjF5liq1L+d1JjlD9Qg+Zz4WFBePOUi1ZlE3Ex5SfcGS5eGmuNMM9iAXE4tn57T9luUtTZ7H2zD/2VxMRS7ru8pBWgoRM18NJzsWSrr5a6cDGLE71Ryxua+gNghdLyTJZgjwRi/nV/Px8qP6Quf6ps3/VV3AvlnN/dL7CJJEI1V8gFoTQIIFYQCzjn+4+Go8+0fj54Rd+vxsibOr4Ztzht488tz11LNr/9Gf33v1pF8UglDX1MlMafy+WRFZhNwSZJjY7OzuV1NGdzsmlJiP3zOyLoiz6dK1IMgRUZR+3Eg5xgYRn2hJbdC0+frxTQr3sIeycOeFO4RkrzBi2KrlAirBnA831W9+tbZ3h+p3bldjdrEx8tlAYtTS3IRALiCWISddKzz333SQ3weLaZDzS3a/cvJHmKxOLWFzYbAc29suVlZWqbsAGebF04qQs3zrzMl4s5Uvvbp80eOa3Z8+eDTKYGUBZbvzkpqffbb/z14gavoLQYIFYEEKDBGIBsUyIF0vU7F/85wIq6ucKF/bw0HHlvY//Ge//0HFt7Hz3TyEsqN8kZ/vBfU+jSb9YIu73ip5UYcwTxQE/d+5cOqCZQSzdsr8u+vtq52OhVvOlr45CJZRTNbV8Zi08l1KaT+VBqeS6qOlkru3n55H+FNgruSO5lgvT7UMt3Fby8NIM9yAWEEtAGbczc57KvL2z+3hIq18OjUGgsI6z7D3RUSfWhSW9EsV++eqrlT1hmoVYJPme4sVSvlximv8WmJ1VxpRQo5S0I7UG6v45Y/qdfGk+uAg1VyAWhMbW6teOM3jH/2o5n6MJxAJimYxcLE+b3e5QiEWfHx6N+Eo3btjh5z/+3f+59eij7t3U1o22F2dq6bS7Di6t6J/xdrvT+0QT89S1JqF+Zk3/WFWm/MX8G+VzC2MEzFEsinBng6WZyDWVjdYbFmDPMgGp00bGUc33B4Yasw5S/rPltHlLs/FKbhZN1Ie0j7vx2dQJh+z5AXuaj/Utk4q5TjlF37MgFhBLWOk1JxPhyZMnFYax6AM1HbEogY0niqg5lbHoKJRrjlwbK7lSNUcsma8z+VYmH+/7V7qAWIJfBTFm/05uc5m4QDpIyFnNP3WGiSyJwa+4ohb3658lD/IRqqdALAiNq1oOU2nljm8EYgGxTCxiURaWKGLY4eMPD8+IsmwfnTGUZevXP/tk5aa9su0uR+lCl71Op4c24w2GmpMkRfEyUdcT+VR8l7xlGS8UakAJUQ6ckh0428m09SckSqEFyz5W5vPnn8Zu7hc8uriJmUzzxZmotPN+JoZ+bZueV6dn12ZDjabU6OngYJ5RzmxT6LKWMx9O1EvxhQYE5c80XdkW0C2mlaTDGCbyVS3xK10C3WuhYuOYjdL4KIgFxFKELl68eO3aNX+D4GA1F7HYNpEt0j9dVp39Xez4RM9nJY3zqay13paT3iyhJiKWTnr5RcxXopCtIJbCZMaT/nelUlv1u7IHLsHp9yvxFXt6RTxA7K7s7KPkwTxCjRCIBaExlFlZ34pfcE8iC3Cr3cnJWEAsIJaJRSziK6bPf3g4ihLWoyzmy+ndP37NkpXumNIglRi5dB1aOq0nMJZJeeq2LY0YHPUolKnFWJxl9LQBBwbPag7EMJkTOcVG7xfnZNSTLy2sVrpqCYN+EVYGHSJKzTLQ0N/PcpQ9he50FE4qEe3BP7N9gtiVE7EqUV9Nzkeqkfkb2e/ce0qgRRaKfnGKgkzytYfd3V0Tzcw/1/2ArM4gFhBLsxBLOQa1RnuxmKfHH5z6hr/3m/1UbKgaDn7MspJQHpZ65andyl8L36BAYW7LmHibiQEnXiyFytOr2I7B1NWND3HmUzTHiF17c5PbFZTwyaZQun5jpfyXAkKNEIgFoTGVoSrtvchOY2ALiGWUo4NYQCz63Izhij63js4YyhJ/eez+oeifH31ptvPwo30Bwdo9z5W2s40mTDYCUtpA7DOP1R7SmXLNP+WLsLS0dCDAGN6jZXt7WzEotNt0GBCfBaqyBdiIYUXYxPtVSrFHgs820/FbNLlVKlRjHurk9bEwX968eTPtNhTEHcr9p7qTLscwbkwBrUI2zkbuADhub5SRQquetc/OEKtBR70dZLAQF/SM0pP2QFJSmTIN9yAWEEtD1XQvFgHsIOmy7BqFelot3cvk48Vin5NmdX8HL5b+lmu3ZTIN6yCW4mTXiPgsOTLbwpPpcftIg0bbH35xe93tBsVFF7QV1+HM0Ct9bvAVNOECsSA0tmo//b9W7ncdiAXEMsmIxezWhAvbPPKsjRimf374j6a3Dp948Juf++T9n/eub8te7Fbn046H9xhq3vN2/7pCGy4sM6dr7tl7gtMYk4TlLirfn7sov5Mc0czN+W9sbMi6ochUaUcczyV79udKG16aL4t7US5cuFBc5l63iYzRf/VnazlOWO0vbxh1njRF858tpyPmazFmp3is4u5fmQls0LYhb4p0U2QGPZP9UV13c3urXwfot1A00y4gTmbshkFyDCQuX78IGwUZ7kEsIJain64l2O4b59kjeUbXtMih/OfGSNKCjAH5Y0Z6PZkq6w2IF8uAfpVuGfkTVBJTbgIRixpfI1h/r1b7aYfE/Tr8MEuj7Iu+hACD7mBMlKWSZH4I1VwgFoTGcggQJYQwcMWkhdjLuycQC4hlwhGLMrLYI0Zk5eiz96eObR19TnlZ4r85pi8/mbvsgszegNjNh4QmS5nTdR9TiwtX0oYM8weuj4uMFHKm0bxLGYnTE2DTRZU5Rv9Jccbefvttxda3MakGp5EY+fxPvpQwFdm8LCXYUOwh7ty5E3zOmYAf6Z3LJC0roVpYR888q9ux9Ddqf5uhNJMl+PO59E5kGivOhSi9QwX1MkG3MnnPqD5DCcOc/eeZM2cWFhZu3bql2g1ZL5e+6GKJkLnB1ve5oeQNwOK2f5nh8kAsIJZyHrBFqNGBwv7b6q2AdFZvh/LDbA6vy5cvB+m6trlura3WYcxWt0BhA243N+tPaaBlMr1YOnEyqiBLjrp396lTWl6TOSA58NJrnGNj+WZOOgJ3htnkTEQg2cZrrSSLEkI1FIgFobFUNwFE69FHH//Ol01GbgKFgVhALCMhFsNU3I04EUv3Rtg6Mq2yOfWc+ebRv3yp8+hjc6OZOy4eI+/xMJocJSYVihmVnvbknu24rirpqVS/bxIRihJOMNZ2nEAgA/hKnvPXb178+le/tu/MbV6WQmdiCQcFTUSLMD2kL4rbXO4l6HeZ7LUYnJo+lAHInJIJV1X0TNg1FrgB9IavSD+OlaBQmTeaSIku+hsL8zJ43e5JtgxzPh988IHQl75RTDwZc93ukbHbEGmEtR+ZZko23INYQCwNVaMRy6vfe81zaYX7TxnQ6zzsUfP6RxN1a61HDV4s/Ro8s2USSVlALIX2eZ8lO/2G0+oz6dxyA8a08rXVLCNzAB8qDWTmeF6jIDMQsofWeN4GyEUIgVgQGmvM8t7PH/76C8rLHRGXTs5oYSAWEMsEI5YT9p8q4ivyaBFWiYjLEePd0vsDRQybevbhZz7/5L33zc3XCxHWYsg5sZSl3Scpi6fpYQBcSR/IzRCe6Y8y+OeDjT7De7F0Z2X7j1JOxDD3ihgbShEBEwbMaTMXFeYDWp5RwtxtsQfj5NGvrYJfgvn5+QNdUoYPtzUANA74+wFUJjPmW3LxpjdisdF+SjNGgFhALGU+Y0EsRm7srCDwfkC6qZoMe2x8S59AYe43OeKdjjFiyUzCkfhSIZsyfZFBLEXIjQYcajwvjxAlcBKuGHz19XgRXDG+tgm+kjnCCZmDMB7PR2OhBBO9cIEJIEIgFoSaZbfLMNLv/6Jl/qYXH6yze+nP7089v31Ui+5PdP8gl0AsIJZJ9mIZsZz48PDMp5d+YOY9yTt0f28AvUyCzLrCfuk00nmwx7LYKVnaDPHqq2VbbOfm5orwTqh1cSpYwhrbTK3cvFFJMt5a9H+n1jLKlG+4B7GAWBqqpiCWtPlbaa7S4RBzPzfqdt9lSqbhIOsAEqnCEo1cHGRqihfLYNlM7JlLN4rIfD6xiEVN3W9ZRu773V4pLc9Sbrn1O7fNXFImHuWxU0J7kRW5jBRxEfsRoOHLgNx+OLggEAtCqHkApt22IKbVefTwl1/+2uaR55UlYnvq2IMjMzF3yRmwCMQCYgGxDFuOHIsoy6Fnd750svPokQ3Q17v6rej2bLXbnWxoisZSyr+dyO/tBuwqYpVZ3cpX4wqbjCyJeZ3yXpR8ObQw1l6OLuJyCNC4Iq5uHXs97VtnXi4zrL+W1g4T42u8KYspso+AWEAsIJaxQSyZpkMlOXMTa/nHCqttonu3BVRrN3mVf4YztaH22Um5axRkrm06YrHNophymfn8CoqSOlGIJdH35HQyIAysf/Sw9Hqs4JOFsC4vb731FkwFIRALQk1Xq92jK9oQRdn72c8f/OZvK2aRghptRqGNlJH7RLtn3wWxgFhALMUhljhTywlBTaHNh5/5J3vv3+45r7S6N6ntDe1Obscy1DiZ6A2ZgYkKWlpYOy+WrCmoazYqOiOLu38l3kjbvsfci2X/zFlhxEuzRyiihRu6pJ8FYez5iuwjbsJqAoWBWEAsY4BYErez2Ui8Yjytn3pu1N/obD61jD23NT/9mNJ+lv/LO4m2xYvlwMuhfB5ydMh0sMCLJaysz5CbS88fqSbSq4RK6DjMKMU/oPG7K9ehLAiBWBBqsiKj7ZPYdSVyJN2du/xg6oTycguxGMpijMURXWnnXDQPYgGxgFhGKdObJmvLkZn7z7zw+Ef/R2/flrUYRxZytEzSc7rdFmWRoSRM9vjGLuF/6sRz8uTKyko/K1URlq/EtgKUTY4jha2amT8r93uZU1/lltdKz7TRbXJcWGw1//PSjwvt7SAWEAuIpbQ2SZj+XemJ55/GzN6wCwsLTTFZhqUUKiayYmYaEhDLgD6pzD12wFnogoYJ92KR9E60CVGCDOz7pVQp6CJmLn/xPP9ba6sdhEAsCKHGEhZrG46Cgynn9v1Dx+9PHVNGbmMmfjQVI5Z9Rl4QC4gFxFIUYjH3oCiLPh8ckVPLsx9//eXWo49MpL529zZ8AmGZKL5iNj64u+FGDOuX83yMTfx2W0v/Soj7MWC3rmvFRIEuLW5NZ1Ituv9rUa2bkSjd2mPuxRXXTi1fiZEUxAJiAbGU2SZKn5BYW2DjguZ7aOttVfS7MqD0qA/4StV+SrtwjUYs6Y6RTsqCF0uQRk40tRaRuF4gocKFDcYtRQ+Z8iFhN8SfmoXZHwKxIIQaabMzBtvW+3/z4Dc/J/4h/xVZeMVXomhFUye0vTk1o9X0rdw+LCAWEAuIZSQXlqPT8Q0YsZbNw8c2Dz8Tff/bv7P33vvdbhAnLtzDh3oiJcpiQ7S7c5jxTnqfMKxnhpUvOgZIWmtraxPiS+EGqpK1rvwnj46oAFlugPiS7QV1KFpWPNgiBmIBsYBYGodY0msFlKc6SPprU1577bWmjBXNeWZa9nOYmO2gSO3ZPggngFgyr8WVK1fsKYnzFTHOnDTEYkeqbie0jynP5nU5TTnxwdJLvvIfqBeQ1nxqtCnf/X73LPNfBGJBCNXzVd9NrrL7v12O3FZ68KObheXwcfPPh4eVi2XaEJY2uVhALCCWIhHLVpz9aCsGnB9OPWO8WARaIujyzGc++Q9/aQKFtc34khHmBMzH0l9qbVciL8t48xV3znb69L5JVwkTrQS5cSfG2rAR83OvMm4WZVlfX6/2jlh6Z9mmQZ6Q+GCmyARTlX0BxAJiAbGUFihMDDvTSzX3qnATUbP+Fkl7hqLprrdu7mKQgNneur9dQhWai1j62a91LYz/KF4sBY3nrV559UK/uLhBIncl1mMVNHzyoixCLKb09iDP3ce/2oWmIBALQqi+PCWpVvvTjx8//vofRkDl6HScansmzrbdZSEmEYtYixxZzA8IFAZiAbEUiliMI0sUKGxqRndldA9Gt4xCh82YHX700rf2Hm2rN+zl6BOo4XMzO9OQvUBzj8z8rmPMVxRUPcFXymz2ftM8LfOcBEcK1e76jZU63AJy5lBP6JffeCyLEv9Ua7gHsYBYQCzFtYn7cpmfn88MhJjvsppMJMNYeGs11HEdFvOloEg8sqL8YcU3QkMRy4CcQJ1UfFpysRQ0wlQ0VBN71rP/DIY04o5FjJTkceIGzs25n9kXdX7Rp7MHE5kWyoJALAihatXqZWvoxhTqZrLv/dfoD+KkDns/+/mjz//ukMDD54RALCAWEEuIU50Wd9HGo8/9T0/ef6/bJ6K899a9rHvvMxSdBGl1ocJfDFg7VucAVulE8d3teAlbNMva/zdKbi8rs6pcZ3tQOmGMmS7aRXkN4Fhx49v2f/o5uy84W+XT3Sho2OXL0Wll9qLaJ2jJjHLW71OLiKs1MYBYQCwglhLaxCSdsoFAfazz9vtqg03ltvXLVVe1+Eqo1fGxCVhtW/QrbJwChbnS6opMcBXkVTvJiCXR+bV8xLZzIodKHRL+dflHanx46tSpe/fu/eL2+jBpFHPUQjMdZnwIxIIQqvYtbUDKXu+dHQf4ssSlx10Ucej+9GdNygcQC4gFxFJ7xDJ9/9eeV9S+7ZiybP/6b/7qR28akmpu9pi0xPRUG3s8BydlSpa2qSkIgAlaVefoYWmzeHejFyggMcm0UZJquJYtverWnvlX40WD9UQsmQseu3ylt4rQTX6TWOhahwuxurpqI+ZlxgG390I9EeMA26gbjlw8qdrWBrGAWEAsBbVJ4tZeuXnD85GeuPqb21tFc4WCFNBP1wRTVdsW3QLjilikH1y5nDg9N2IniCXIc6Ddo1kDFktVOKq3a4ZsdGKTn0/O5eb8l5aW0sMbW2yHyVE0wGbGh0AsCKEKCUucp6GbquFTJ0u9fFli55VfPvr463/44eHnhjdAg1hALCCWqhHLiRiInlD0sMid5YhyJp345de/FfOVlttD9szNjiZjSmZm9TZuUlO8WPpFi45M/PtjfWj+pgpmWkYqNBhlHlqTwHSlollljb1YkmsM96cbNYt/ZZlKGgJqY6rb2dkx+XgPxBU1bPbBAdP1jQCSVnP363WkuwexgFiajlgS0qs83+XLfKQ0a/V34oGWSHr/9H2a95FrY6YV9+QcY8TiJmWx5vJQAAzE4vZMjbjcbp9o6irHM/tDeJnxuTtEiYbBly+n4/W5uZHy5ZTSp/LwDY5ohxCIBSFUIGN5+u7pubCYyGCR5fX9v3n4uS8+OPJcL7H2cRALiAXEUn/EEt+qunemhVge/tqMErRE5cizH33ud/f+7u/bNjhYm6HnJFIWzX7n5uYy17vVlq8kUm5mBp24dOmSbOj1ISuJ03DPpDs3XlmpOdkaJjGp7TwJE3/dOr/lPbLOaMlzIoxJnXO06JRsKubMkCAmBHlNIuOBWEAsIJai20TPsfU7tz29ARKPvlu3btXtvTmSrJOi55DG/lYtXKiVdowRiyRnBRvFbpi0HyCWHIN5I9eXxcUSlQ9mXNclDVESyRFNLSyKSyeA8ewn7nIfhEAsCKHy1DIRgyKo0rKGeRM66NMf/dXDX/9M12g7dexAvgJiAbGAWGqCWAxlMXfQ5mHdudMPpiJHlugufuYze4tLJi9LfApPYCyTKcVNsmtgG2HfHzA5l21lbW0tbQSp8yo2c0rr6+s27Wcj+Epmghx9vvLqBZdvJXhSte2feXRZJWxWXssw6nwhBoRZFzE1fKUO/RzEAmJprhrkxfL9uYuepnn3Ds102mhQxntJOerdpRj+N6l162m1CnH1Hj/Ekmn6z44yihdLiKa2EcPcmIH+HCu4A67e44khij1/fS8U596zNmSr/62hATZzPQRiQQhVAVla5g3dilOwxFlYHj54/PV/G5l9D5+QZVZmWQUa2j46E9tqQSwgFhBL3RFLvLfp+4eOKxeL7tzuzqeO6RaWU5q+/OXZ78S9pHvzo8mUErpae2idvVgGRHPSxvybC2nnlfQstG72oKdP/sePZSxrRKC2fiepmAwZ0/6aNX76TEz/N4ir/rmI0quzzbbJPFSfdgaxgFiaq6Yglq3727nfF5l+Hm8tXqvto3vIp/rW1pZrmc39/HEdAtTOBArzkZKyhIIrIJYBgxnpg7sbhlXUauGUTY44IH7v3218YB2e/KO2unF3T/+bbxrXagI2oLEXiAWhWr2oTfLrbolfQU9++aUXe7GGurZapXPYnjqmVfAgFhALiKUpXiy6fR4cEWU5Fh0iRqT6UtB0cyoKHbb92/+09cH/B1+Z9DdAu729vW3zgtR8FX/CsqDF+zr5A2eedTb023+aZOz1d2dJXAhZwBOXIFGv+gRq69f4QlzXrl1zZ/j1R1ymKPJGDc0HIBYQS3PVCMSi+10LC3xMkOk+nLnGvFkmZunVV19NOLzmQyw2p4XaubjWGHvEYnwU9J5KnLMhYSCW4DeCWvv8+fN2vUjl40kFATsweKyNmpv5gMqNSN0cdYKvdBU09gKxIFSn13P0EfuvRHyl6wr94Hf+RWSTjfFGZPk9NKONOGM2gcJALCCWpnixRCHCIreViIyacGEnlJrlfpyXJWItQqfHXvjV2/8JyoI68apYgZam2PdleFWc9AMNLo2YFdt/JpyK6uxFYQLLNDfUdToYjhpf1cmdPrpkviKrgVl13qkfVgSxgFiaq5ojFntTWx7vQ1lsT9arP8+0odKndyY1N0nvPcMluT8Rei+uImOJWNLXRWNLNyanp7cuiOXAh4N9iFU7mFGHbI8yEv6L+TcGB6cdFZHaPdQnUx1CxQnEglDdldvaDmIBsYBYcjR7EV4smUWU1PilfRihl2fvHzm2dfj5nZfPmR5jgGuyA7W7Tm7dRE3tPZ6Q4zoxk+SRcOXKlSEnOZlpzwc4nQwOeTQgm7r79zq9MZtdJ+aZkVPR5csnT/ZdhJtpvz4wF/1gk3e/YHGJbRu1X0sOx/UuuHPnjvrY7OzsSO0/TM/PTBIwzAXad3VmZ9U96mwvSCCWPGX2RRUtdda2lqXXqpNElYpPLyreVtG6IZbc6KjoxOCltonT/Ua7uPpJ/EPThnqS5BmLDyHBYNsP85zn/ldq5f0wrM58+6wn303cEe+uXC/oVNVDomsRd5t8z5P6BwozkpNuIhRnnkvT6/D6bffmQn20ce+uVif0G5AMLpnpmtL/acBdI//yfI4j+mGokLmJUZYoC70CjbdALAjVXSAWEAtlLBGLjqIoYRFo0Z019bxYy/bhZ0RZHnz+C52ND7qdRkyl7XYhk67pSeTuZsIJQlnG1L5vt2XAXV5edk0V/VaGZm6n52B2TVk/C/5gs7JZTKo1bvfv3+9HJsbsWmiCaqNXDUBZmWgqHSMlbTl1V/kNQ2vMtqapN35yc7zvAiNl99EtYCOc2KZwI5yk26cfHRzwB/3ul3RkFS0E1i2QGZatdkZqz4WojintwoULteok0V3Ts6Q3PaOAi1h87Fn67S9ur4/HY9kiljwmb9Mr9Bnf+MVlWlb4Hf9+aK/4t868PE4Pc7n3pd9xuRtHe1BrF9Sr1UM8EYtbuzojFhvazssF0HkvkMb84PF8zGKNY+6A0Z2GFnZw3u9vBozbE68PcR291HLfL5lh5fLBFRcOmQpq6Qw9BI2xQCwI1V0gFhALZSwRy2b3/KejvCxHnovvr2n5smwrO8ux3/pk8cfxST2JPlrGq6XViaMI2rH7XqdDYLHJmaTdvXtX2UpNCs0DmUo/Y7H90k1FO8Dcn5jOXbw0d+vWrclp88Q/Ffnk+3MX3TZJtNVg3HIgQcncVaKoA7yxMK91kZ1xJ1tpiXUtvbMsw8EAp6t+rZ2IO5/5Z27c/37ERdHVr1+/LutDO1YDjNRDL5jNLo7VuD6IpWO9WEy9YkvfSCX9zKwDYkmbzHLU6/bf3hkfL5aeS0rufmv+WdBC+65d3vaiHtEZ9ZLZoufbOD3YN7e30q9Fn/aJHJL+378N2z5mbyZQWO7nSeJhUmfEYuYNCet5jvvLXhrz5CSH+YDeZVPN6QZPuHa5D3yNPQxlSQ8O01+6t0ZiYKOBepDXmcaZ7tKinEOIrPVecg23lIWeg8ZPIBaE6i4QC4iFMpaIxcQKM5Rle+pYRFmmno++OTSjbx4cmdn57r9vO14qkdeKE0Ashi0txqZjORNLTDwSV1lzp4WFBc2Qh4l0lF4HmoYrmQZHN9XElR9eFVkZ+wDKQ95NagfF5rp48aJmiS5l6UdQBgRtS+OBfl4vZ8+enZ+fV4iPSej/mT3f3dYlWFtbU4O4ri1pNGisEgmfrURw8H43UeLyiS7Ik6ZxmVoVCH5fZWfzR/nQb2sVKEzKV52uTerkPpamf9YHsVhDW76Fw2mLZ+PGCeaE1XtzN0Lipi4oF4sbyTNnOvfZfb817Hacnuqy9j59ls565ZMwQxfFZizivaMeYl7oOXPGzO57Danr1vzSKCmLrOc+rkXukzMzGQ9D+swNfWqxziuvXhgcCixzUdTg4L3yklHHSzvX+lwXhZ18eg4nvXL2qAqJOKtqh4a+oRAaLBALQnUXiAXEQhlLxLJ9dMYAlX84MmN8WRQxTHlZ4u1jm1GClhM6pb1fPjIJWNo9F5YIurS64cMYlo73lGzATKkdT5Jvra0q5oOZrQ0I756em6XdL9xPrbOTZeTHy0vGW+JAm/gYX4sBXxq7jOa0cm2xa/3SbZ7p6TI4Err5SwVFUepj+UxozmxbewCEGONLMKCzKYyYroIiuc29fkkmhrRJbkhPr8SnLqhuKxm+hbUMXBymS9TOjra1dTuWltvfziUt/7e/lSNdrep720OmUvq0FawWIbtXSqdkWj5f1caGhatNcjdCtzHvFNsm5nrpKOt3vPqh0cbGxvg9xu1FtB07d0PZPRTxojHvEc/ztFeztjDeHTloXCGPt3yvBve9oKbDSp5jbK/21xhbw7wDsx72c4+2w3UturL3RfALoefSbT/ZJ4D7ZDZdiL6BxlIgFoTqLhALiIUypl4sJ4RSBFpEWYwvS+zUIo+W41tHZ6JwYUemoz975oVPVn6y1+1FLZvrvpf4HjF5a9uJkMzBin4uu7yCKWnm5kY9SkzVnq6Jm5195ZVXtD5dqGBpaclYo5poTS6obYckSfqDx7/a1bxRc2bZ5WWdf/V7rymwfj+vFDfitj7N3+vC6fKt/mztg7sb6TZPn8OYXRHXDDEMX+kXqstM6QVd1KUvXbokBxR1bxOdw/USMP8UldHNoiKmqAunOB66iIKX7iGaSxPDujKM8ROg1WrxKqlz76151/XZ/+S8WHPXtByXLM89N8JvbEAcVHpvaf0q8Y1YizK1KACsDYJ6oFe0/Hc1XNRw5d69e8UtuAnVpQdPKOhCaPwEYkGo7gKxgFgoYxso7MhxURYbMezDw8Iq0bb4SvQHEXqZlmuLAog9/u5r8UhUH0/2LGiBsozpTKyfp8KAqcgAK3Bk/X/8OHPh4ajTnvGeC4005RsQ2K3fbqNFoz11hvNVOtAsMjZXZABHyTEbH7WJhuztw2OeWpl1sKPlu7g1fwRNyOXzpF9l1j3HsUZ6y4/Zs30sT7JBb+dQlcVEHrbNzUBRY/XFWGaxiD4VVsv4kg75yiiUuHjeDpmTHToSGhuBWBCqu0AsIBbKWCKWrpPK4RORI8vhZzfj44qvmBPQf42K/uvUMfP3D7/w+61HcdCwzpNO1+bQYkA6gROwkcxzw5OAzuh8heW3nf78Y3Dj9PuziV3Z57KKzDY5sMWKvvUa1/8xWOR7ZnIFeZ+WdqwJibTZiGrCNalmgxpq7JfXINRcgVgQKvK10f001tBW7/Ux2oIsEAuIhTKuXiwjluntZ154snLTUJb204Qsrad9rL3XyfOYQQghhBBCCCGEEEJ5BGJBqEDFTKXVMUmqI4tnK8eacxALiIUCYoncXA4fj1xepo7vdDt29GBpG6bSjRjWip80e3vED0MIIYQQQgghhBAqRSAWhApUl7BEilxYImMoiGVogVgoIJakF8uUcrccf3B4+uEXv9R++DBCLE9Pv+ct93QbIYQQQgghhBBCCBUrEAtChSpp6GwricKIArGAWCggFpXtqRllbdk8rNQsJ5Sj5cELv9362fuWrOTpZwghhBBCCCGEEELITyAWhIpV2yRxjbxY2jY3y0gCsYBYKCCW+MSm41hhz8qLxdyPD47M7Lx+2bqttLuxwzp7vW8QQgghhBBCCCGEUKECsSBUoLqG9UePWo8e9TIlfApiGVIgFgqIZX85IcoSxwo7Ft+M0xFumTqx86WTnYcftTu9dCxtnFkQQgghhBBCCCGEShKIBaFi9cn1nz74x599cv2vZfV8Ei8uL83aDmIBsYBYcjR7fb1YohvwhDk9lQ+PRn4thrvc/+znWz/7uelqMWvZ2+PhixBCCCGEEEIIIVS8QCwIFajd139gbKOfrPxkLw7hkyN4D4gFxEIBsajEzivKyBLHCpt6NvZomYmChili2FSUqWXn9T+PvFi6DxkChSGEEEIIIYQQQggVLhALQqOqa7hs7/vnU3yiKD1aP95++OCjf3kyoNkXxAJioUx8oLB+ZdpwF1GWj7/8UhSWsGPcWeLMLG3nSdXuEEQMIYQQQgghhBBCKKBALAjlUMvkPGgp8FdssjRWy72Yr+gfT977+S8/+/nNqedALCCWHIfugFhALCMHEIu8W+TXEt10n/n8J++vm9Qse+1PogdUe68XQKxDphaEEEIIIYQQQgihgAKxIDSC2tZnpbckvGc7b7V668MfX7psYviYZNQgltyHBrFQQCzDlChc2JEZ88CJ3Vmm9Qj65C/+ynS7LlOJqXDsYocQQgghhBBCCCGEggnEgtAo6gGV2Fxpv2h1TZkPHz76V7Nd4+yh464hGMSSQyAWCohlmPLw8Iwoy+aRZzePmKQsx+Pzn3789T/c++WjduxgF+GVdq6+iBBCCCGEEEIIIYT6C8SC0AhyjJNPzP9FscJi2PLkZ+89ekHBwaLs00IRm6HNviAWEAsFxJJdpo5tHpXnyontqWPGi+X+1POmFo8+/7t7771vnlHtp354CCGEEEIIIYQQQiiMQCwIjaJexB2bdsVod+6y0iHEGRFMUoRjUaywHpAAseQTiIUCYhmqHDm2eVhkJXoEKURh7MsSUd5uEz3zwq9+9Gbsatdqd/BiQQghhBBCCCGEEAopEAtCI6gXaMfECIuNlg93Pv7yS2IqhkDIxBknYnl287CWk8+AWEAsOQ7dAbGAWEbKxXLoORMZTC4skS/L0Rk9f/S9ErTEj6bpR4dOfPz1P+w8/KjVhrAghBBCCCGEEEIIhRSIBaERFKU06KW417Yi8Dz87X/WNchOPa+F5Fv/6LhJhKBtsRYQC4glx6E7IBYQy2jp7o8ZF7o4XFj3VhVrsbXQ99p+8Ln/sfX+38BYEEIIIYQQQgghhAIKxIJQH8WeKq1uZDCb2r7V/UrBwf7ir+7/+m9phbhFKQMMwSCWHAKxUEAs/k0UJWg5OhMTl2Pbz/zWJ//hLztPfVlaieBh7SgAYu8/tc1jkPQtCCGEEEIIIYQQQn0FYkGon1qxsTHKZx9H13liEEv05aOPH7/0crQq3MQEOwJiAbGAWEAs9XRwmYkCGEagZcYEE9Ongoa1P3rUsqTFwOPkRuy014GwIIQQQgghhBBCCA0SiAWhDBnbYhQSrGeCbJv89vp8f33781+MLJVxZmmT/ADEAmIBsYBY6lY+VLjCIzObEV85vn30+KYoS/zUUhjDh7/9O62Nu72e2drfQVvt3ld7OfouQgghhBBCCCGE0CQJxIJQltp2Qfe+Jdyf/uivtv/xC1tHZ+Ll4cfN8nDZMUEsIBYQC4ildu1z+EQUJWxq5uHh3zB572MerDQtShZ17OGvv/Dptf+7k/RdiT/bYiutHnjBjQUhhBBCCCGEEEKor0AsCGWo3bMqdiOF6d+PHn30r/9Qzis9uPKs3XhwBMQCYgGxgFhqGCXsuHPzdp9Xm4efib+ZNk4tj8+cM24r7e5z70mPtOy1O7iwIIQQQgghhBBCCB0gEAtC/dXqhgh78t77Dz7/T41d0lgttSR888iJOM9BtA1iAbGAWEAs9WwiPbXiEt+/h2b2384nTNCw9gd/133iGdDS7gUQA7IghBBCCCGEEEIIDRSIBaEstd0UBa1f/bvvRRbJQ8e3Dj9vMMOWSW9w5Lko5E4MWkAsIBYQC4ilboHCIgb8a8/qSRU9pg4dd9xZIrhisLEeYtvP/HefvP2fBFe62afky9JVq90GsiCEEEIIIYQQQgj1FYgFoQyZCDk9g2Pr8Z/82ebUc8peENsopx8cli/LjDKyRN/07JggFhALiAXEUrNy4sMjx5TxPt6eNt/oCWZjiImyRLgl9sMTg/n4W9+JXFha8aMvX8dFCCGEEEIIIYQQmjCBWBA6WLLUexqCQSw5BGKhgFhKRjIKGrb3wcbTYGHRx6dmQ9rrApin2aoQQgghhBBCCCGEJlwgFoQOFogFxAJiAbFMSNk+9pm9xXc6PYjS7ha59O1FxKXdjaKIgwtCCCGEEEIIIYRQB8SC0DACsYBYQCwglknwYokcWY4c/3Bq+vGZf9fphUyM1ep5ruC/ghBCCCGEEEIIIfRUIBaEDhaIBcQCYgGxTEJ7muws0cbUzKMv/l7r0Ue9KGEt67wSs5YWscIQQgghhBBCCCGEOiAWhIYRiAXEAmIBsYx/iLCpY9tHZ+LbfDr+5/Ht6d/65N2VHlZ5ylpahAlDCCGEEEIIIYQQigViQehggVhALCAWEMtEeLFMzejzwdSJrSPTW4f1KdAys/snf9Yx6Vii0jHZWKKkLAghhBBCCCGEEEITLxALQgcLxAJiAbGAWMa+POg5r0ReLIdmYr5ybOvw89r45Re/rKBhrc6ezcVCoDCEEEIIIYQQQgihDogFoWEEYgGxgFhALBPSpAItm90WMI4s+mcUOuzRP37hk5WfdLqeLEQKQwghhBBCCCGEEIoEYkHjpp7hr2WzNLc7vY32Xvc/jbj+GsQCYgGxgFgmtmzH0cM2Dx8z91Tkv9LqdWuTncU+dTudziR5t3hGS6t/sDVzhu1YoWpKiLmm91tarOl1sdWppF50v4Iak6vJg4JGQ4gOfOCrn3sQoUIFYkFj9qIzSKVr49vrZmXWP5+YZdcGt7RHtAGCWEAsIBYQy4S386Op6c2p5wRaopv60aPeoPyJGZl3H60TwFcsdZio2aNPfRvKV3wqXq0Je/DkuZxTGssbZDwqVdoTbMBdMPZwuvw+WX6bcBUqHxWEei9XeNqTNqAam1uJC1fbBqnV+BOhyRSIBY3ZG65jnVTa++3agi175n1jvm3vDb/aGsQCYgGxgFgmuESBwkzLbB+dUYKW+8d+a++996KYYe2nPbwtks002M/QgB1wDK54PSubmP8HPLf0PpnYN+h+LOixRh9Ak3MfIRqN1kD1uay8hRGqViAWNGZqdQGKfcF0v4yhSyvebrdHjRUGYgGxgFhALBPe1FGssCnxleOiLFu/duLBkZnHl/68+4TtOrHED9VuPMZxnjgVYZ4e47niBE7zrOW6hl4smIryVaqgChZKO/Jdu1C3fDkxSbAiTbIlsW6jgjIbBFcw3i91u/3xRmpKv+L2R6hQgVjQeL3eOh3rpNILXPNJp/00gk07/r7t/uUQArGAWEAsIJZJ9mL58OizkSPL1DG1zIMpPQdOmNQsH/3eS61HH3WfsRM5Zs9d6ckMOFb/2d0YX5FyutzYdOwyvXPKdADKtAgXVNmC6oW/VIVNQePX4cWRuAo+DpeTsw6g/q/mxkVS5QrWrTMPc3QuFkJFC8SCxuzNZlBKtKh6z9IWpQu4/tef/uj/bOm77mul5US4OVggFhALiAXEMuGUZfPwcVGWyJflSI+7HFLcsOPbn/3v995730LrsR+5T9rkZDJ9UIKbTrCG0CtqXp0SAFJAMyJ9uKqmoOXTTVFJmwQ5enEBJOlOde63PITHvjOP5EvNEBGhsAKxoPF6vTmuKt3oNa227OyyCX783VftOmsTKwzEMoxALCAWEAtFfGXr8PPyX4lBS+zREuOW7amZ+1PP65tP/uN/Hnu6cvv27WuxFhcX932+PXJ5Sz99O/r53bt361/rxVjdc85b9PMbN27UfPL2+PFjXZS3337bVjZfrc2vjFZWVmo47V9fX/e5mm7RrsZ7Zu7aH9WHQ7Wbetr29naFNprEsVZXV9Xz7ZPNbEcasV7m52Y/7q50cxVXu3zP4UYX+wKy7azPra2tMvuPuR08Xw0NLar14n98+/+69pa9BKW1fOKid7fzVqTkx6nGPBcuXHj11VcvxHq1pwuvTVi5cKGS15kGJIuOnj6ocw1y0q+wiZWevaYZq30eJqTrqze7BmkayZu3Q+VUFSEQC0INBS3Sk4iiPHr06F++FBkED83s/sn32sbHJfrPrd4GiAXEAmIBsYBYDihR/hWnTbaiR8GJiK9EzTUthh3da9aJcEy1cvPG7Isnv3Zy1nyqnHzpRbMxarH7uXz5cs1rfe7cudnZfaedr7KmyMxa58rKYmgqm6+mpnx19mv2+krz8/M1RAVnzpzJXcFEOX/+/CTM1U3tZBcL1W6SrB416RJ37txxH24+/T9x15sNPTwL7R660UJdl6aURAubz9t/e6fM/iNLcZDe0tz212dUYpU2w00ePW/7mx+W/NRev3PbPQG3G09W6XWYkt+b5p7NvAQ5iq4mNnojvc1r+Ix6+qDo6ezZsxrGaFy6vLysc97d3eUKIgRiQahnsHa8UOJ/Op4rcfnk/fcf/Ob/ECVnnoqWXctinvtwIBYQC4gFxEJJt79pKD1jE/fauL53vnH6VNrCkm/aY4p2WDcjsistUUycs6c16vqNlTrb4ufm5gbwoRymT5WNjY26XWLXyBWkaIeTQFkkrbYO2G6VIxajjXt33SfbqOabtLk/8Xg07muFagJN/JkXouQeZW6HyUQs6VJas6fHHj6v5qos0Z7GfTqMJxZ1KV3TX2H1QSyN69I64TPfPnv56hUtgyjTCRIhEAtC9ZPJpNKymVXa+6lLa3fuqgx/vbA2J0AsIBYQC4gFxAJi8dQPrlxOGND9FyDLi7+efEVaWloKsuDR/mru9Uu1tcLLwybTQOxziV8+e6aG4OH7cxfDTtE1P++MUaL7yUEsulj5+EpiHb08txIg1t47byyU4cUFYgGxgFhALHQYEAuIxedtLv9mObiMOivBDwYhEAsaC7Wf5q03/2v3NlqPPvroSy8qdo1SBfzDkch/5cMjx0AsIBYQC4gFxAJi8VSQcDqJPRjzdD2lGFD+dpDETL7yWGGZs0GTVyCs6Urlx8tLdZh8uvBDCxWLsAKYmOx4sTTIPqWLpbwIp755OggqzvyDq1evllMXEAuIBcQCYqHDgFhALD7vEa2WMAGQtfDiyg+vfnB3o9/ImWwuCIFY0PgRlq7R2gQHa7W7W3vvvffwM/9k88iJ2Oo382Dq2ThhAIHCQCwgFhALiAXEEkDySwhogteGTJy1mqLYk0nY4j2pkslQolJC1KBRKYv5p3w7gnixuDupQ+CFRGWVELWImblJmzz2jizjhFgUhP0758+FosXuhrnZr1wpDx6DWEAsIBYQCx0GxAJi8Vnyle4VmvJoqZC7NAqmghCIBY0vYomChUUp7U14MP3v8dz/rrBgD6ae3546FnuxnJD5b/PodAxaQCwgFhALiAXEAmLxNVXLiT6sFV6fa2trNaQOS+8sJyZd/hNI/Vwko1Y1NdrZ2clcku9zfWXLqOF0VIsTi7AC2KxCrVZrjCfhY4BYzKVRhz/3R+eDJFjSp1n36v5TMRXLrBSIBcQCYgGx0GFALCAWz/dI5qeWgsnhfnN7C9CCEIgFjT9m0edeZBl99PGXTxoAsHlYYcGEVU48ODwtw19kBCQXC4gFxAJiAbGAWEJYJxVaxzP9e3pmW7I5ckgZC2zmjCtHkdXVOrJo+XzdpmfyrXFDJbgZJnJPVuvgr5OYCV+/sVKQCUC71c7H/gkwHl4sWpGqu3vfE2n2RX9UnH6glXabg1hALCAWEAsdBsQCYvGM9pnwRk2kn7x8+bKJCgtlQQjEgsaRrygdS/xs/+T99+9/9vPyXNk+/Mz2oecMU4n8Vw4f3z46E5n/Dj0HYgGxgFhALCAWEEsQg7WxTuZGDhbP2AmMPACqnau4RzfbmkRl0qB89U1srNy8UflFTIS0mpubGzDVzGfxFEmqITbzNMkNqLV23hn3WGHjgVhUi6dR12ejIgTqH2PEfLrxwUAsIBYs5iAWEAuIBcRS/ywsifN3nVMT/UQeLZVnVUQIxIJQEYQl+t/jH/2lHFYeTUVhwTanZgRa5MISl8j2Z7KwGCMgiAXEAmIBsYBYQCz+MhG0gkTNstu31lYr5yuuPXR5eXlwugUfU+zFS3N1MMDb+mquODsbAK64v1Uda8UFXRNAEVYAs8+xN7iMAWIRAtmXIenkSxFfGd2LJU1e9fnKqxcSva4cygJiAbGAWEAsdBgQC4jF07E+0SUsX0l8qZVhi4uLXHeEQCyoiSil5Rine0lXOlGk79ajRzsvvmwig8lbZfvQM4OtoiAWEAuIBcQCYgGx+Juqt+5v+3t1JAyUCq1T1cL/zOOeO3euuEAEKju7j4c5jXJqbaKEBTR0mvw6dfPkUB8rOoR3PUPeTThicfuhFp+Gup3T6FRuTFWtbAWxgFhALCAWOgyIBcRSJpLRS3/9zm3ihSEEYkHNkkEsrb3eRoxZOns/+/lHn/vd+0eOfXh4xriqbB95LnZhAbGAWEAsIBYQC4ilWJPl3OuXbKSvIMZKky28KqO8SVFuZaKEFRrx2Y0VlulGU2bdzdXMl2Am09B5+t98sz58pcsFt7YSMbWDz7fNp43TDWKp1j6Vjv535YdXg+DDzOv+nfPnKowcAmIBsYBYQCx0GBALiKUEvmKGvrYLzb+5oLd/esiBEIgFoVpaskzM9NgMEv+/CEtLwcHuP/OCjHrKtmINfIoShhcLiAXEAmIBsYBYSjBYm7ThPnaNtJny1q1bnepSWbhH/PHyUnATfGI7HUerqimZMqb4RwZLxFIoP933gRf32rVrmQEfgiOW8Y4d0VwvFkFN/+dVIiy7/b5avgJiAbGAWEAsdBgQC4ilnNdNuvNoDHD37+/RDRACsaDmYJZe5pXOw48+/tf/VjQlgitHZx4cno6M+IdO9NKunACxgFhALCAWEAuIpWiTpeyJp755OnegMDexZGaa6KpYizmcTYpenBeLPo1NthII4frNiJZ5mqjSwRM27t2tW6dVdzVOV2nzXNgIaWe+fRbEUjcvlndXrvtf8bQxzvzT5StVMUUQC4gFxAJiocOAWEAs5bxu0v1HvviuezpCIBaEao1YzIztV3/z8wef/6cPf03eKtOxUW/GWPw3j06rRJa+Q8dBLCAWEAuIBcQCYilBymrgaZdPfGp+UpULiytlmvEMgNavvna35lMZUKoiZO4/vz930T/am8Im2J28fPZMtebmtFZWVtJz4+Im3lVdWRBLv6sf5IonvKDMp3Dsx493Ku/wIBYQC4gFxEKHAbGAWEoLF5b55dWrV+kMCIFYUM3xSieKlK6J23vvbz/zwv2p503OFVn0Hh6eEVmRI8t2HCJMSe/xYgGxgFhALCAWEEvRBnpjSVxdXfWxaxhHlkQyj1trq9V6dUhL7ywXaoK3tRbbqNYsa7yRcs+K0+Zm87mwsFC3Tis/g2FmyJ4X13RpFRlxQCx1sE+ph9+5c8ffCJu5ZNV4LO3sVuy/AmIBsYBYQCx0GBALiKWcogF82iXa7U56LyRSsyAEYkGoVhJeaRlr+4Mjymx/TFjl/qHIf+Ufjhw3Bj45tShumL7ZPvQciAXEAmIBsYBYQCwloAhJfieeJsuEfUSeMRVCo+KihGWG1bKxwiqUSVCRz2snYZvQ9le+9tUa5nv/4O6GS0GKCxTmMqcahkqbQMRy9+7dRDzDIKDF9CLtWV2rJtcFxAJiAbGAWOgwIBYQSwn+K5npJN1OpWU9SnMIZUEgFoTqatKKyyfXfxob9aYd657ZPhEXUZZjm6S7B7GAWEAsIBYQS1lk4o2F+YAZ4FVktay2UltbW0WY4DOjVGmj8sDNFy/NmfP5Sgj7pplY1q2j+kS0y02bKoGFIJY0X0mvMw3yyBJdNhStJjYUEAuIBcQCYqHDgFhALGWCln6rN/TPc+fOVb6ICiEQC0JDWdtzm7xBLCAWEAuIBcQCYvEnK3ZbRsZM+6OPvePWrVsV1m55ebm4dB3pyopwuA405Zhr7VG0yG52NkCie/ebHy8v1aq7mkholRQbKcI2+BgsaWwKYhFfEQUJYoRNF5GbjY2NWl2XovP61txw1nUgm20SYvnqfr+6IgIYFtvmJ1/SqavYcwaxlIxYMrNDuV/WuehU2/3HliCWSUMsmQPv3DFs+22k75rieL9ZcmQoC+4sCMSCEIgFxAJiAbGAWCggloOl3OaZlo7cgacuX75sd95qtUqujknaUY6dKxErrPw5mEkC7zmVTfzw8a9264MApcXFxapMkDr0gacHYiniJMUOtYDUZscJAk3tTiL/lZrxlbCIxdRU4eYbYbdNPL4ahFgy/auatAZccCWmLDYtAYilTMTSL0JRg1wB2s7iktLejCCWeiKWzDs63zwiEdKz3wqwIhLypQPn4suCQCwIgVhALCAWEAuIBcQCYhnWnO0mhzdZ3D1XsZ06dco1RpdpklYSkTJNXeYQN27cKP+qmY25uTkfu4w1YRtrrLbnXr9UK75iEGBV9iPlQk+cGF4sxdmnbAvLnGFAadoVwwf9mn4uviL/mBpeyiLyRbl5fRsRFr9ZiMU2bJ1beLAXS6L9QSzlI5bGOa/s82Kp4ikKYqknYjkw9FbulIeJN1qxnpRZgw3ryzJgpIoQiAUhEAuIBcQCYgGx0P54sURYwp232MgnuWdH2lVVscKEi0KteR9+Vvb9uYuVVFZTPs+prLU7W18BucXUqnMq1U219l+Ta2ecptP1RCy2hTP5ir8p0/68hv4rwRGL+wx0rf81tNLq9BJcv3FeLKYKDaUsCVM1iKVMxBIwQGslRX2+EnMziKW2iMV/+pDpF+heaHmWuJQl+C2T8AG1x33l1QtgFQRiQQjEAmIBsYBYQCwUEEtfg6adMCSCa/kvPbt69Wol9Tr3R+fLjNZiTYSVhBG4efNmQLuMCaBUt/4pY0q1ViedQCVWpElDLEaKK2gdswaHs8v3XDLAbOwRS3p1fG0RS/qEm5XuvtEJz5P2/Vm8WMpGLJnL55tSpEoelSCWeiKWxI1sKIVnDMZ0Zpc0einoqZg+hytXrkBZEIgFIRALiAXEAmIBsVBALBn2a/efsjwaP4ZQMeXLN9arFtsP7hcaRmCAfc2abstMdy/vGU8TVWKOqglk5SzBPfrGvbt1sEJ+cHej370DYglrn/rBlcuZ6UOC5M69fmOlzhcxbKeVFVJFC29VXu3JfFmjcsE5t3hbn/fu3WsQYhmQlKVZoMUIxFI+YlE4yrcWr0mLsaLttxebUa5d66SysJTwdAWx1BOx9EP7Pui3X6TQQh+z6XUAdkNhgaEsCMSCEIgFxAJiAbGAWCggln0T4MQkQU4Yifjy/mvGV1dXS56K/Hh5qZ9ltujJWPmxwmyUMP8rZQP1VBXerZ8uX71SB+PjlR9eJVBYCfYpw1dswKWwviyWr0wCYqlqdXlzb4dQL4vl5eXbTdP6+ro+79y5U6atGcRiq9xoR0l7zha0gFgmFrEkLooerZ7ns7W1ZR5QAhviefJwPX/+fISCCxvbJ0KQ2QPZaZFWj2npD10FgVgQArGAWEAsIBYQCwXE0hlgZBQkCGLysNMSGUxLrpSbwqH8QCsfP94ps7KacwaxDFqjtrLK18rKY7BfHZaEa1JtAsGNB2ipJ2JZWFhIWF3FCUIF/TN8peaXD8TSOMSSDnem24E1zsMIxOLGonRBBX3jQIFYCu3YoXLU+yOWfiNDnecbC/Ny/yrHST3R2TTRoKugSRCIBTVDIBYQC4iFAmIBsdRTcjrxjxLmOtcXGissbYnY3t7ONHuVFGXlxZMlm3G1oG9wdIVRp5Hzby5U3gnd1lO8FJ8AaGER2tI7y2NmU64VYlGcvVC5oNKBxVZWVhpxXcI+l5hzjXQ7hHpiYK4dUiAW+3PrxYKGFIil0I4dZOGO655V3ChRw/75+S5ryXR+DRVbLLEfRcmDhaKxF4gFNUMgFhALiIUCYgGx1FanvnnaP5KyaycVtil6imW1tLRUSRZie5S51y+VxldslLBQYa/1effu3U4NVtHaE7BLFIOsqbSphvJZwXQyY2ZTrhyx2Kgyrj9WZgp0n4W0TeErHRBLpbcDiKVkgVhALLkFYim0Y9ccsWROBLRKQ37Y/Z4nQR7viUeWTdGH5xkaV4FYUDMEYgGxgFgoIBYQS21lc02HWuqlXBqlnXwUo7lE55VEfc2GCSdV0BzS/VJW6SAmqkTog9JiqR9Ya+NT5VMv99LY9B65L7H2UBAvrMqmXC1iabVa1jKSmSbXn6/okl25cqVB1wXEUuHtAGIpWSAWEEtugVgK7dhNQSyJcbI+taLCerS43cPzbs18WLljZoTGUiAW1AyBWEAsIBYKiAXEUvP5VRDHCPNbucUUOgOxO1dWzLSxpjQvFpsJU+SjuDq6/1TinLBeLMrSXE8bSvCY2rkR2iuvXhgnm3JViMXtz1oH2u8a+VMW8ZWaIMMhBWKp8HYAsZQsEAuIxX94AGIpomM3KFBY5pfXrl1L+8L6hyF1B4Qa85986UU7bAa0oLEUiAU1QyAWEAuIhQJiAbHUWfK1D2XiNBtra2slUAelykhMucvPlK7DiXyUMJnc2dnJnC76mKjEqOrTCRVfO1TAKPe3mhLnvriGotWqlTxtytV6sahjKzCd0jUN6L0+OXjkkNc42weIpcLbAcRSskAsIJbcArEU2rHr78ViX+vu+93d1uji3B+dD+XFYkePiUGpBjDyXIevoHEViAU1QyAWEAuIhQJiAbHUVpoqLCws+Mxa07+1ts5ClZhNlYxYNPuyjiy7u7tFz7hs7grXgSZ3rhEVGRlrZY9WfDlPBx37k4QtxhMZlhn4rmibcrWIRRYQm/kp87b1uXnNZWqc4QPEUuHtAGIpWSAWEEtugVgK7dh1Riz9mEqGAeTxY3myuhHD/APqusV889bitQ5eLGhMBWJBzRCIBcQCYqGAWEAsdZYcCHyW/NvphzX9a51X2OlHeoplzjlUumwflx0V5ZYIPqVMxDuam5sLFf3A/ErMJnNVYCWSj46M7/6mE/PbrfvbrmOWpzeMTkynNx425QoRiy6K4SuJK5IwmeW7XuIrDbV3gFgqvB1ALCULxAJiyS0QS6Edu1m5WAa/7peWlmw6vYQnik+wWTtEMY4snT6ONQg1WiAW1AyBWEAsIBYKiAXEUnOdO3fOfyG5+9tba8HyhGdOYxQQOdPpobRcLO7nxUtzRUywbH01nZudnQ1YTf3cTBFrIl1N/+toTVetTjuRUN0z2ljdktbktilXgljUjcWo5HN2oANcbr7S3OsCYqnwdgCxlCwQC4glt0AshXbshgYK6yctIdL5+PAVN+1iejnI4uIiPQeNpUAsqBkCsYBYQCwUEAuIpbYy0xW77MszPbj9RrHCQi3sytyPmJA/Gkm4/w85GcvEADu7j4c57Xy1NlHCfJbgJWpXn6hKxltHTiduTtHBVyHTyGK/UVt1em4xQfiZPnV67UCXtVqbcgmIJd0+ujVsTD+vmGCzL6rI1c7tBt85f67Rj18QS4W3A4ilZIFYQCy5BWIptGM3y4tlGL27cn3IAV6OalpHFoTGTCAW1AyBWEAsIBYKiAXEUnPZuFuhvFg0Awloj261Wumz9TSdu4lM0sGLRgUtbqywsNEDVPe51y/5BzpwbRPWx6gSYJBon9WfrY3U+P3mxvpGLMQeRZAvd677tBFHJzmAIjTFply+F4vMEMZ/JYC3WcxXvvq1k/ayiq+k0WazBGKp8HYAsZQsEAuIJbdALIV27LFBLG6IXSVNSUf6sot4PGPSyrmZQGFo/ARiQc0QiAXEAmKhgFhALPVXbjt+2nJqPm/dupWY8ASxy0s/Xl7KHUgqcbYDXD2GIUl2W7HCBpywj3Z3dz1NUSYmta2d3DvaTrqXCqfB1nSSmVN0JEcis3Ht7UW7842NjSCw0Gyb69vcGXU5iMW92c2nySEUJI1QxFccDyeRG90aTTdtgFhALCAWEAsCsYBYipA8ttNjD8+AtGbj7NmzDR0NIjRAIBbUDIFYQCwgFgqIBcRSf5n0FT7RihNuIleuXOlnfvU0zWfmdRjyVG105swZ14tff2kkXwq3vokEmEEIhDau31jxTCuS2HZjuJU/OUwcemtrK51TdHB9XSNLouPJvanj0CN5OQQJFGY+zc47eLEMbZ9STwtiTk3vQU8A3W5jYNoAsVR4O4BYShaIBcSSWyCWQjv2uCIW60erknBr9r+L19fX6T9ozARiQc0QiAXEAmKhgFhALPWXpiKK7hUqfYU+tbdQLiyutu5vH5iu40AoYqzz8ue4ePFijvX1adcQfZosIAEhhNH35y4G8S6yJom7d++6B6qQsnR6awwTLTmMC0vaziKHCXfP2r7xk5tB0t2b3jL/5kLaS6NZNuVyEItpmcuXL6epWOJC5ysiZx8/3hmPpaMglgpvBxBLyQKxgFhyC8RSaMceM8TiDg8+uLuRGSjY5+FjFvdcvXoVFxY0ZgKxoGYIxAJiAbFQQCwglvpLOT+u/PCq55TDXSZmcn6E9eqQlt5Z9pkauRMt+dmYTPLpGdcwXiz2b0ytxULCWt61K3Ev/yhhrknizLfPHtjCpc2BH/9q1ySld7vNMFNf1xvJ/L3K6urTBDO2OjmoYb8ENtpVczN/lOzFMj8/3w9WeXZm8RV1m6o6bXCBWCq8HUAsJQvEAmLJLRBLoR17LL1Y7AhBIWSHTOk3Un1NykmExkkgFtQMgVhALCAWCogFxFJn2XmIsqfk9g7JtJvIRyHI6bl+Az5RwpJZ32/dsplOhveiGOAmYmKFBZSit3kuuEtUSvk/B3SA0jqb+VQMtBxLC9Mh2vSrBDqyNTK2fh/K4p6YTrjRNuUSEIta3oQcHBzqLd9xZdFQZLlxWjcKYqnwdgCxlCwQC4glt0AshXbs8UMs7jhBI/OXz57x7zbpdUt2ZQ9C4yEQC2qGQCwgFhALBcQCYqm5LMY4c+ZMqJwfKvJRCHueJnWHT24SW+wCNGUy7+fmMiSqsd/LuBy2vjo3s/+v+CElu60wa2nU0amCskSd7dtnM5t9SBcid7b84+WlzGMpgYpPZ06ckmbpjbYpF4pYzDPk5s2babeVzJslB1/ZuHd3zB68IJYKbwcQS8kCsYBYcgvEUmjHHtdcLHa0mU426ekNb0oi5SRCTReIBTVDIBYQC4iFAmIBsTRFdtV/pqE5x1REniIBT295eTk3YkmYepUrwp16DQNXDty/iIh/ug77K3nYzM7OhvJfMUnCK1//b2u3fud2kMznptjgUf1MMzky7mQe9Be31xMVaZBNOUhRI0T2qXaK0vWcrnwDccy+qMhx0aezK8Fa5RAav7jnAflKptG5Pi3mhu+rye0QKgBjI8y1dWh8EIvdw4ULFzoVLXFoXLcBsYBYAvTk/mt6PGOFkYwFgVgQArGAWEAsIBYQC4gFxJI9f5Yd02aDtxky3FQZoyINSzI6cboXzxNWJoZQq4+tg79SZ4eyv7uxwvxtEysrKz6mqPRP+rl6VNLf5l6/5AlXntKygfHoFN0ryPW1FK2G5qcyEUvXPtVOXla5mKRz/+Rp5JMvfTV+6LjOcMpY64MtJwGxZHqxVNtctb1Y/l4s7m/raa6tYeODWGxRD6z/S6RCV1cQC4gluMxQUNMZz1z37ob2psEJvQiBWBACsYBYQCwgFhALiAXE0p02J2bONmZxkBnXqVOnMqfrOaSgTz5WcndOLqOteybKVB8qHfeNGzf8r0gXQszN+TvWuC22s7NTk15n4nflt8LvX4R4oLlEXTpfrp3MQ+vkO3ix7K+9rAxazplu4ZxeLD3jhYkPJu5bf3NkPoX0Ypmd7WcbRZm3g/87znRR3Q71bOrEWVV+kiAWuweLWOp/n9bk9EAshXbsSUAskhml+AwF091v6Z1lehEaG4FYUDMEYgGxgFgoIBYQS1Ok6bR8HYIs+bdGqFCxwjSTCTI10qfrWyOJixhjmb8ji2hNkMrKGyaIV03wEwvSx+bfXPC8jnYjkeg+U4uLi77Rq5wmfWNhvqE25YIQixCImKX1fkt0PB9+pt1ubGzU0+QXRAUhlk5dKUtNzscHsZhObjeaEiisA2IJYYkuKBdLzQOF1eH0QCyFduwJQSxm5Ok/DnTvZdezGaGmC8SCmiEQC4gFxEIBsYBY6m9zsdvWWcTTFGJ/cvXq1SBnq1QinsjBbtgoYZZnuH+ZL4yAja5mY4X5SGnD/b1q3Ioo7FhNep3aR2sJE/nqcy8kVL0ONAAl/J+MhTR3k8ruH+QSl29TLiJQmNrWXM0gRDZRlLCn5sZ6TwXPxeKfC6o4g/445WJxaWJtvVjqZiUHsdjyyqsX6j44rNkjF8RSaMeeEMSi5SD+T57Etpyk6UVobARiQc0QiAXEAmKhgFhALM2ScrGmF6TnLrLA+huJth/cz50VJmEZOX36dNpwcOnSJVtTE6w59/6V9NvHJGF+JacTf8TlBkarg5XNnIDax1xH/4jY6lq7u7vDHPrixYtBptaJS9wUhfViuXPnjrmUymMk8OnSsoCIxTRyZqcdG0eWsLlYZN5SkfQA18afXHjFfFNJMafxak+vvPKKPufn5+tzO/g/CoYMVFjt87Y+ArHYAcYfnPqGKIu5TewNW7dSq9cciAXEEuR5KL/nIGn57Hos3c71icGLEIgFgVhALCAWEAuIBcQCYqmdFDgriB3E/lZeI57mHoUvc6fWub1Mouzo+6OEGckZwu4/t+nfnJh/SC4bJcw/5rv5/MGVy/WZ5dpkP/4mTpvo/sDepR7orj33RCzfOX9uYhGLtU+pl4qv9GtPTxeBYZyuxgC0hEUs/SKZVFJcb4+6GeBC5WJ5GjevhvZEU7IcVUEsFSIW/fYrX/uqDUyaGNXUp+is3lq81qlNFwKxgFiCjD8VKyzUvKb+lB0hEAsCsYBYQCwgFhALiAXEUs3EI2HiD5Ub3Pzc38Qvo3Yo+2MiSpiRm4A9N8Kx21rd74m4AloABwdcKllygPDM1eH+auPe3eHtPgbtJJLu5D56sybVwXOx6BHxv577zgAK5dPC12+sdCYjW3tBZCVtBqqWsrh+Nk1HLOlfnTwZZcIpiJb5l2id9cmT165dq7zZQSyZ6cQqp6GDEUtNBGIBsQTRrbVV/yUgibt4eXmZjoRALAiBWEAsIBYQC4gFxAJi6Su5YgThK6aMFCssbVo1/MPHhcX+PDNklvmnyfUSxLvC00Y8NzcXxCdg+ITwRUM7K6UG9TSR2D5w7txoriRyhAoCV0zpRw3rCQbCIhYRO3sdg+dfyXQyA7E0saTtoePnxVLnxnc/r729CGKpCWJpSqlDnwGxgFjCKvIRn/Wqb8JzV9vyjKEjIRALQiAWEAuIBcQCYgGxgFj6Sku9gnix9MswP5JpfmlpqV+WkVHtfQNCS9lYZP4LnOdev5Tb1G6jhHk6BNhWqnD6l8i0LFRmowa54YPyVU2+PsMgDfsHipftxoLzXHqsz62trcxqjjdiMXHSgti5shMVnDy5sbEBYgGxgFhALCAWEAuIBcQSaixqdPbs2VBp+cyn8iqlDzQJbrgIxIIQiAXEAmIBsYBYKCCWoWYjuvfleuJj5U/MQyzbyKHz58+Hsmus/myt08eLZXN7K0h9zYZISQ6YpC9tIhz/dPfm84O7GzWZ7ClYTSJLRO75rbyRhowR7/IPuZ74pGNJXOXFxcWm3NFhEYtpBP+Qa/2K/K5M/tixN1KAWEAsIBYQC4gFxAJiKQ202OGQf7p7s61aA1QQiAUhEAuIBcQCYgGxgFhALIMkKBIkuWumTXzIuZAkX4G0USYfcjDxygachrs8P19ljfne+liMRFnMPxWiLYgXi3U4qM/MVu2f6E652/mNhflh+EpAa0LauJMZdG5CEEs6HHlY07BLZMfYeAFiAbGAWEAsIBYQC4ilNGmtj+fDJ0pwFS8xSTyOAC0IxIIQiAXEAmIBsYBYQCwo2yB+9+/v+ceqcjfW1tZyUIeld5bTVt0c56NJ0ZUfXk0fyD2iSdfhP+HUz0VKRqqpkQ1mFcQUpV+p9VqtVh26k/LTpK9g7nZWzDGz51HntMq445lux/3tys2hgpWNE2JJW7jCGhwtp1xZWRl7ygJiAbGAWEAsIBYQC4iltLGostN7jj/tD60v75AjfIRALAiBWEAsIBYQC4gFxDKJfMV8vnz2TKjAWQMyhA9jE/c3zSeMtmnKok8Z7j1NP5pxWUeW3d3dUWdZ8n2xjWb3kyNxiC02X0glvajfdfS0kriRr0c9JdvCPnDFbqhSjZhXFxEoLIipdHAsOCVlGW87BYgFxAJiAbGAWEAsIJbSRqTr6+v+aSYTPweuIBALQiAWEAuIBcQCYgGxgFgOmI0oHJNPzowEKlCcqMFzj3R2DcM8giycVxrtzPwoiYPKaO65rs1uGBeHwfVNZEqfm5tL7yd3+1+8NJfGZpUgFjuNDxJganV1ddTZrP0z9QGTZCgIV1BJGGvGHrGEMnINGeZOnBLEAmIBsYBYQCwgFhALiCVIle30xDMLi/0EriAQC0IgFhALiAXEAmIBsYBYDpD16vCfeplya231QCO4O0uRR3+mgTvH1Ej0Yhg7uIkV5hMYzX6KcAzzCHWt/7OzAeBKIoxVHXTlypVEovvcVTtz5kwCUI0KfkySoVAWTFWt/jdy8EBhbiDyIkzDtpikLAQKA7GAWEAsIBYQC4gFxBLwXg7iwmJD1w4zxUAIxIIQiAXEAmIBsYBYQCyTKy0kDxUoTBuKFdZv7pH5/blz5/wzRhg3msz88+mDaqaUbxqfyUV2dh8PPqL7TxPDytMq/fQ0Zmet106F/ivS1v3tr3l4QSUMc4uLvnYfhZ+SS1Ni/z6WBVWw5rPrsIHCCi0mkax7af7b6q32EM8KEAuIBcQCYgGxgFhALCCWAeNSBQoLdRfb/dy5c4e+hEAsCIFYQCwgFhALiAXEAmI5YEJis80HWZauGE0DLKSJxOz5fGj6RaPKjBKWWet01hA3s+VIoMX1I8l003HrPvf6JX9zv03cUhPvClVWlhpPryC3Vd3VgsOb2hN/eeHChYDZRFxT1CTkYinaNGxDC5p/6qFhINb4rQwFsYBYQCwgFhALiAXEUtqIVDjEp6buRMD2Q3oUArEgBGIBsYBYQCwgFhALiOVgyQ/DH664tpVbt251+mcHcb9RzK4gAbtksRW9ONDs7h434UUxzGlkWo5sNpQDD6qcE57eQgnnDzdhSbX6g1Pf8Il57ZpUvj93Md15Rk3Hoo2bN29mOh7l628vnz1T87u4QYgljdb0KV+6RM6k8cAtIBYQC4gFxAJiAbGAWCq5lz3fbrZYL5byEx8iBGJBIBYQC4gFxIKJH8QCYmmGzDxBdu18JnLjUZGw9SS8KzInJNabJAja0aKz6zdWBsx8El9qyXzuxOxpMGC8ZwYfVxs6Q0+Tk2t6MN5CdZjpqV6583a4Dg1mY/3ObZ8aub+1Se/T1zpHZ1M1D6RoIJaRTMPu00Nl/s2F8XvAglhALCAWEAuIBcQCYiltRuMfKCw9zq/t2A8hEAsCsYBYQCwgFhALiAXEUq85iaJdBbHy2LA/w6zzEucwVnX/xCRpznHgRMhkoDG/NYRgeEcWe9rmMzMHTPoc8nGsfhYr2aMHewiVJs9cPmp8256us0juutgfqoky3YDyXYKaWxaaiFjSHfvW2uqYPV1BLCAWEAuIBcQCYgGxVHIv+1TWJI0z3wBXEIgFIRALiAXEAmIBsYBYQCwHW6LN9qlvnvZJDZIIXixT6YHeJMoB4x8lzGxcvHhxeNJg8sEsLy+nrVTDzOrdvzG1dmNb9WtqESD/+Z5b5Q/ubnRGD6UVvP/oNIIADPO5tLSUoyL9GsFk+snnq5TZyTfu3QWxhDINJ2JxmH/qKbS1tTVOtgwQC4gFxAJiAbGAWEAspQ1NFdTLTVuYLz5Y4hnbyRvAFiEQC0IgFhALiAXEAmIBsUwcaLl8+bKn3d/dvnz1Suax3ClKqChhUc75lZXBOCf9pezv+vlXvvbVtMF31HOwPjQDJD8hGwsrR5VdvxmValODuA37gyuXQwW81nZmM46aiCVhaQ1l7+vXq0Es/qDFdgP184QFp+lWDBALiAXEAmIBsYBYQCylSYt1cnehtH+tmSbQkRCIBSEQC4gFxAJiAbGAWEAsw1ql19bWQsWwMqvRBx9aa9X902MMQzgSzjruf1KEq8R+Rs3Rbb8XQRlc34uX5szffyWENe2txWt16D/GNcfHlObW68oPr3aGS6UzvFZXVwcQwRyd/ECWBmLJHWDQ/qfFxcXx4CsgFhALiAXEAmIBsYBYytTbb7/tWV+3+2lDkwU6EgKxIARiAbGAWEAsIBYQC4hlBJ359tnMNCf55ie3bt0acCzF6fI0edtP0Yt89VWksjQ7yXc+OgfXQScRT2B3d3d21teFwt2QC04dOowMND4BuBKNX5BNRB4/ntfXnXLXyiZVMmJRXDz5UkWffUBjJjLJV9bv3O6XaqhZ3KW4HDaJlq+wuCc5HoglHUCy/pRLYLLyWwPE0i/QUA2Li1jqEPsIxAJiCdaXLlzwHIckft6IWiMEYkEgFhALiAXEAmIBsYBYaiSTHjxIag0VRR6zezbpT1zlzpHuJkEx5fqNlXx2ga372wNW049aX+vfkD4ZxTEL5e1Rq/V0YnKephAbPE1R4woy7ciK5Gnsc3+rKk8sYtF1MiWRi8htH/fG9Gnqb5w+JTCZSVkmFrGkbbW1cqQwG2OAWNyIjk3xZsCLpW6Ixf+lU7IXS+XPVRALiMVfphtrnJY7Km9ilmH6oSLi0pEQiAUhEAuIBcQCYgGxgFhALCNI2bzdFJGe679OnTrlznncCbzJg5L7KJr5uNOnnd2csZvaHvlg0vW9ceNG5mRPmpub83QJcs0NBwYlK0eqb3pBfW5r1BsL87f/9s4vbq/fDi01V0Bw2C/xz4QgloT96+LFiydPnsw0LPoHjhtgymkQZSkie00oK2QRAd/GyYulWYHa6hA9EsTSz9usnj3KIJaaPE5BLCCWIDIBbEN5ydcHYCMEYkEgFhALiAXEAmIBsYBYmqRWpy3kYCYVhmH4zMoEQvrFCjMRuoLkYrERuvJJZqlQk8/vz13sN9/zXNOaCDxSk3QgxiDiaURLrzQMaIpKBGfzsfu7Rp9XXr0wmYjFbQRduCtXrnR6eWXdCxrEkcXGPkowlcZlZynUa8Q8qKvlK4lvxjJQWP0zstQkrwaIpV9sz3r2nDoElwOxgFhCyXTmW2ur/kNud4AaxT1eW6UjIRALQiAWEAuIBcQCYgGxgFhGUzo9iY994erVq5lHsb4j/t4PihLmU9+NjY0g/g3GspwJP27evBlqvfkAkFOy7t69m7ms3tNqX5xBKpTJzGyr+pOMWPR5+eoV99Dp6xgq85C1lDUOrgRHLGYtraiwimyj16S3F+tQdD52uyY+dp6Bwhrh1JIwRqvxycVSH8SiUEXmPpXcG6RG5dq1WnEIEAuIJYjkEu0TSzPz8fXB3Q06EgKxIARiAbGAWEAsIBYQC4hlBMlAc//+/YBLd5VQIX2I7Qf3g+RsMMVQDR/T0rfOvOwZ8OppCKmeedGNjSYo4m9ysqeXDkdWiWRhTxjT8wVkcNfgB18znthV7i6XXtLuAoaJQiym+ld+eNXt4Ts7O6dPn/a3SifgijmcLJU1cduqA2Jp73+W1ufFUbezChUorM5JyxMVlMW88mYHsdhiLNFP3e/qPfADsYBYxiQXSy9HYJBwx5lvXoRALAiBWEAsIBYQC4gFxIJGm+iGWvi/urqamMD/eHkpYbHKbfIO4tKxsLBg01p6Upb0+dgoYUHmt2lkVYmU/CZgLJ1CkwOn87EHmXKf+ubp3BmAmotYTCOY+GAJ85y1TgYJyJb4pzK+1JArlI9YVNr78W0dWqOeMdz80927d73cLvVarKEuXLigT4Uu1OnVgb6DWNyIefW5SRsBWkAsIBZ/yd0kYJQ/W2UQCwKxIARiAbGAWEAsIBYQC4glzxxbobcCpjH/wZXLiaN85/y5sBnmc5sGzA/dmFf+gQU+frzjHkJnGARWmSLrdh3sNQp7EsSUFiRRykiJK0KtaldRSL1JQyyqu27eTJ8SdcuFv3wzVIzBRGc4efLk8vJyQx+qYS/B08dduy7vi1pZaYMgFveJZBz11u/cbtf1fV2rlgexPPViuXChKc+odqzKTwPEAmLxl6KE+d/FifVD828ugFgQiAUhEAuIBcQCYgGxgFhALHmksD9B0mOYn2u9v7vz7e3tdAr3UctX9yd+97cOvHz2TJApmRsrzGhubi5gAKVqrQa2nU1zNSspdChUY6upRqiVcTMkYpl9Ue4/Kgm2dO7cucExu1x6mumc5HOL1TD/TSWIBZWDWDDXglh84Fz9U1bUTSAWEIv/GFUzjuCRZuWLTy9CIBaEQCwgFhALiAXEAmIBseSUUk0EWfVvJsnu/GRpaWlAaKCRAkApOkqo+pr0mEGqbL12NNmzUcKCcAgFmK7EoJ9YK62rWecU0KURl3QQvGpZS0DEEsEVQ1l6EZNc/5V+1dT3W/e3ZeBIhwH0z9nT3KQsIBYQC4gFxIJALCCWgoamdsN6jbtDF/8q7+7u0osQiAUhEAuIBcQCYgGxgFhALDn131Zvebp0uL91kzecP38+SKBzTZ8CRmrauHfXP6qM+XS9djTfC2Vy0q/Egao16JsjJmyXY+/CkllNs6Gm6IyrF0vPg83mohjSY8zaOGw2iyCJcBK5lxqUkQXEAmIBsYBYEIgFxFIEX3F15swZ223cDIs+0UoDruVCCMSCEIgFxAJiAbGAWEAsEyR30uKuRve0Stsk7VtbW2njS27koL0dOOMaXor75NqUfeprvHZ0PrIIB0QRchHoVO3FYuK8pWsxIYgl/Y0aJFQPrBFi6TmKmTr2y7/ST0KqNsBgqP5vkY8yRTXroQpiAbGAWEAsCMQCYil0gGqWdwRf+mPywDVoVQdCIBYEYgGxgFhALCAWEAuIpXZSrLAgSV/NHtbW1rRP+Z0kptC5V5nJ7Bt2eqaElqFyY6rpogd1KkqYTy6WUPX11J9f/kFmgo2Jig/mbqhBamVTDl5Z67+Seddk2h309wrq5e7EXU/qeZeJ15qkLE0xeYBYQCwgFhALArGAWAqCK9LO7mMtkwqS9c3W1IxbEmu5EAKxIARiAbGAWEAsIBYQCxpZsmMGie1jNkyGEplr03Al3/6X/8s7Yeu7sbHhbwI2vzWxwhJRod3w0DlKwKhoubWzs2NSiQaxoDXdl8VeazXLuCIW3bA5aifDR+Lp4Unjotwwzj/znRWIBcSCuRbEAmIBsYBYxsaLxVCWdm+NlAbY1vs2iAv+uXPn0jgHIRALQiAWEAuIBcQCYgGxoNEmLZJZih5kViZL9Ob2VjrMcW6vDq0sCzXnsfv51pmXc0ctS+CTW2urc3NzAR0+3IBUVU35FDAhsUhwchxZBlTcxJEYJ8RiOrPuWeMvMsi00b8T2t7iz1Oj3DCiLLMvusi2KQYPEAuIBcQCYkEgFhBLSKwSy3zzi9vr6WeO8UHJV2ykU6KEIRALQiAWEAuIBcQCYqGAWMLorcVrPukiExZbM38OsrBdy9iLqK/yyXsuebMbFy/NBVm/b4poTYVzPHvos2fP+hs+xgm6mHZQsyQaqumIxTDRBF9pD91PrJQnNn0X5HmeGL4S+7LYnzclKQuIBcQCYgGxIBALiKUIKTCpQoQlcrYZTOKT6zEqs7PaOXwFgVgQArGAWEAsIBYQC+0PYgkgeU70s5WUY2Tvlyvb9RsYnBZiJJnoRtUihLR9QZ+KOTaMRbtQyrK6uhowg+iYebeocWpiUw5VgtRI5onTp59GlnNJiX+UNiVlqYNrF4gFxIJALCAWEAuIpbjx54D/qvVMRQzqoqyKly93hnDYRQjEghCIBcQCYgGxgFhALGioKY2yrPfjKyWY2tOL382nMa26c55Q8x+bMLOSQFh2/Z17XJmS0/nGy+wG5tOaP8Aq6V6qSX7lM/CwgcLW19dDGXee9plevC9Pw4e9U/R0qjlfAbGAWEAsIBYEYgGxFAFarly5UsSg1OxTCRrrPLRACMSCQCwgFhALiAXEAmIBsTQGrkitVktZ5d2Jh4lubElAOYgl8VlElDBba8UKS0zsy4QKbkIXexpKOzHkbLM4KfMNfGUwAkxjv+YiFpU7d+6E8g+z91Q3iMfoXiyJJ4Db7Np5zY0gIBYQC4gFxIJALCCW3IPzzPf70jvLQW7YzJoqzCk9B4FYEAKxgFhALCAWEAsFxBJySrOzs5PwICkzWlSmaVXTqsR0y8e6mvjtxr27/cKUlePF4qboNMe9tbZaeaSCy1evECWsX9El04Wbf3OhDjblUPedjDIBe52waLp754+Qvp+y1CFKG4gFxIJALCAWEAuIpRzQsvgf3y5osZfZp+0/uLAgEAtCIBYQC4gFxAJiof1BLMEmNsq1noYr5TiyZNpr5FERauaTuU7fxgrrlweiNC8Wk3V8wKmWM60VZtNpwFcGXDJ9qomqiudWEGLJvFPy9SLds4p3Z1iUv+0y8aVafnNzM8ipglhALJhrQSwgFhALiKVyxDLgVa4sKYWu+krXEdCCQCwIgVhALCAWEAuIBcQCYvGa0ph/Ktd6ehpTvrXdzLfPny8wSpjZeOONN9I1LTlcmK3vwsJC5dO8lZs3gsdhGL9AYfpUQ40HYrH2qYD9Tb4mQZo605eliOCBIBYQC+ZaEAuIBcQCYqk8UNhTA8jjxwrhlRE1dPQApEMuMQGuIBALQiAWEAuIBcQCYqH9QSwBJjP2S61Aryo3SeJwS0tLQ552vrrr8969e1VhpPS6vLt37xZU3+F15ttng5g8xhu06FP+T+ORiyXtxRJECjeXO1BYZt9zQcu1txdBLAjEAmIBsYBYuGfHA7G465+0tfqzNU1GEhWJ4Mrsi1EJ9JK9dOkSfQaBWBACsYBYQCwgFhALBcRS1PRGGdfdBfslp2NxZ9omqXgo3tDvt7KVZwKP0rwirMk+x8kXNDmv0IGpEelYKjfr1B+xaP3pd86fC36b1NymBmIBsYBYQCwIxAJiya2t+9vfn7uY7hXRtuEr4RBLepaBEIgFIRALiAXEAmIBsYBYQCzBtH7ndnLhWFl2dtdkU1o4IC23ryRWWILoLC8vdyoNU6ADX7w0F+qK15bNBKyamstcrfKvWhGBwoJLXlknT2bjOn+bppsOpz7BPcL2VUKWgFhALDVHLGYPFy5c6BBlCMQyLojFrnbyRCzD3BGu88ru7q5cVK3zSshhZAxmEhHG3lq8RodBIBaEQCwgFhALiAXEQgGxFGtqN44dJrm3f9rqfODhx8tL5dT31tqqTWOuQ5dZWdeyUPliOq0cdF00fEwelefy6Rd1ytOa4/7QNJQaLdOaULStrbaIJVFxxfqzTWfvrNyNn/hGjZDPpgNiAbFgrgWxBPRiUcYI+kMliMX8an19vQPiCoRYzLUw7+sivFgSCRHNhgbASkZowhSbwVXYcaONMGb7m1Zx0V0QiAUhEAuIBcQCYgGxUEAsheuNhfny07+7dnDN7rYf3C+tvm7E59JykLgHUkilCi+3mejOv7lgWt6d4uZoCrOTudcv1c3eobO5fmPFtfXnu16mccxO1GgV2pTr6cWSMKDMzc2lb/B87Z++HIuLi+njVqiwz4dWp90pF901VCCWSgRieYp7v/dau91u4u1Z1TmH9WK5c+cOLe92bE/EYsdI/oilXzXN9x8/3lm5eUNHSa/ICTwUj+GKu/ONjQ2e4WjsBWJBzRCIBcQCYqGAWEAs4y1F+AkY2CdHIpbSooQZXblypZIcJLbKKysr1U71FXPJrB8MwtX027W1NTuLrtzw5J7AH5z6RkAHHTWamq5841ojAoWZlt/Z2Tl9+nQQ16hEriY3kUxNehq5WCoRiKUSgVj6ebE0F4WWduYBvVhUFN7WrcIkg2hPxJIIYBvKi8V9QWtIoJNUkC6N8/v1AS1kCezFsn9s7y7OQGiMBWJBzRCIBcQCYqGAWEAs4y1NhEyq6jK9WNwJ89I7y2XWd3V1tfzKugcyZvoyr2/C1UALCTMtZfm8Dc58+2w6FkRNjEfyOwkyRbfb8oypyqZcZ8TiXnftP9F6Nh5d7rz31hyjzmaSsoyZFwuBwka9HUAsJQvEYvcgY7Gs/ApXJXcK7VkbtxuiX9xev3fvXvnPz7BeLMqoJ5O90niYou3Fmsk9sRs3btQcsdgroomAekiOfmXvBWUZvHYtqrVWMulBbVzGM31WEvdj8KG43aHlRniFIhALQiAWEAuIBcQCYqGAWMqQ5kXFTXUONKGWmZjEzLISC+3LBC2KpFTtTE/xiGSnTtTdZ1Wpm0enVpNYnczW1pZ/bLeEx1WrQ7r7AyQji//NlZnjR5/fn7tYk/5WkJdbotc1ooBYQCwT4cVy8qW0mfjkySbdqq4LTuO8WDJjSFaY++3AfhK5hly40KlroLB+ifRy9Kt09rXBcCXz5R78fXrqm6dLXtKEEIgFIRALiAXEAmIBsYBYJl2CHG7eyzIdO14+e6b8Cb+JFVbyFN20rXxoyicN7j+1/Hb4HOMHV2p2dnd3tyaBmzIli5J/LpB9Ntm/vdPJSuI6aYglcdET7SAWZZ4knrlYrPHFteAsLdWC6gW8KLZ2aUNVIwqIBcQyKYglzqTdxJvUTSRT8vMzbLr7dISr2rVznGs9KidnX3vtteIa2R+xpBdX5dibeW0Ng09KW8tl9q8wyDy6EYgFIRALiAXEAmIBsVBALGXr4qW5Ctb6KYX4/Hz5plITK6z8orAJlduFdaEDJqERrKptl86Miua/clZRSsjFcqCRbnN7SwtI/WPyZBprpDqYTgoKnNhE0y2IBcQyEYHCBFdixFLc6vuiS9O9WBrAVxwUFwWqqrEXS79Xbe43Vz9Po8FeLMFXO5ld3bx5k+c2ArEgBGIBsYBYQCwgFgqIpQLJEl1+IhZ9msjg5csEiQ4SnH0kIFEJXLEHleHbJ81seiasANyVQ6MDderUqcw5f+6mUDOWWevGBQqzIFNOTqbFvuIYcYIQPgW7k/vUmCGW5hYQC4hlQnKxNL2ESmleIWKhwYMjlqaW2FUooln7KZEWYRSaAgchEAtCIBYQC4gFxAJiAbGggQ+fx4/LXBho5tiyk1ZVX/kilMyTVFxzXmlMwj2QUrAGTP+euHy1pSxKDZJ5rXN3ADVjmbVuKGLpxBH5+q049gkUc/KlaHWwm5QFxAJiAbGAWEAsIBYQy6QhFhO4zw10bLyry4zmihCIBSEQC4gFxAJiAbGAWNC+6YeoQ8mz3zcW5kue/NjD3VpbLTntgQskyp/ymSNa3x1/L5ZEovsaTmXtyZhUQ7LLpxN75GsKE/CttMo2F7EI3CopSzp/u3+GXnNBV1ZWKux1kBUQC4gFxILFH8QCYqkMsaQeSprIdA7KFYcQiAUhEAuIBcQCYgGxUEAsxdqjTYaScmZr5igb9+5WYp23vKFMLxbxpKpQhDnc9RsrQZCS+blab2f3cWIGW8+89zofZaAxyxs9DW22AdWYHQKFDSElTXHJln/kd/e36oQmKUslXQ6yAmIBsYBYsPiDWEAslaW9cZb+qCT8V+wIEMSCQCwIgVhALCAWEAuIhQJiKVvGy6FMr46qVpnpcFd+eLXMqaB8Kaq9uN85fy63dSPhxWKXCnbq6rmSgD1RXpBeFUyYKc+0rmrMkm3KjUAsmZ1haWkp4TmUG7GkLbznzp2Tr0wl/RCyAmIBsYBYsPiDWEAsVfEVd1BhvFprOC5FCMSCEIgFxAJioYBYQCwTJ81JFhYWKvTqKHlSZLx2ypmgyhBcbWXX79z2dB1IGEc2NjbcGtUwIEPiTM6cOZPpCZHbi0JNCmJJq9VqpS/BxYsXE63tOrXk6IqW2ZiFq+agJfc9yAqIBcQCYsHiD2IBsVRLWbQ4bOUm+e0RiAUhEAuIBcQCYgGxgFhALHWS7OalTY1MhJ9+BvFyjO+nvnm6nMouLy9XyB50aJNoxx8pGdP2+X/3R5nVqVWgsMRpKOl9wKgUKmpSAoUNO7Z5/PjUqVOZSX1yd0LjjWRAy82bN/FiAbGAWEAsIBYQC4hloqKEvXz2jGYT6eBglUwuEAKxIARiAbGAWEAsIBYQC3o6D9F0pYwoYWfO1KHKP7hyuZwJqollVJVMvnd/u4YNtGUykWROaGsS9joNe+7fvx/KvmP3UE7wt8YhlrR1Q586rv+N1g/PiN9sbW2VbEyBrIBYQCwgFiz+IBYQS4XNq6SAB45AEAKxIARiAbGAWEAsIBYKiKUCXXt7cXDIY5/YSnY/8/PzdbDCmxQdBeXetF9+f+5iTa6pz3W0F1ExGaolRrmliFKJfuh5rdWwIJbhbrboY3Fx0T9QW7/iZscpx6oCWQGxgFhALFj8QSwgliLGz25vccOK2j+TazIEBSEQCwKxgFhALCAWEAuIBcRSL7mzlM3tLdcG7W4ERCyJKGGd6taaFR0rLNPno5xLaSUokpiyegbIamg/dw1t/iYAFbl8DXkJJh2x9HTuj867Yb7Cmmbc9E4gFhALiAXEAmIBsYBYmpVYJXOwmkjApoHExr27tYpMixCIBSEQC4gFxAJiAbGAWFDSLtyOzaCDw/LkTpOeaZiuNrSUgEHACapbX7PsTngjHcegTL5y48aNIK4D9odb97cbOq3VOavvGeN+7lz3iWwiat50U4RtnHFCLArnJahZhEnI7FN+aSAWEAuIBcQCYgGxgFia68WS9mixKzPkvMIDGSEQCwKxgFhALCAWEAuIBcTSDDP0ys0b7mxHsxp/7wd3yqTF5vXJiL62thZ8iujaEZTupVpmpgBK/S5EjnrJXuCmXWlc915eXvaPeudeZWtAKa41xgmxSKIgwa1C9or8walvKOkOgcJALCAWEAuIBcQCYmmoL4t1WHGXtszNzZmkawNGvAiBWBACsYBYQCwgFhALiAXEUjFpcDeUaSM9Z8u96j8dKEwO/ulJUfkTJHtE5couYiGe2RbCKadqmY35wd2NIN5IdhWh8FunsS4s+tzd3Q1okjD7Kbo/jxli6ThJcYoIMCInvHJqAVkBsYBYQCxY/EEsIJawXuCJ3iLpse8+qxPjK/gKQiAWBGIBsYBYQCwgFhALiKW+lmhlaPc3ymcaNTLTV1RbWa2MK2JBvQmJVu3cTz40meGt8tVLIZ7GoHsb+35uryyzuNLdQ9HJacYPsezs7JikLMFuupMvlZ+UBbICYgGxgFiw+INYQCzBB8/2GzVg4indb1DdarV4UCMQC0IgFhALiAXEAmIBsYBYakEa3HnLrbVV1y7vmZva7kfm6YWFhbpVfGVlpaBcLGVWNp3SRt5IaRcWH2+kv5h/o9P8BYN379719OZJN6aaevC1ALGkr4LSFAWr1+yLEWWZfdHegyVUE7ICYgGxgFiw+INYQCzBA+2qXLp0aX19fcDQHSEEYkEgFhALiAXEAmIBsYBYmgBdFD7rm6dDmebdf25sbFQ4U3Jhkv00KCL4FFFcKlHZkrW4uHigU9FIVdt+cH88ZrZyoch9iUXO0tdaTV20TXnMEEsnzosT0otFfGX2adao06dPJ7gXiAXEAmIBsYBYQCwgljoHCpPz9/ybC8q5QjQwhEAsaKxsS+2etX3ryLRseZuHjz08/Jwx7Q1fHkw9u/snf9Z9K0R7HMKBsWWP3pL1MNrJkZlRj/sPR489mDoh++On7/600zI2pINsadGR96KNlj6i83z4xd8b9bg6Yvw5s3X4xObh4/ms/OY320dn1OaCK9qVdrg58LjRXx46/mDqeR00arHD0w9/51/ktb51nlz/6/jandiM96yLOGo77Iqr2cvdNh+tgy9BfN13vvunakZVJKr7iMe9f3i6i1ieHqvVHnjQvW6fa5mjP/zC74960AkssZV/Wh0j7pbH4ufD8TyIpdV50tlTs3/0O7+3GT8uPjysbnyCFj6w/eMbJH7A/vG/bztPbBRWNp6Svz3Ffp759tl6VvbipTlPmGRX03cX1KuyZ85UyJD0f2rtIiwFYV00KpH8lsJaedTU7SxvsDD2qQsXAl7H9Tu3E7mXqrzvLl6cnc0Iwu4Zw918vvLqhbAV3JdrB8RSEWLRZdUD1joteXqhgViGlNIh9PPhG4FPv/iSi1hKe/7oKpvnTJoSTVSpCrFE92wqLd84PxKdcaCQcHENe+fOnagxeysMKndAGezvm/k39j/Jq/Xy5curq6sAFYRALGhc1er0HBpk7BbniC3+o6223j7ynDBJu5OAK63+Fu9WbLdoGaPhznfl0BABhlGPKyvt/UMz20eP/2rlJ5YcDLS0m+MawrJnDO4ffeFLuRaYT28ejazPMvfHFvxWDtunfuHYmo8ZW+rmwAX+Bks8PHLcuLw8+uLv5b7on7x7c3vqmCFkhhiN2ggfv/K9dvJytw4mXHFb7Xa9WKZz9Lf7U8+r3bpdqHvJWwMO3TIX3NEvv/hlwSr8JA7o5Lorj86oy8X9PLrX1O0/WfnJ6P281Y5vuF/+s983fVjPGcPJKIOeb70m0jPh8Xdf6+Rnuehgq4T/ws/EzEpr02pqc795I8wqXTPRjee6WqRfSV260c9u3gg7hV792Vp9TPOe7aOk99ZJK1RRg/u3TCakCejFoi79i9vr9bmIcjQ5e/asdQ8KG8BNn9euXQtV2eSK2t66fkrJiCVaEe88Zj07DIhlyM6fdkjN0eZfOdn1M+sUBqQHDGb6WXgnDbGU/+R3vVhcq/rYI5YolciFC8U1rOJo1QGxuOsbzHt8wHA68cffOX9OAXUTZKXMhwNCIBaEykUs7/700dTTWFWjrraWlXz3j//UNf/F3iyDEEv30LEvy+NXvmds/SMfN/bkUOmurG8fYGrvulC02+a4xufi4e/+85EPHQGh4123khixDOW4k6UImcRuMcacqnYY3P4PjjwnxKI/2zyiKzWdM1BYvBZ+9/pNg4h0dDcw0SheLK85K+tbnd6C4gP7W+zF8v2oAY9O5/Bi0QkLMsWHizhZa4i1/a3Yi8J4WWlDtn6cJA4sHxoXisPTIivGqUId5tN3/2seltixzkPRrjZjDzBa+MDnjPGT2zrSC8qHF0thksN+YkqcY0rvTqjcFfS10s7uY1vBxBRxtHLyJWsp3t7erhCxmHWjoYp6whjcZe68/QdXLoe1XqnBg5vyzbZsNAFNbLf/9k6tUFnXSLTfDSVHvTKNPlp6r/0HrObTpou9WCbNRNuvlNlhdKN1r28cFy7H+8h9MYFYhhyu2mxqX/UbD1TixaKBhz36V7wdc8cmblVp7a+DpodV9psxLLH/SrfBi0Es5trtWwgVE52q0F0mQcn8Up96hmu5lbCKHSQPYCqAFoRALGhM+EpMG1q7KysPD//Go6muf8bo3iTP7l74U1mx9/bZVPsjlraJ29T9vzgXywlr6B/Beyb6yYntQ899ev1GexjI0e6+wPYcMPDgC//LqMc10XuM6VPGYsXcMsAmR/vfn/qNKOBYZFGd/jBmJ3IJ6nvoQzOb8R/HiCVy4nnwxX+Vh+5E7bD36cr1KEpYry6RS9CI7bD73UsdG3vrgFhd+63t7T25Lm1OPaeek8N7JnIhmprpqNk7LtcbwFeeerHEf/zkAblYhs82dOhpb5fF/5OV67lmrWr/Jw8j56GuWwzpWIZ4vh3r5mI58hu/+q4iMT5J+2OhUJqfn9+3Qnx25Pn8iy8+TUCtOAB1Nr7Pzc1FNexNC3OvqVcKlqKXLh4o5YAxdQlll7n29mKje3J6Aq9064FjiM/OFpF6R+dcRC6WNMipUCZp0FOTzWye9rc37D5rzte+pqQsOzs7AdGX3cCLpUwvFnsL63ZwL/doD+eTJ00uJUvgQCxDNn7CbKrXXH5Xs9nZkh871otlAnOBJNq/0LhVA7CoOoxLWSahqc27rIgGtw9DdWwbwa/Chs0M1Gnu9PPnz6sFFAFMb/m1tTU7RoKpIARiQZM2luza61qPPhJlkS+L3EHylHd/+kTvkggz7D01ebcPgju9P2n/3T3t4ZPrIx/9k5Ube+/+5Fc3bnQefjSsndfggHYXL+n/937281GPu/fuDfGJJys/3dNp3/jrlolAlucCPFEVombXft69+eTGfx18CRSjSQc1f78X/2Xr/b/JYXKNXTpaajTt0BxRkdZURm6HDzY61idpxPq3Nv7etGTUAqP3N30+pVqtA5BeCu+1nrz3809WfpKzt09Oibr3T9VQ6pyfrvz1k/8n+rLz6FGe54zpdrrXcj9kJq88WbkZ3e+9e63b4RmQFyPFU9Ia8Ns9Ke7z7dGlX5mdVJv7/UBpPZ2toBa9arH/+p08lY1+vr6uXJ3/f3v3opwmGgBg9P1fsW+yXSFrVyGYadUPvKR6zuxk0pkV9OcW+RSeeDps+Vpu4t53Dn9Ka/lxU/sB3w/7Pc4O7GvQCy/KL8tiucNZsel9+efh534/tvH0zW+L1A8mj1xhDpvDfFhJDg/Z/5wf/jJ7tns7jNhy2FccYuZD6rwpPeVeZTzYvM1u2cP/RZabyf6132OtO0xz/+mBec922z/5thx8l0eE3x46bYYgsfB+Tm4Rv+HD0b++x7H7vErYcWpnL9g1nRc/PoFx+mrLipO3x7wxHC/9dXa+J3fwHHfjymE7DRbbP1c+HmrXeM2rPXSCY9gY1s/xMJ3d52isn8j0y3h+OuPJo6bFP4ybXsLx1+HsfIcvc99ybbe3Mi+mYRiuSqd/nM5xW/PX5ro1fN7WjN8DzkdsPzX5toP2lEHY752cpXrkq7jJgL/nqYcvZ15WD8KXTe9P03F+5z0PRo/cSb7DUvBavPCnb8JG+5uM5MWn4XAM9yax8M0NP8dh6h2HVLDqhPe4+Hk82X1hOsvUseHT2cNyiuOVnWBcznQ3rjnVPkzfWznevH23/s3L8HmprUsTGZdFbL7T+7hucf26hcnnTFct+d3i7ibDvAzHczNerCm/ZvnPdLGvFbOehmv4uLi6HS/lNswLb/RlgLJ97Y7rx7BbPW7Ha/QNh0tdDYb/6u102jvP39RyouQR751ufsvo135X/MS+cqdZv8ydSO86Mred1APG+cWamVM273AwutXDrS3vs7uwrHmx9e1b/TH22yezZZfrpveQSCx8a8cr+w/j5g/1z2foh/Hkphd/OJYsf5lCxbjuWxRzcPjYXbwhyP+zO3zZZf///9w4ePP3P4bx0gs+c0ydns/HdEOX3YXnPy23TWlqcTgf54FcuQKM45frdA3XLruPKYyt8e/HohWdn+/J9wDmh/hL5sqlNE7/DSsH7eRSctPlBOn72GUUBR7x/tmb3vc5b/KU1759IlZRa8jFKVhJXmN7/+ZzxCIwmKu/5gJcSWIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyCQWAAAAAACATGIBAAAAAADIJBYAAAAAAIBMYgEAAAAAAMgkFgAAAAAAgExiAQAAAAAAyP4D/kLy88J0/gUAAAAASUVORK5CYII='
};
ModuleRegistry.registerModules([AllCommunityModule, PivotModule, IntegratedChartsModule.with(AgChartsEnterpriseModule),
  AllEnterpriseModule, ExcelExportModule, ColumnMenuModule, ContextMenuModule, CsvExportModule, ClientSideRowModelModule]);
@Component({
  selector: 'app-cppib',
  standalone: true,
  imports: [CommonModule, FormsModule, CommonModule, AgGridModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatButtonModule,
    MatIconModule, ContainerActionsComponent, SaveModalPopupComponent, ConfirmDialogComponent, MdbDropdownModule, BookmarksComponent, MatSidenavModule],
  providers: [DatePipe],
  templateUrl: './cppib.component.html',
  styleUrl: './cppib.component.scss'
})
export class CppibComponent implements OnDestroy {
  constructor(private http: HttpClient, private userService: UserService, private gridHelperService: GridHelperService,
    private appraisalDataService: AppraisalDataService, private lookupService: LookupService, private datePipe: DatePipe,
    private signalrGridRefreshService: SignalrRefreshService, public router: Router) {
    LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-078719}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cushman_&_Wakefield_Global,_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{18_June_2026}____[v3]_[0102]_MTc4MTczNzIwMDAwMA==3d83d461ffd91d4aa36e813251f26c82");
  }

  themes = [
    { label: "themeQuartz", theme: themeQuartz },
    { label: "themeBalham", theme: themeBalham },
    { label: "themeMaterial", theme: themeMaterial },
    { label: "themeAlpine", theme: themeAlpine },
  ];
  environment = environment; 
  theme = themeQuartz;
  userData: any;
  disabled = true;
  gridApi!: GridApi;
  rowHeight = 30;
  lookupValues: { [key: string]: string[] } = {};
  fullLookupValues: any;
  public initialState?: GridState;
  dataLoaded: boolean = false;
  private autoRefreshIntervalId: ReturnType<typeof setInterval> | null = null;
  private isRefreshInFlight: boolean = false;
  private pendingRefresh: boolean = false;
  private hasBuiltValuationSummaryColumns: boolean = false;
  private autoRefreshIntervalMs: number = 10000;
  private signalrRefreshSubscription: Subscription | null = null;
  private isSignalrConnected: boolean = false;
  refreshMode: 'connecting' | 'signalr' | 'polling' = 'connecting';
  getRowId: GetRowIdFunc = (params: GetRowIdParams) => this.resolveRowId(params.data);
  exportingExternalDealID: string = 'DealIdentifier';
  private logoBase64: string | null = null;
  defaultExcelExportParams: ExcelExportParams = {
    prependContent: [
      {
        cells: [
          {
            data: {
              type: "String",
              value: logos.Te,
            },
            mergeAcross: 1,
          },
        ],
      },
    ],
    rowHeight: (params) => (params.rowIndex === 1 ? 82 : 20),
    addImageToCell: (rowIndex, col, value) => {
      if (rowIndex !== 1) {
        return;
      }
      return {
        image: {
          id: "logo",
          base64: value,
          imageType: "png",
          width: 295,
          height: 100,
          position: {
            colSpan: 2,
          },
        },
      };
    },
  };
  excelStyles: ExcelStyle[] = [
    {
      id: 'header',
      alignment: { vertical: 'Center', horizontal: 'Center' },
      interior: { color: '#1D1740', pattern: 'Solid' },
      borders: {
        borderBottom: { color: '#EAEBEB', lineStyle: 'Continuous', weight: 1 },
        borderTop: { color: '#EAEBEB', lineStyle: 'Continuous', weight: 1 },
        borderLeft: { color: '#EAEBEB', lineStyle: 'Continuous', weight: 1 },
        borderRight: { color: '#EAEBEB', lineStyle: 'Continuous', weight: 1 },
      },
      font: {
        color: '#FFFFFF',      // white
        bold: true,
        size: 10,
        fontName: 'Arial'
      }
    },
    {
      id: 'body',
      font: {
        size: 10,
        fontName: 'Arial'
      }
    },
    {
      id: 'xls-num-right', alignment: { horizontal: 'Right' }, font: {
        size: 10,
        fontName: 'Arial'
      }
    },
    {
      id: 'xls-text-left', alignment: { horizontal: 'Left' }, font: {
        size: 10,
        fontName: 'Arial'
      }
    },
  ]


  async ngOnInit() {
    this.logoBase64 = await this.fetchImageAsBase64('/assets/images/CW_Logo_Color.png');
    this.userService.userData$.subscribe((data) => {
      this.userData = data;
      if (this.userData.roles.includes('Ratings')) {
        this.router.navigate(['/404']);
      }
      if (this.userData)
        setTimeout(() => forkJoin({
          country: this.lookupService.getAllowedValues('CountryName'),
          city: this.lookupService.getAllowedValues('CityName'),
          state: this.lookupService.getAllowedValues('StateName'),
          zipCode: this.lookupService.getAllowedValues('ZipCode'),
          propertyType: this.lookupService.getAllowedValues('PropertyType'),
          areaMeasure: this.lookupService.getAllowedValues('AreaMeasureName'),
          countryAbbs: this.lookupService.getLookupItems("CountryName"),
          stateAbbs: this.lookupService.getLookupItems("StateName"),
          partnerInfo: this.lookupService.getLookupItems("Partner"),
          hvacType: this.lookupService.getAllowedValues('HVACType'),
          utilityPaidBy: this.lookupService.getAllowedValues('UtilityPaidBy'),
          landOwnershipInterest: this.lookupService.getAllowedValues('LandOwnershipInterest')
          // Add additional lookup observables as needed.
        }).subscribe((result: any) => {
          // Store the lookup values in an object using keys that match your ValidatorsMap keys.
          this.lookupValues = {
            CountryName: result.country,
            CityName: result.city,
            StateName: result.state,
            ZipCode: result.zipCode,
            PropertyType: result.propertyType,
            AreaMeasureName: result.areaMeasure,
            HVACType: result.hvacType,
            UtilityPaidBy: result.utilityPaidBy,
            LandOwnershipInterest: result.landOwnershipInterest
          };

          this.fullLookupValues = {
            CountryName: result.countryAbbs,
            StateName: result.stateAbbs,
            Partner: result.partnerInfo,
          }
          this.fetchData();
          this.initializeRefreshTriggers();
        }), 3000);
    });

    this.mergeWithFieldDisplayMap();
  }

  refreshGridData() {
    this.triggerGridRefresh('polling');
  }

  ngOnDestroy(): void {
    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId);
      this.autoRefreshIntervalId = null;
    }

    if (this.signalrRefreshSubscription) {
      this.signalrRefreshSubscription.unsubscribe();
      this.signalrRefreshSubscription = null;
    }

    this.signalrGridRefreshService.stopConnection();
  }

  triggerGridRefresh(reason: 'polling' | 'event' | 'initial' = 'event'): void {
    console.info('[CPPIB] Refresh triggered:', reason);
    if (this.isRefreshInFlight) {
      this.pendingRefresh = true;
      return;
    }

    this.fetchAndApplyGridData(reason === 'initial');
  }

  private startAutoRefresh(): void {
    if (this.isSignalrConnected) {
      return;
    }

    this.refreshMode = 'polling';

    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId);
    }

    this.autoRefreshIntervalId = setInterval(() => {
      this.triggerGridRefresh('polling');
    }, this.autoRefreshIntervalMs);
    console.info('[CPPIB] Auto-refresh polling started:', this.autoRefreshIntervalMs, 'ms');
  }

  private async initializeRefreshTriggers(): Promise<void> {
    const signalrConfig = environment.signalRConfig;
    const configuredPollingInterval = signalrConfig?.pollingIntervalMs;

    if (typeof configuredPollingInterval === 'number' && configuredPollingInterval > 0) {
      this.autoRefreshIntervalMs = configuredPollingInterval;
    }

    this.refreshMode = 'connecting';

    if (!signalrConfig?.hubUrl) {
      this.startAutoRefresh();
      return;
    }

    this.signalrRefreshSubscription = this.signalrGridRefreshService.refresh$.subscribe(() => {
      this.triggerGridRefresh('event');
    });

    this.isSignalrConnected = await this.signalrGridRefreshService.startConnection(
      signalrConfig.hubUrl,
      signalrConfig.refreshEvents
    );

    console.info('[CPPIB] SignalR connected:', this.isSignalrConnected);

    if (this.isSignalrConnected) {
      this.refreshMode = 'signalr';
    }

    if (!this.isSignalrConnected) {
      this.startAutoRefresh();
    }
  }

  get refreshStatusLabel(): string {
    if (this.refreshMode === 'signalr') {
      return 'SignalR Connected';
    }

    if (this.refreshMode === 'polling') {
      const seconds = Math.round(this.autoRefreshIntervalMs / 1000);
      return `Polling (${seconds}s)`;
    }

    return 'Connecting...';
  }

  private fetchAndApplyGridData(includeColumnSetup: boolean): void {
    if (!this.userData?.email || !this.userData?.currentRole) {
      return;
    }

    this.isRefreshInFlight = true;
    const selectedIds = this.captureSelectedRowIds();
    const apiUrl = environment.appraisalApiConfig.baseUrl + '/by-email-and-role';
    const queryParams = {
      email: this.userData.email,
      role: UserRoles[this.userData.currentRole as keyof typeof UserRoles]
    };

    this.http.get<TransformationResult<any>[]>(apiUrl, { params: queryParams }).subscribe(
      (result) => {
        const now = new Date();
        const fiveMinutesAgo = new Date(now.getTime() - 5 * 60000);
        const mappedData = result.map(item => ({
          ...item.value,
          isRecentlyUpdated: new Date(item.value.timeStamp) > fiveMinutesAgo
        }));

        this.appraisalDataService.setAllRowsData(mappedData);
        const filteredRows = this.applyRoleBasedFiltering(mappedData);

        if (includeColumnSetup) {
          this.ensureValuationSummaryColumns(mappedData);
          this.dataLoaded = true;
          this.fetchAllPriorQuarterData();
        }

        this.applyRowDataUpdate(filteredRows, selectedIds);
        this.lastRefreshedAt = now.toLocaleString();
      },
      (error) => {
        console.error('Error refreshing data:', error);
        this.completeRefreshCycle();
      }
    );
  }

  private ensureValuationSummaryColumns(rows: any[]): void {
    if (this.hasBuiltValuationSummaryColumns) {
      return;
    }

    this.columnDefs = this.columnDefs.filter(
      d => d.groupId !== 'valuationSummary' && d.headerName !== 'Valuation Summary'
    );
    this.columnDefs = [...this.columnDefs, this.buildValuationSummaryColumns(rows)];
    this.hasBuiltValuationSummaryColumns = true;
  }

  private captureSelectedRowIds(): Set<string> {
    if (!this.gridApi) {
      return new Set<string>();
    }

    const ids = this.gridApi
      .getSelectedNodes()
      .map(node => this.resolveRowId(node.data))
      .filter(id => !!id);

    return new Set(ids);
  }

  private applyRowDataUpdate(nextRows: any[], selectedIds: Set<string>): void {
    if (!this.gridApi) {
      this.rowData = nextRows;
      this.completeRefreshCycle();
      return;
    }

    const currentRows = Array.isArray(this.rowData) ? this.rowData : [];
    const currentById = new Map<string, any>();
    const nextById = new Map<string, any>();

    for (const row of currentRows) {
      const rowId = this.resolveRowId(row);
      if (rowId) {
        currentById.set(rowId, row);
      }
    }

    for (const row of nextRows) {
      const rowId = this.resolveRowId(row);
      if (rowId) {
        nextById.set(rowId, row);
      }
    }

    const add: any[] = [];
    const update: any[] = [];
    const remove: any[] = [];

    for (const [id, row] of nextById) {
      if (currentById.has(id)) {
        update.push(row);
      } else {
        add.push(row);
      }
    }

    for (const [id, row] of currentById) {
      if (!nextById.has(id)) {
        remove.push(row);
      }
    }

    this.rowData = nextRows;

    if (add.length === 0 && update.length === 0 && remove.length === 0) {
      this.restoreSelectionByIds(selectedIds);
      this.completeRefreshCycle();
      return;
    }

    this.gridApi.applyTransactionAsync({ add, update, remove }, () => {
      this.restoreSelectionByIds(selectedIds);
      this.completeRefreshCycle();
    });
  }

  private restoreSelectionByIds(selectedIds: Set<string>): void {
    if (!this.gridApi) {
      this.onSelectionChanged();
      return;
    }

    if (selectedIds.size === 0) {
      this.onSelectionChanged();
      return;
    }

    selectedIds.forEach(id => {
      const node = this.gridApi.getRowNode(id);
      if (node && !node.isSelected()) {
        node.setSelected(true, false);
      }
    });

    this.onSelectionChanged();
  }

  private resolveRowId(row: any): string {
    if (!row) {
      return '';
    }

    const activityNumber = row.activityNumber != null ? String(row.activityNumber).trim() : '';
    if (activityNumber) {
      return activityNumber;
    }

    const externalDealId = row.externalDealID != null ? String(row.externalDealID).trim() : '';
    if (externalDealId) {
      return `deal:${externalDealId}`;
    }

    const projectNumber = row?.project?.projectNumber != null ? String(row.project.projectNumber).trim() : '';
    if (projectNumber) {
      return `project:${projectNumber}`;
    }

    return '';
  }

  private completeRefreshCycle(): void {
    this.isRefreshInFlight = false;
    if (this.pendingRefresh) {
      this.pendingRefresh = false;
      this.triggerGridRefresh('event');
    }
  }

  // A recursive helper to convert a nested map into a flat array of column definitions
  getColumnDefsFromMap(
    fieldMap: any,
    parentPath: string = ''
  ): any[] {
    const cols: any[] = [];
    for (const key in fieldMap) {
      // Construct the full field path (for data lookup)
      const fullPath = parentPath ? `${parentPath}.${key}` : key;
      const value = fieldMap[key];
      if (typeof value === 'string') {
        // Leaf node – create a simple column definition for this field.
        const validator: ValidatorFn | undefined = ValidatorsMap[fullPath];
        cols.push({
          field: fullPath,
          headerName: value,
          hide: true,
          filter: true,
          enableRowGroup: true,
          enablePivot: true,
          valueFormatter: (params: any) => {
            const v = params.value;
            // nothing to do for null/empty
            if (v == null || v === '') {
              return '';
            }

            // only format if the field name contains "date" or "time" (case-insensitive)
            const fld = params.colDef.field as string;
            if (!/date/i.test(fld)) {
              return v.toString();
            }

            // try to coerce to a Date
            const d = v instanceof Date ? v : new Date(v);
            if (isNaN(d.getTime())) {
              // not a real date → show raw
              return v.toString();
            }

            // real date → format it
            return this.datePipe.transform(d, 'MM/dd/yyyy');
          },
          tooltipValueGetter: ValidatorsMap[fullPath]
            ? (params: any) => {
              const fieldValue = fullPath.split('.').reduce((obj, prop) => obj ? obj[prop] : '', params.data);
              const result = ValidatorsMap[fullPath](fieldValue, this.lookupValues);
              return result.valid ? null : result.message;
            }
            : undefined,
          cellStyle: ValidatorsMap[fullPath]
            ? (params: any) => {
              const fieldValue = fullPath.split('.').reduce((obj, prop) => obj ? obj[prop] : '', params.data);
              const result = ValidatorsMap[fullPath](fieldValue, this.lookupValues);
              return result.valid ? {} : { backgroundColor: '#F8D7DA' };
            }
            : undefined,
          cellClass: () => {
            return (validator === validateNumber || validator === validateCurrency || validator === validateNACurrency ||
              validator === validatePercentage || validator === validatePercentageLoose || validator == validateZipCode || validator == validateYear
              || validator == validatePeriod || validator == validateCashflowWalt)
              ? 'xls-num-right'   // currency → right aligned
              : 'xls-text-right'; // others → left aligned
          },
        });
      } else if (typeof value === 'object') {
        const children = this.getColumnDefsFromMap(value, fullPath);
        if (children.length) {
          const groupHeader = this.groupHeaderNameOverrides[fullPath] ?? this.prettifyGroupName(key);
          cols.push({
            headerName: groupHeader,
            children: children
          });
        }
      }
    }
    return cols;
  }

  // Simple helper to prettify group names (e.g., "subjectPropertyLocation" -> "Subject Property Location")
  prettifyGroupName(groupKey: string): string {
    return groupKey.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }

  mergeWithFieldDisplayMap(): void {
    // Get a flat list of fields already defined (including nested ones)
    const existingFields = this.columnDefs.flatMap(col =>
      col.children ? col.children.map((child: any) => child.field) : [col.field]
    );

    // Get additional column definitions based on the nested FieldDisplayNameMap.
    const additionalCols = this.getColumnDefsFromMap(FieldDisplayNameMap);

    // Optionally, filter out any columns that already exist in your columnDefs.
    const filteredAdditionalCols = additionalCols.filter((col) => {
      if (col.children) {
        // If it’s a group, filter children and only include the group if it has any left.
        col.children = col.children.filter((child: any) => {
          if (child.children) {
            child.children = child.children.filter((parentChild: any) =>
              !existingFields.includes(parentChild.field)
            );
            return child.children.length > 0;
          } else {
            return !existingFields.includes(child.field)
          }
        }
        );
        return col.children.length > 0;
      } else {
        return !existingFields.includes(col.field);
      }
    });

    // Merge with your existing column definitions.
    this.columnDefs = [...this.columnDefs, ...filteredAdditionalCols];
  }

  isValidPropertyName(value: string): { valid: boolean, message?: string } {
    if (!value || typeof value !== 'string') {
      return { valid: false, message: 'Only text values allowed.' };
    }
    if (value.length > 500) {
      return { valid: false, message: 'Maximum 500 characters allowed.' };
    }
    return { valid: true };
  }

  isValidYear(value: any): { valid: boolean, message?: string } {
    const currentYear = new Date().getFullYear();
    const year = parseInt(value, 10);

    if (!value || isNaN(year)) {
      return { valid: false, message: 'Year must be a number.' };
    }

    if (year < 1800 || year > currentYear) {
      return { valid: false, message: `Year must be between 1800 and ${currentYear}.` };
    }

    return { valid: true };
  }

  isValidNumber(value: any): { valid: boolean, message?: string } {
    if (value === null || value === undefined || value === '') {
      return { valid: true }; // Allow empty
    }

    const isNumber = !isNaN(value) && isFinite(value);
    return isNumber ? { valid: true } : { valid: false, message: 'Only numeric values allowed.' };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    // this.gridApi.sizeColumnsToFit();
  }
  rowData: any;
  lastRefreshedAt: string = '';
  rowClassRules = {
    'ag-row-flash': (params: any) => !!params.data?.isRecentlyUpdated,
    'invalid-row': (params: any) => isRowInvalid(params.data, this.lookupValues)
  };
  columnDefs: any[] = [
    {
      field: 'actions', headerName: 'Actions', headerClass: 'header-product',
      cellRenderer: GridRowActionsComponent,
      cellRendererParams: {
        onClick: (rowData: any) => console.log("Navigating for:", rowData),
      },
      maxWidth: 150,
      headerCheckboxSelection: true,
      checkboxSelection: true,

      pinned: 'left',
      suppressMovable: true,
      lockPinned: true,
      lockPosition: 'left',
    },
    {
      field: 'activityNumber', headerName: 'Activity Number', filter: true,
      headerClass: 'header-product',

      pinned: 'left',
      suppressMovable: true,
      lockPinned: true,
      lockPosition: 'left',
    },
    {
      headerName: 'Project Number',
      field: 'project.projectNumber',
      filter: true,
      headerClass: 'header-product',
      enableRowGroup: true,
      valueGetter: (params: any) => {
        if (params.node.group) return ''; // <-- skip group row
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else
          return (params.data.hasJobCenterInfo === true && params.data?.project?.projectNumber == null) ? '-' : params.data?.project?.projectNumber;
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      headerName: 'Portfolio Name',
      filter: true,
      headerClass: 'header-product',
      enableRowGroup: true,
      valueGetter: (params: any) => {
        if (params.node.group) return '';
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else
          return (params.data.hasJobCenterInfo === true && params.data?.project?.portfolio?.portfolioName === null) ? '-' : params.data?.project?.portfolio?.portfolioName;
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      headerName: 'Client Name',
      filter: true,
      headerClass: 'header-product',
      enableRowGroup: true,
      valueGetter: (params: any) => {
        if (params.node.group) return '';
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else
          return (params.data.hasJobCenterInfo === true && params.data?.project?.portfolio?.client?.clientName === null) ? '-' : params.data?.project?.portfolio?.client?.clientName;
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      field: 'latestReview.status',
      headerName: 'Ready for Client', // Updated header name
      filter: true,
      enableRowGroup: true,
      valueGetter: (params: {
        data: { latestReview: { status: string } }
      }) => {
        switch (params.data?.latestReview?.status) {
          case "PendingAppraiserReview":
          case "PendingPortfolioReview":
          case "PendingQualityReview":
            return "Pending";
          case "Approved":
            return "Yes";
          case "Rejected":
            return "No";
          default:
            return "";
        }
      }
    },
    {
      headerName: 'Property Type And Tenancy',
      marryChildren: true,
      children: [
        {
          field: 'propertyTypeAndTenancy.propertyType',
          headerName: 'Property Type',
          filter: true,
          enableRowGroup: true,
          enablePivot: true,
          hide: false,
        },
        {
          field: 'propertyTypeAndTenancy.propertySubtype',
          headerName: 'Property Subtype',
          hide: true,
          filter: true,
          enableRowGroup: true,
          enablePivot: true,
        },
        {
          field: 'propertyTypeAndTenancy.tenancy',
          headerName: 'Tenancy',
          filter: true,
          enableRowGroup: true,
          enablePivot: true,
          hide: true,
        }
      ]
    },
    {
      headerName: 'Primary Professional',
      filter: true,
      valueGetter: (params: any) => {
        if (params.node.group) return ''; // <-- skip group row
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else {
          const first = params.data?.jobCenterActivity?.firstName || '';
          const last = params.data?.jobCenterActivity?.lastName || '';
          const primaryProfessional = `${first} ${last}`.trim();
          return (params.data.hasJobCenterInfo === true && primaryProfessional == '') ? '-' : primaryProfessional;
        }
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      field: 'jobCenterActivity.branchLegalName', headerName: 'Production Office', filter: true,
      valueGetter: (params: any) => {
        if (params.node.group) return ''; // <-- skip group row
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else
          return (params.data.hasJobCenterInfo === true && params.data?.jobCenterActivity?.branchLegalName == null) ? '-' : params.data?.jobCenterActivity?.branchLegalName;
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      field: 'jobCenterActivity.finalDueDate', headerName: 'Final Due Date', filter: true,
      valueGetter: (params: any) => {
        if (params.node.group) return ''; // <-- skip group row
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else
          return (params.data.hasJobCenterInfo === true && params.data?.jobCenterActivity?.finalDueDate == null) ? '-' : this.datePipe.transform(params.data?.jobCenterActivity?.finalDueDate, 'MM/dd/yyyy');
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      field: 'jobCenterActivity.bookedDate', headerName: 'Booked Date', filter: true,
      valueGetter: (params: any) => {
        if (params.node.group) return ''; // <-- skip group row
        if (params.data.hasJobCenterInfo === false)
          return 'Record not found in JC3';
        else
          return (params.data.hasJobCenterInfo === true && params.data?.jobCenterActivity?.bookedDate == null) ? '-' : this.datePipe.transform(params.data?.jobCenterActivity?.bookedDate, 'MM/dd/yyyy');
      },
      cellStyle: (params: any) => {
        return params.data?.hasJobCenterInfo === false ? { backgroundColor: '#F1E2E0' } : {};
      },
    },
    {
      field: 'externalDealID', headerName: 'External Deal Id', filter: true,
      headerClass: 'header-product'
    },
  ];

  defaultColDef: any = {
    resizable: true,
    filter: true,
    suppressChangeDetection: false,
    floatingFilter: true,
    enableRowGroup: true,
    pivotMode: true,
    suppressColumnMoveAnimation: true,
  };
  autoSizeStrategy: SizeColumnsToFitGridStrategy = {
    type: 'fitGridWidth',
  };
  detailCellRendererParams = {
    detailGridOptions: {
      columnDefs: [
        { field: 'title', flex: 1.5 },
        { field: 'available', maxWidth: 120 },
        { field: 'format', flex: 2 },
        { field: 'label', flex: 1 },
        { field: 'country', flex: 0.66 },
        {
          field: 'cat',
          headerName: 'Cat#',
          type: 'rightAligned',
          flex: 0.66,
        },
        { field: 'year', type: 'rightAligned', maxWidth: 80 },
      ],
      headerHeight: 38,
    },
    getDetailRowData: ({
      successCallback,
      data: { variantDetails },
    }: GetDetailRowDataParams) => successCallback(variantDetails),
  };
  enableAdvancedFilter = true;
  paginationPageSizeSelector = [5, 10, 20];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;
  activeTab = 'all';
  quickFilterText = '';
  enableCharts = true;
  enableRangeSelection = true;
  rowSelection: 'multiple' | 'single' | undefined = 'multiple';
  rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' | undefined = 'always';
  suppressAggFuncInHeader: boolean = true;
  groupDefaultExpanded = 0;
  sidebar: SideBarDef = {
    toolPanels: [
      'columns',
      'filters',
    ]
  };

  editedRows: Appraisal[] = [];
  selectedRows: Appraisal[] = [];
  fetchData(): void {
    this.triggerGridRefresh('initial');
  }

  fetchAllPriorQuarterData() {
    const data = this.appraisalDataService.getAllRowsData();
    const activityPropertyMap: { [activityNumber: string]: string } = {};
    data.forEach((row: any) => {
      if (row.hasJobCenterInfo && row.activityNumber && row.jobCenterActivity?.propertyID) {
        activityPropertyMap[row.activityNumber] = row.jobCenterActivity.propertyID;
      }
    });
    this.appraisalDataService.getPriorQuarterAppraisals(activityPropertyMap).subscribe({
      next: (priorData) => {
        console.log('Prior Quarter Appraisals:', priorData);
        this.mapPriorData(data, priorData);
      },
      error: (err) => {
        console.error('Error fetching prior quarter appraisals:', err);
      }
    });
  }

  mapPriorData(data: any, allPriorData: any) {
    data.forEach((row: any) => {
      if (row.activityNumber) {
        const prior = allPriorData[row.activityNumber]?.value;
        if (!prior) return;

        const current = row;

        current.improvementInformation = current.improvementInformation || {};
        current.cashflow = current.cashflow || {};
        current.assumptions = current.assumptions || {};
        current.contractMonthRent = current.contractMonthRent || {};
        current.valuationSummary = current.valuationSummary || {};

        // ImprovementInformation
        current.improvementInformation.primaryImprovementPriorValue = prior.improvementInformation.primaryImprovementValue;
        current.improvementInformation.secondaryImprovementPriorValue = prior.improvementInformation.secondaryImprovementValue;
        current.improvementInformation.tertiaryImprovementPriorValue = prior.improvementInformation.tertiaryImprovementValue;
        current.improvementInformation.priorOccupancy = prior.improvementInformation.occupancy;
        current.improvementInformation.priorVacancy = prior.improvementInformation.vacancy;

        // Cashflow
        current.cashflow.priorWalt = prior.cashflow.walt;
        current.cashflow.priorConcessions = prior.cashflow.concessions;
        current.cashflow.priorCollectionLoss = prior.cashflow.collectionLoss;

        // Assumptions
        current.assumptions.priorMarketInflationYears1_5 = prior.assumptions.marketInflationYears1_5;
        current.assumptions.priorExpenseInflationYears1_5 = prior.assumptions.expenseInflationYears1_5;

        // ContractMonthRent
        current.contractMonthRent.priorAverageContractRentPSF = prior.contractMonthRent.averageContractRentPSF;
        current.contractMonthRent.priorAnnualContractRentTotal = prior.contractMonthRent.annualContractRentTotal;
        current.contractMonthRent.priorAverageMarketRentPSF = prior.contractMonthRent.averageMarketRentPSF;

        // ValuationSummary Scenarios
        ['asIsScenario', 'uponCompletionScenario', 'uponStabilizationScenario'].forEach(scenarioKey => {
          const currentScenario = current.valuationSummary?.[scenarioKey];
          const priorScenario = prior.valuationSummary?.[scenarioKey];
          if (!currentScenario || !priorScenario) return;

          currentScenario.priorDateOfValue = priorScenario.dateOfValue;
          currentScenario.priorHoldingPeriod = priorScenario.holdingPeriod;
          currentScenario.priorTerminalCapitalizationRate = priorScenario.terminalCapitalizationRate;
          currentScenario.priorInternalRateOfReturn = priorScenario.internalRateOfReturn;
          currentScenario.priorCapitalizationRate = priorScenario.capitalizationRate;
          currentScenario.priorFinalValue = priorScenario.finalValue;
          currentScenario.priorFinalValuePerImprovementAreaMeasure = priorScenario.finalValuePerImprovementAreaMeasure;
        });
      }
    });
  }

  private buildValuationSummaryColumns(rows: any[]) {
    const metricDisplayMap: Record<string, string> = valuationSummaryScenario;

    const canonicalOrder = [
      'asIs',
      'asCompleted',
      'asStabilized',
      'uponCompletion',
      'uponStabilization'
    ] as const;

    const canonicalHeader: Record<(typeof canonicalOrder)[number], string> = {
      asIs: 'As Is',
      asCompleted: 'As Completed',
      asStabilized: 'As Stabilized',
      uponCompletion: 'Upon Completion',
      uponStabilization: 'Upon Stabilization'
    };
    
    const canonicalize = (scenarioRaw: any, valueConditionRaw: any): (typeof canonicalOrder)[number] | null => {
      return canonicalizeValuationScenario(scenarioRaw, valueConditionRaw) as (typeof canonicalOrder)[number] | null;
    };

    const present = new Set<(typeof canonicalOrder)[number]>();

    rows.forEach(r => {
      const scenarios = r?.valuationSummary?.scenarios ?? [];
      for (const sc of scenarios) {
        const canonical = canonicalize(sc?.scenario, sc?.valueCondition);
        if (canonical) present.add(canonical);
      }
    });

    const keys = canonicalOrder.filter(k => present.has(k));

    const scenarioGroups = keys.map((canonicalKey) => {
      const metricCols = Object.entries(metricDisplayMap).map(([metricKey, metricHeader]) => ({
        colId: `valuationSummary.${canonicalKey}.${metricKey}`,
        headerName: metricHeader,
        hide: true,
        filter: true,
        enableRowGroup: true,
        enablePivot: true,

        valueGetter: (params: any) => {
          if (params.node?.group) return '';
          const scenarios = params.data?.valuationSummary?.scenarios ?? [];

          const match = scenarios.find((x: any) =>
            canonicalize(x?.scenario, x?.valueCondition) === canonicalKey
          );

          return match?.[metricKey] ?? '';
        },

        valueFormatter: (params: any) => {
          const v = params.value;
          if (v == null || v === '') return '';
          if (!/date/i.test(metricKey)) return String(v);
          const d = v instanceof Date ? v : new Date(v);
          return isNaN(d.getTime()) ? String(v) : this.datePipe.transform(d, 'MM/dd/yyyy');
        },

        tooltipValueGetter: getValuationScenarioValidator(canonicalKey, metricKey)
            ? (params: any) => {
              const fieldValue = this.fetchFieldValue(params.data, `${canonicalKey}.${metricKey}`);
              const validator = getValuationScenarioValidator(canonicalKey, metricKey);
              const result = validator ? validator(fieldValue, this.lookupValues) : { valid: true };
              return result.valid ? 'null' : result.message; 
            }
            : undefined, // use default tooltip (which is the cell value) when no validator exists

        cellStyle: getValuationScenarioValidator(canonicalKey, metricKey)
            ? (params: any) => {
              const fieldValue = this.fetchFieldValue(params.data, `${canonicalKey}.${metricKey}`);
              const validator = getValuationScenarioValidator(canonicalKey, metricKey);
              const result = validator ? validator(fieldValue, this.lookupValues) : { valid: true };
              return result.valid ? {} : { backgroundColor: '#F8D7DA' };
            }
            : undefined,

        cellClass: () => {
          const validator: ValidatorFn | undefined = getValuationScenarioValidator(canonicalKey, metricKey);
            return (validator === validateNumber || validator === validateCurrency || validator === validateNACurrency ||
              validator === validatePercentage || validator === validatePercentageLoose || validator == validateZipCode || validator == validateYear
              || validator == validatePeriod || validator == validateCashflowWalt)
              ? 'xls-num-right'   // currency → right aligned
              : 'xls-text-right'; // others → left aligned
          }
      }));

      return {
        headerName: canonicalHeader[canonicalKey],   
        groupId: `valuationSummary.${canonicalKey}`,  
        marryChildren: true,
        children: metricCols
      };
    });

    return {
      headerName: 'Valuation Summary',
      groupId: 'valuationSummary',
      marryChildren: true,
      children: scenarioGroups
    };
  }
  
  fetchFieldValue(data: any, fieldPath: string): any {    
      const scenarioName = fieldPath.split('.')?.[0];
      const scenarios = data?.valuationSummary?.scenarios || [];
      const scenario = scenarios.find((s: { scenario: string }) => scenarioName.includes(s.scenario));
      return scenario ? fieldPath.split('.').slice(1).reduce((acc, key) => acc?.[key], scenario) : undefined;    
  }

  applyRoleBasedFiltering(data: any[]): any[] {
    if (!this.userData || !this.userData.currentRole) {
      return [];
    }

    const currentRole = this.userData.currentRole;
    const userEmail = this.userData.email.toLowerCase();

    const filteredData = data.filter(record => {
      const submittedBy = record.submittedBy ? record.submittedBy.toLowerCase() : '';
      const status = record.latestReview?.status;

      switch (currentRole) {
        case 'Appraiser':
          return true;

        case 'GlobalAdmin':
          return true; // View all records

        case 'PortfolioCoordinator':
          // return status === ApprovalState.PendingPortfolioReview;
          return true;

        default:
          return false; // No access for other roles
      }
    });

    return filteredData.sort((a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime());
  }

  mapToAppraisal(apiData: any): Appraisal {
    return {
      ActivityNumber: apiData.activityNumber,
      ExternalReferenceId: apiData.externalReferenceId || '',
      TimeStamp: apiData.timeStamp,
      Rowkey: apiData.rowkey,
      HasJobCenterInfo: apiData.hasJobCenterInfo,
      JobCenterActivity: apiData.jobCenterActivity,
      FileName: apiData.fileName,
      Project: apiData.project
        ? {
          projectId: apiData.project.projectId || '',
          projectName: apiData.project.projectName || '',
          projectNumber: apiData.project.projectNumber || '',
          portfolio: apiData.project.portfolio || {}
        }
        : undefined,
      PropertyTypeAndTenancy: {
        PropertyType: apiData.propertyTypeAndTenancy?.propertyType || '',
        PropertySubtype: apiData.propertyTypeAndTenancy?.propertySubtype || '',
        Tenancy: apiData.propertyTypeAndTenancy?.tenancy || ''
      },
      SubjectPropertyLocation: {
        PropertyId: apiData.subjectPropertyLocation?.propertyId || '',
        PropertyName: apiData.subjectPropertyLocation?.propertyName || '',
        AddressLine1: apiData.subjectPropertyLocation?.addressLine1 || '',
        City: apiData.subjectPropertyLocation?.city || '',
        County: apiData.subjectPropertyLocation?.county || '',
        State: apiData.subjectPropertyLocation?.state || '',
        ZipCode: apiData.subjectPropertyLocation?.zipCode || '',
        Country: apiData.subjectPropertyLocation?.country || '',
        Region: apiData.subjectPropertyLocation?.region || '',
        MetropolitanStatisticalArea:
          apiData.subjectPropertyLocation?.metropolitanStatisticalArea || '',
        Market: apiData.subjectPropertyLocation?.market || '',
        Submarket: apiData.subjectPropertyLocation?.submarket || '',
        StreetLocation: apiData.subjectPropertyLocation?.streetLocation || '',
        Latitude: apiData.subjectPropertyLocation?.latitude || '',
        Longitude: apiData.subjectPropertyLocation?.longitude || ''
      },
      ParcelInformation: {
        AssessorsParcelNumber:
          apiData.parcelInformation?.assessorsParcelNumber || ''
      },
      SiteInformation: {
        Shape: apiData.siteInformation?.shape || '',
        Topography: apiData.siteInformation?.topography || '',
        Access: apiData.siteInformation?.access || '',
        Visibility: apiData.siteInformation?.visibility || '',
        Frontage: apiData.siteInformation?.frontage || '',
        SiteImprovements: apiData.siteInformation?.siteImprovements || '',
        PrimaryLandMeasure: apiData.siteInformation?.primaryLandMeasure || '',
        PrimaryLandValue: apiData.siteInformation?.primaryLandValue || '',
        PrimaryLandExcess: apiData.siteInformation?.primaryLandExcess || '',
        PrimaryLandUnit: apiData.siteInformation?.primaryLandUnit || '',
        SecondaryLandMeasure: apiData.siteInformation?.secondaryLandMeasure || '',
        SecondaryLandValue: apiData.siteInformation?.secondaryLandValue || '',
        SecondaryLandExcess: apiData.siteInformation?.secondaryLandExcess || '',
        SecondaryLandUnit: apiData.siteInformation?.secondaryLandUnit || '',
        GroundLeases: apiData.siteInformation?.groundLeases || '',
        GroundLeaseDescription: apiData.siteInformation?.groundLeaseDescription || '',

        Electic: apiData.siteInformation?.electric || '',
        Gas: apiData.siteInformation?.gas || '',
        Refuse: apiData.siteInformation?.refuse || '',
        Sewer: apiData.siteInformation?.sewer || '',
        Water: apiData.siteInformation?.water || '',
        Telephone: apiData.siteInformation?.telephone || ''
      },
      Ownership: apiData.ownership
        ? {
          PropertyOwnershipEntity: apiData.ownership?.propertyOwnershipEntity,
          SoldInLastThreeYears: apiData.ownership?.soldInLastThreeYears,
          SaleDate: apiData.ownership?.saleDate,
          SalePrice: apiData.ownership?.salePrice,
          ListPrice: apiData.ownership?.listPrice,
          ContractPrice: apiData.ownership?.contractPrice
        }
        : undefined,
      SiteConditions: apiData.siteConditions
        ? {
          SoilConditions: apiData.siteConditions?.soilConditions || '',
          LandUseRestrictions:
            apiData.siteConditions?.landUseRestrictions || '',
          Wetlands: apiData.siteConditions?.wetlands || '',
          HazardousSubstances:
            apiData.siteConditions?.hazardousSubstances || '',
          OverallUtility: apiData.siteConditions?.overallUtility || '',
          Summary: apiData.siteConditions?.summary || ''
        }
        : undefined,
      FloodZoneInformation: {
        FloodMapNumber:
          apiData.floodZoneInformation?.floodMapNumber || '',
        FloodMapDate: apiData.floodZoneInformation?.floodMapDate || '',
        FloodZone: apiData.floodZoneInformation?.floodZone || '',
        FloodZoneComment:
          apiData.floodZoneInformation?.floodZoneComment || ''
      },
      ImprovementInformation: {
        PrimaryImprovementMeasure:
          apiData.improvementInformation?.primaryImprovementMeasure || '',
        PrimaryImprovementValue:
          apiData.improvementInformation?.primaryImprovementValue || '',
        PrimaryImprovementPriorValue:
          apiData.improvementInformation?.primaryImprovementPriorValue || '',
        PrimaryImprovementUnit:
          apiData.improvementInformation?.primaryImprovementUnit || '',
        SecondaryImprovementMeasure:
          apiData.improvementInformation?.secondaryImprovementMeasure || '',
        SecondaryImprovementValue:
          apiData.improvementInformation?.secondaryImprovementValue || '',
        SecondaryImprovementPriorValue:
          apiData.improvementInformation?.secondaryImprovementPriorValue || '',
        SecondaryImprovementUnit:
          apiData.improvementInformation?.secondaryImprovementUnit || '',
        TertiaryImprovementMeasure:
          apiData.improvementInformation?.tertiaryImprovementMeasure || '',
        TertiaryImprovementValue:
          apiData.improvementInformation?.tertiaryImprovementValue || '',
        TertiaryImprovementPriorValue:
          apiData.improvementInformation?.tertiaryImprovementPriorValue || '',
        TertiaryImprovementUnit:
          apiData.improvementInformation?.tertiaryImprovementUnit || '',
        YearBuilt: apiData.improvementInformation?.yearBuilt || '',
        YearRenovated: apiData.improvementInformation?.yearRenovated || '',
        EffectiveAge: apiData.improvementInformation?.effectiveAge || '',
        EconomicLife:
          apiData.improvementInformation?.economicLife || '',
        NumberOfStories:
          apiData.improvementInformation?.numberOfStories || '',
        NumberOfBuildings:
          apiData.improvementInformation?.numberOfBuildings || '',
        PropertyClass:
          apiData.improvementInformation?.propertyClass || '',
        BuildingCondition:
          apiData.improvementInformation?.buildingCondition || '',
        BuildingQuality:
          apiData.improvementInformation?.buildingQuality || '',        
        Occupancy: apiData.improvementInformation?.occupancy || '',
        PriorOccupancy:
          apiData.improvementInformation?.priorOccupancy || '',
        Vacancy: apiData.improvementInformation?.vacancy || '',
        PriorVacancy:
          apiData.improvementInformation?.priorVacancy || ''
      },
      ImprovementInformationIndustrial: {
        PercentOfficeSpace:
          apiData.improvementInformationIndustrial?.percentOfficeSpace || '',
        ClearCeilingHeight:
          apiData.improvementInformationIndustrial?.clearCeilingHeight || '',
        NumberOfDockHighDoors:
          apiData.improvementInformationIndustrial?.numberOfDockHighDoors || '',
        NumberOfDriveInDoors:
          apiData.improvementInformationIndustrial?.numberOfDriveInDoors || ''
      },
      ImprovementInformationLiving: {
        NumberOfUnits:
          apiData.improvementInformationLiving?.numberOfUnits || '',
        ProjectAmenities:
          apiData.improvementInformationLiving?.projectAmenities || '',
        UnitAmenities:
          apiData.improvementInformationLiving?.unitAmenities || ''
      },
      ImprovementInformationRetail: {
        NumberOfAnchors:
          apiData.improvementInformationRetail?.numberOfAnchors || '',
        TotalAnchorsArea:
          apiData.improvementInformationRetail?.totalAnchorsArea || '',
        TotalAnchorsGrossLeasableAreaPercentage:
          apiData.improvementInformationRetail?.totalAnchorsGrossLeasableAreaPercentage || ''
      },
      TenantInformation: {
        LargestTenant: apiData.tenantInformation?.largestTenant || '',
        LargestTenantArea: apiData.tenantInformation?.largestTenantArea || '',
        AvgExpiries: apiData.tenantInformation?.avgExpiries || '',
        LeaseExpires: apiData.tenantInformation?.leaseExpires || '',
        NumberOfTenants: apiData.tenantInformation?.noOfTenants || '',
      },
      ConstructionDetails: {
        BasicConstruction:
          apiData.constructionDetails?.basicConstruction || '',
        ConstructionStatus:
          apiData.constructionDetails?.constructionStatus || '',
        ExteriorWalls:
          apiData.constructionDetails?.exteriorWalls || '',
        RoofType: apiData.constructionDetails?.roofType || '',
        RoofSurface: apiData.constructionDetails?.roofSurface || ''
      },
      MechanicalDetails: {
        HVAC: apiData.mechanicalDetails?.hvac || '',
        FireProtection:
          apiData.mechanicalDetails?.fireProtection || '',
        Security: apiData.mechanicalDetails?.security || '',
        NumberofPassengerElevators: apiData.mechanicalDetails?.numberofPassengerElevators || '',
        NumberofFreightElevators: apiData.mechanicalDetails?.numberofFreightElevators || ''
      },
      Parking: apiData.parking
        ? {
          ParkingTypeOne:
            apiData.parking?.parkingTypeOne || '',
          ParkingTypeOneNoOfSpaces:
            apiData.parking?.parkingTypeOneNoOfSpaces || '',
          ParkingTypeTwo:
            apiData.parking?.parkingTypeTwo || '',
          ParkingTypeTwoNoOfSpaces:
            apiData.parking?.parkingTypeTwoNoOfSpaces || '',
          ParkingTypeThree:
            apiData.parking?.parkingTypeThree || '',
          ParkingTypeThreeNoOfSpaces:
            apiData.parking?.parkingTypeThreeNoOfSpaces || ''
        }
        : undefined,
      Taxes: {
        CurrentTaxYear: apiData.taxes?.currentTaxYear || '',
        AssessmentRatio: apiData.taxes?.assessmentRatio || '',
        EqualizationRate: apiData.taxes?.equalizationRate || '',
        AreTaxesCurrent: apiData.taxes?.areTaxesCurrent || '',
        IsThereAGrievanceUnderway:
          apiData.taxes?.isThereAGrievanceUnderway || '',
        TheSubjectsAssessmentAndTaxesAre:
          apiData.taxes?.theSubjectsAssessmentAndTaxesAre || '',
        TotalTaxRate: apiData.taxes?.totalTaxRate || '',
        TotalPropertyTaxes: apiData.taxes?.totalPropertyTaxes || '',
        MonthTaxesDueWithoutPenalty:
          apiData.taxes?.monthTaxesDueWithoutPenalty || '',
        PercentDiscountIfTaxBillPaidByDecember:
          apiData.taxes?.percentDiscountIfTaxBillPaidByDecember || '',
        TotalTaxExemptions: apiData.taxes?.totalTaxExemptions || '',
        TotalAssessedValue: apiData.taxes?.totalAssessedValue || '',
        ImprovementsAssessedValue: apiData.taxes?.improvementsAssessedValue || '',
        LandAssessedValue:  apiData.taxes?.landAssessedValue || '',
        AssessorsMarketValue: apiData.taxes?.assessorsMarketValue || ''
      },
      Zoning: apiData.zoning
        ? {
          CurrentZoning: apiData.zoning?.currentZoning || '',
          IsCurrentUsePermitted:
            apiData.zoning?.isCurrentUsePermitted || '',
          PermittedUses: apiData.zoning?.permittedUses || '',
          ProhibitedUses: apiData.zoning?.prohibitedUses || ''
        }
        : undefined,
      ConstructionCosts: apiData.constructionCosts 
        ? {
          SoftCosts:
          apiData.constructionDetails?.softCosts || '',
        FurnitureFixturesandEquipment:
          apiData.constructionDetails?.furnitureFixturesandEquipment || '',
        SiteImprovementCost:
          apiData.constructionDetails?.siteImprovementCost || '',
        BuildingImprovementCosts:
          apiData.constructionDetails?.buildingImprovementCosts || '',
        TotalEntrepreneurialProfit:
          apiData.constructionDetails?.totalEntrepreneurialProfit || ''
        } 
        : undefined,
      Valuations: apiData.valuations
        ? {
          Currency: apiData.valuations?.currency || '',
          DateOfReport: apiData.valuations?.dateOfReport || '',
          DateOfInspection: apiData.valuations?.dateOfInspection || '',
          FIRREA: apiData.valuations?.firrea || '',
          IsUSPAPCompliant:
            apiData.valuations?.isUSPAPCompliant || '',
          Stabilized: apiData.valuations?.stabilized || '',
          ClientOwnership:
            apiData.valuations?.clientOwnership || '',
          PreviouslyAppraised:
            apiData.valuations?.previouslyAppraised || '',
          Partner:
            apiData.valuations?.partner || ''
        }
        : undefined,
      CashFlowModel: apiData.cashFlowModel
        ? {
          CashFlowModelName:
            apiData.cashFlowModel?.cashFlowModelName || '',
          PortfolioName:
            apiData.cashFlowModel?.portfolioName || '',
          ScenarioName:
            apiData.cashFlowModel?.scenarioName || '',
          PropertyName:
            apiData.cashFlowModel?.propertyName || ''
        }
        : undefined,
      Cashflow: {
        NetOperatingIncomeTotal: {
          Year1: apiData.cashflow?.netOperatingIncome?.year1 || '',
          Year2: apiData.cashflow?.netOperatingIncome?.year2 || '',
          Year3: apiData.cashflow?.netOperatingIncome?.year3 || '',
          Year4: apiData.cashflow?.netOperatingIncome?.year4 || '',
          Year5: apiData.cashflow?.netOperatingIncome?.year5 || '',
          Year6: apiData.cashflow?.netOperatingIncome?.year6 || '',
          Year7: apiData.cashflow?.netOperatingIncome?.year7 || '',
          Year8: apiData.cashflow?.netOperatingIncome?.year8 || '',
          Year9: apiData.cashflow?.netOperatingIncome?.year9 || '',
          Year10: apiData.cashflow?.netOperatingIncome?.year10 || '',
          Year11: apiData.cashflow?.netOperatingIncome?.year11 || ''
        },
        ImpliedOverallRate: {
          Year1: apiData.cashflow?.impliedOverallRate?.year1 || '',
          Year2: apiData.cashflow?.impliedOverallRate?.year2 || '',
          Year3: apiData.cashflow?.impliedOverallRate?.year3 || '',
          Year4: apiData.cashflow?.impliedOverallRate?.year4 || '',
          Year5: apiData.cashflow?.impliedOverallRate?.year5 || '',
          Year6: apiData.cashflow?.impliedOverallRate?.year6 || '',
          Year7: apiData.cashflow?.impliedOverallRate?.year7 || '',
          Year8: apiData.cashflow?.impliedOverallRate?.year8 || '',
          Year9: apiData.cashflow?.impliedOverallRate?.year9 || '',
          Year10: apiData.cashflow?.impliedOverallRate?.year10 || '',
          Year11: apiData.cashflow?.impliedOverallRate?.year11 || ''
        },
        Year1NOIPSF: apiData.cashflow?.year1NOIPSF || '',
        Walt: apiData.cashflow?.walt || '',
        PriorWalt: apiData.cashflow?.priorWalt || '',
        Downtime: apiData.cashflow?.downtime || '',
        Concessions: apiData.cashflow?.concessions || '',
        PriorConcessions: apiData.cashflow?.priorConcessions || '',
        CollectionLoss: apiData.cashflow?.collectionLoss || '',
        PriorCollectionLoss: apiData.cashflow?.priorCollectionLoss || '',
        RealEstateTaxGrowthRate: apiData.cashflow?.realEstateTaxGrowthRate || '',
        NetCashFlowAmount: apiData.cashflow?.netCashFlowAmount || ''
      },
      CashflowLiving: apiData.cashflowLiving
        ? {
          NonApartmentTotalPSF:
            apiData.cashflowLiving?.nonApartmentTotalPSF || ''
        }
        : undefined,
      CashflowRetail: apiData.cashflowRetail
        ? {
          RollingTwelveMonthsSalesPSF:
            apiData.cashflowRetail?.rollingTwelveMonthsSalesPSF || ''
        }
        : undefined,
      Assumptions: apiData.modelAssumptions
        ? {
          MarketInflationYears1_5:
            apiData.modelAssumptions?.marketInflationYears1_5 || '',
          PriorMarketInflationYears1_5:
            apiData.modelAssumptions?.priorMarketInflationYears1_5 || '',
          ExpenseInflationYears1_5:
            apiData.modelAssumptions?.expenseInflationYears1_5 || '',
          PriorExpenseInflationYears1_5:
            apiData.modelAssumptions?.priorExpenseInflationYears1_5 || ''
        }
        : undefined,
      LeaseExpirations: apiData.leaseExpirations
        ? {
          FiveYearCumulativeExpirationsPSF:
            apiData.leaseExpirations?.fiveYearCumulativeExpirationsPSF ||
            ''
        }
        : undefined,
      LeasingAssumptions: {
        LeaseType:
          apiData.leasingAssumptions?.leaseType || '',
        MarketLeaseTerm:
          apiData.leasingAssumptions?.marketLeaseTerm || '',
        RenewalProbability:
          apiData.leasingAssumptions?.renewalProbability || '',
        MarketLeasingTenantImprovementsNewLeases:
          apiData.leasingAssumptions?.marketLeasingTenantImprovementsNewLeases || '',
        MarketLeasingCommissionsNewLeases:
          apiData.leasingAssumptions?.marketLeasingCommissionsNewLeases || '',
        Year1TenantImprovements:
          apiData.leasingAssumptions?.year1TenantImprovements || '',
        Year1LeasingCommissions:
          apiData.leasingAssumptions?.year1LeasingCommissions || '',
        FreeRent:
          apiData.leasingAssumptions?.freeRent || '',
        ExpenseReimbursement: apiData.leasingAssumptions?.expenseReimbursement || '',
      },
      ContractMonthRent: {
        AverageContractRentPSF:
          apiData.contractMonthRent?.averageContractRentPSF || '',
        PriorAverageContractRentPSF:
          apiData.contractMonthRent?.priorAverageContractRentPSF || '',
        AnnualContractRentTotal:
          apiData.contractMonthRent?.annualContractRentTotal || '',
        PriorAnnualContractRentTotal:
          apiData.contractMonthRent?.priorAnnualContractRentTotal || '',
        AverageMarketRentPSF:
          apiData.contractMonthRent?.averageMarketRentPSF || '',
        PriorAverageMarketRentPSF:
          apiData.contractMonthRent?.priorAverageMarketRentPSF || '',
        AnnualMarketRentTotal:
          apiData.contractMonthRent?.annualMarketRentTotal || '',
        CWProjectionMonthlyMarketRent:
          apiData.contractMonthRent?.cwProjectionMonthlyMarketRent || '',
        CRMR: apiData.contractMonthRent?.crmr || '',
        MarketOccupancyPercent: apiData.contractMonthRent?.MarketOccupancyPercent || ''
      },
      ValuationSummary: apiData.valuationSummary,
      RevenueAndExpense: apiData.revenueAndExpense
        ? {
          YearOne: {
            BaseRentalRevenue: apiData.revenueAndExpense?.yearOne?.baseRentalRevenue || '',
            TotalOtherIncome: apiData.revenueAndExpense?.yearOne?.totalOtherIncome || '',
            PotentialGrossRevenue: apiData.revenueAndExpense?.yearOne?.potentialGrossRevenue || '',
            VacancyandCollectionLoss: apiData.revenueAndExpense?.yearOne?.vacancyandCollectionLoss || '',
            EffectiveGrossRevenue: apiData.revenueAndExpense?.yearOne?.effectiveGrossRevenue || '',
            GroundRent: apiData.revenueAndExpense?.yearOne?.groundRent || '',
            TotalExpenses: apiData.revenueAndExpense?.yearOne?.totalExpenses || '',
            NOITotalAmount: apiData.revenueAndExpense?.yearOne?.noiTotalAmount || '',
            OperatingExpenses: apiData.revenueAndExpense?.yearOne?.operatingExpenses || '',
            GeneralnAdministrative: apiData.revenueAndExpense?.yearOne?.generalnAdministrative || '',
            Insurance: apiData.revenueAndExpense?.yearOne?.insurance || '',
            ManagementFees: apiData.revenueAndExpense?.yearOne?.managementFees || '',
            RealEstateTaxes: apiData.revenueAndExpense?.yearOne?.realEstateTaxes || '',
            ReplacementReserves: apiData.revenueAndExpense?.yearOne?.replacementReserves || ''
          },
          StabilizedYear: {
            BaseRentalRevenue: apiData.revenueAndExpense?.stabilizedYear?.baseRentalRevenue || '',
            TotalOtherIncome: apiData.revenueAndExpense?.stabilizedYear?.totalOtherIncome || '',
            PotentialGrossRevenue: apiData.revenueAndExpense?.stabilizedYear?.potentialGrossRevenue || '',
            VacancyandCollectionLoss: apiData.revenueAndExpense?.stabilizedYear?.vacancyandCollectionLoss || '',
            EffectiveGrossRevenue: apiData.revenueAndExpense?.stabilizedYear?.effectiveGrossRevenue || '',
            GroundRent: apiData.revenueAndExpense?.stabilizedYear?.groundRent || '',
            TotalExpenses: apiData.revenueAndExpense?.stabilizedYear?.totalExpenses || '',
            NOITotalAmount: apiData.revenueAndExpense?.stabilizedYear?.noiTotalAmount || '',
            OperatingExpenses: apiData.revenueAndExpense?.stabilizedYear?.operatingExpenses || '',
            GeneralnAdministrative: apiData.revenueAndExpense?.stabilizedYear?.generalnAdministrative || '',
            Insurance: apiData.revenueAndExpense?.stabilizedYear?.insurance || '',
            ManagementFees: apiData.revenueAndExpense?.stabilizedYear?.managementFees || '',
            RealEstateTaxes: apiData.revenueAndExpense?.stabilizedYear?.realEstateTaxes || '',
            ReplacementReserves: apiData.revenueAndExpense?.stabilizedYear?.replacementReserves || ''
          }
        }
        : undefined,      
      ValuationComments: apiData.valuationComments
        ? {
          AppraisalValueComments:
            apiData.valuationComments?.appraisalValueComments || ''
        }
        : undefined,
      ReviewHistory:
        apiData.reviewHistory?.map((review: any) => ({
          Id: review?.id || '',
          AppraisalId: review?.appraisalId || '',
          UserInfo: review?.userInfo || {},
          Status: review?.status || 0,
          Comments: review?.comments || '',
          ActionDate: review?.actionDate || '',
          EntityType: review?.entityType || ''
        })) || [],
      LatestReview: apiData.latestReview
        ? {
          Id: apiData.latestReview?.id || '',
          AppraisalId: apiData.latestReview?.appraisalId || '',
          UserInfo: apiData.latestReview?.userInfo || {},
          Status: apiData.latestReview?.status || 0,
          Comments: apiData.latestReview?.comments || '',
          ActionDate: apiData.latestReview?.actionDate || '',
          EntityType: apiData.latestReview?.entityType || ''
        }
        : undefined,
      SubmittedBy: apiData.submittedBy || '',
      ComparableIds: apiData.comparableIds || []
    };
  }

  async onBtExport() {
    const invalidActivityNumber = this.inValidSelectedRowActivityNumberFirstOccurrence();
    if (invalidActivityNumber !== '') {
      const proceed = await this.confirmDialog.open();        
      if (proceed === false) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/activity-details', invalidActivityNumber])
        );
        window.open(url, '_blank');
        return;       
      }
      if (proceed === null) {
        // User dismissed the dialog without making a choice (e.g., clicked outside the dialog)
        return;
      } 
    }

    const allCols = this.gridApi.getAllDisplayedColumns();
    // filter out the one with colId === 'actions'
    const exportColKeys = allCols
      .map(col => col.getColId())
      .filter(colId => colId !== 'actions');

    const hasGroupHeaders = this.columnDefs.some(def => Array.isArray(def.children) && def.children.length > 0);

    this.gridApi.exportDataAsExcel({
      fileName: `C&W_V&A_${new Date().toISOString().slice(0, 10)}.xlsx`,
      sheetName: 'Data Export',
      columnKeys: exportColKeys,
      skipColumnGroupHeaders: !hasGroupHeaders,
      onlySelected: true,
    });
  }

  /** Updates selected rows instantly when user selects/deselects records */
  onSelectionChanged(): void {
    if (!this.gridApi) return;
    this.selectedRows = this.gridApi.getSelectedNodes().map(node => this.mapToAppraisal(node.data));
  }

  /** returns `true` if any field in this row fails its ValidatorsMap check */
  private isRowInvalid(data: any): boolean {
    return isRowInvalid(data, this.lookupValues);
  }

  isAnySelectedRowInvalid(): boolean {
    return this.inValidSelectedRowActivityNumberFirstOccurrence() !== '';
  }
  
  inValidSelectedRowActivityNumberFirstOccurrence(): string {
    const selectedNodes = this.gridApi?.getSelectedNodes() ?? [];
    for (const node of selectedNodes) {
      const row = node.data;

      for (const fieldPath in ValidatorsMap) {
        const validator = ValidatorsMap[fieldPath];
        const value = getValueByPath(row, fieldPath);
        const result = validator(value, this.lookupValues);
        if (!result.valid) {
          console.log("Invalid row selection", row.activityNumber + '-' + fieldPath + '-' + value)
          return row.activityNumber;
        }
      }
      const scenarios = row?.valuationSummary?.scenarios;
      if (!Array.isArray(scenarios)) {
        continue;
      }

      for (const scenario of scenarios) {
        const canonicalScenario = canonicalizeValuationScenario(scenario?.scenario, scenario?.valueCondition);
        if (!canonicalScenario) {
          continue;
        }

        for (const metricKey of Object.keys(scenario)) {
          const validator = getValuationScenarioValidator(canonicalScenario, metricKey);
          if (!validator) {
            continue;
          }

          const result = validator(scenario[metricKey], this.lookupValues);
          if (!result.valid) {
            const validationPath = getValuationScenarioValidationPath(canonicalScenario, metricKey) ?? metricKey;
            console.log("Invalid row selection", row.activityNumber + '-' + validationPath + '-' + scenario[metricKey])
            return row.activityNumber;
          }
        }
      }
    }

    return '';
  }

  /** Checks if user has permission and selected records can be approved */
  canApproveorReject(): boolean {
    if (!this.userData || this.selectedRows.length === 0) return false;

    const hasRole = this.userData.roles.some((role: string) =>
      ['GlobalAdmin', 'Appraiser', 'PortfolioCoordinator', 'QualityControl'].includes(role)
    );

    if (!hasRole) return false;

    if (this.isAnySelectedRowInvalid()) return false;

    return true;
  }

  approveSelectedWithComments(comments: string): void {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length === 0) {
      alert('Please select at least one row.');
      return;
    }

    selectedNodes.forEach(node => {
      let appraisal: Appraisal = this.mapToAppraisal(node.data);
      let latestReview = appraisal.LatestReview || {} as ApprovalStatus;

      if (!latestReview) {
        alert('No review history found for this record.');
        return;
      }
      if (this.userData.roles.includes('Appraiser')) {
        this.updateApprovalStatus(appraisal, ApprovalState.PendingPortfolioReview, comments ?? 'Appraiser approved.');
      } else if (this.userData.roles.includes('PortfolioCoordinator')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Approved, comments ?? 'Portfolio Coordinator approved.');
      } else if (this.userData.roles.includes('QualityControl')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Approved, comments ?? 'Quality Control approved.');
      } else if (this.userData.roles.includes('GlobalAdmin')
      ) {
        this.updateApprovalStatus(appraisal, ApprovalState.Approved, comments ?? 'Admin approved.');
      }
    });

    this.saveAllChanges();
  }

  rejectSelectedWithComments(comments: string): void {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length === 0) {
      alert('Please select at least one row.');
      return;
    }

    selectedNodes.forEach(node => {
      let appraisal: Appraisal = this.mapToAppraisal(node.data);
      let latestReview = appraisal.LatestReview || {} as ApprovalStatus;

      if (!latestReview) {
        alert('No review history found for this record.');
        return;
      }

      if (this.userData.roles.includes('PortfolioCoordinator')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Rejected, comments ?? 'Portfolio Coordinator rejected.');
      } else if (this.userData.roles.includes('QualityControl')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Rejected, comments ?? 'Quality Control rejected.');
      } else if (this.userData.roles.includes('GlobalAdmin')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Rejected, comments ?? 'Admin rejected.');
      }
    });

    this.saveAllChanges();
  }

  /** Update Approval Status in LatestReview and ReviewHistory */
  updateApprovalStatus(appraisal: Appraisal, newStatus: ApprovalState, comments: string) {
    let updatedReview: ApprovalStatus = {
      Id: crypto.randomUUID(),
      AppraisalId: appraisal.ActivityNumber,
      UserInfo: {
        email: this.userData.email,
        displayName: this.userData.displayName,
        name: this.userData.displayName,
        id: this.userData.userId,
        groups: [],
        roles: this.userData.roles,
        currentRole: this.userData.currentRole
      },
      Status: newStatus,
      Comments: comments,
      ActionDate: new Date().toISOString(),
      EntityType: 'ApprovalStatus'
    };

    // Update LatestReview
    appraisal.LatestReview = updatedReview;

    // Append to ReviewHistory
    appraisal.ReviewHistory.push(updatedReview);

    // Add to edited rows
    this.editedRows.push(appraisal);
  }

  saveAllChanges(): void {
    if (this.editedRows.length > 0) {
      // Make a PUT call that expects a TransformationResult
      this.http.put<TransformationResult<any>>(environment.appraisalApiConfig.baseUrl, this.editedRows).subscribe(
        (response) => {
          this.editedRows = []; // Clear the temporary array
          alert('Changes saved successfully!');
          window.location.reload(); // Refresh the browser
        },
        (error) => {
          this.editedRows = [];
          console.error('Error saving changes:', error);
          alert('Failed to save changes. Please try again.');
        }
      );
    } else {
      // console.log('No changes to save.');
      alert('No changes to save.');
    }
  }

  onExportOptionChange(selectedOption: string): void {

    if (!selectedOption) {
      console.error('No option selected');
      return;
    }

    switch (selectedOption) {
      case 'closer_json':
        // console.log('Generating report for Closer JSON...');
        this.exportCloserJSON();
        break;
      case 'closer_xml':
        // console.log('Generating report for Closer XML...');
        this.exportCloserXML();
        break;
      case 'fannie_mae_xml':
        // console.log('Generating report for Fannie Mae...');
        this.exportFannieMae();
        break;
      case 'cppib':
        // console.log('Generating report for cppib...');
        this.exportCppib();
        break;
      case 'buds':
        // console.log('Generating report for cppib...');
        this.exportBuds();
        break;
      case 'excel':
        // console.log('Generating report for Excel...');
        this.onBtExport();
        break;
      default:
        console.error('Invalid option selected');
    }
  }

  exportCloserJSON(): void {
    // console.log('Closer JSON report generated.');
    // Add logic to generate the Closer JSON report.
  }

  exportCloserXML(): void {
    // console.log('Closer XML report generated.');
    // Add logic to generate the Closer XML report.
  }

  async exportFannieMae() {
    const selected = this.gridApi.getSelectedRows();

    if (!selected.length) {
      alert('No property record seleted');
      return;
    }

    if (selected.length > 1) {
      alert('Please select only one property record to export.');
      return;
    }

    if (this.isAnySelectedRowInvalid()) {
      const proceed = await this.confirmDialog.open();        
      if (proceed === false) {
        const row = selected[0];
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/activity-details', row.activityNumber])
        );
        window.open(url, '_blank');
        return;       
      }
      if (proceed === null) {
        // User dismissed the dialog without making a choice (e.g., clicked outside the dialog)
        return;
      } 
    }

    const acceptablePropertyTypes = ["Multi-Family", "Senior Housing", "Living Sector"]
    if (!acceptablePropertyTypes.includes(selected[0].propertyTypeAndTenancy.propertyType)) {
      alert(selected[0].propertyTypeAndTenancy.propertyType + ' property is not supported for Fannie Mae');
      return;
    }

    const activityNumbers: string[] = selected.map(item => item.activityNumber);

    if (activityNumbers.length > 0) {
      const externalDealID = selected.map(item => item.externalDealID)?.[0];
      if (typeof externalDealID?.[0] === 'string' && externalDealID != '')
        this.exportingExternalDealID = externalDealID;
    }
    const apiUrl = environment.appraisalApiConfig.baseUrl + '/fanniemae';
    this.http.post(apiUrl, activityNumbers, {
      responseType: 'blob', // Important for file download
    }).subscribe({
      next: (blob) => {
        const downloadLink = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = this.exportingExternalDealID + '_APPR.xml';
        downloadLink.click();
        window.URL.revokeObjectURL(url); // Clean up
      },
      error: (err) => {
        if (err.status == 422) {
          alert('Unable to generate valid fannie mae xml.\nPlease find the Error Summary file in Downloads.');
          const downloadLink = document.createElement('a');
          const url = window.URL.createObjectURL(err.error);
          downloadLink.href = url;
          downloadLink.download = this.exportingExternalDealID + ' Fannie Mae Error Summary.txt';
          downloadLink.click();
          window.URL.revokeObjectURL(url);
        }
        else
          console.error('Download failed', err);
      }
    });
  }

  exportExcel(): void {
    const selected = this.gridApi.getSelectedRows();
    if (!selected.length) {
      alert('Please select at least one row to export.');
      return;
    }

    this.gridApi.exportDataAsExcel({
      onlySelected: true,
      fileName: `C&W_V&A_${new Date().toISOString().slice(0, 10)}.xlsx`,
      sheetName: 'Data Export',   // 👈 add this
      processCellCallback(params) {
        const colId = params.column.getColId();
        const value = params.value;

        if (colId === 'latestReview.status' && value != null) {
          if (value === ApprovalState.Approved) {
            return "Yes";
          } else if (
            value === ApprovalState.PendingAppraiserReview ||
            value === ApprovalState.PendingPortfolioReview ||
            value === ApprovalState.PendingQualityReview
          ) {
            return "Pending";
          } else if (value === ApprovalState.Rejected) {
            return "No";
          }
        }

        return value != null ? String(value) : '';
      }
    });
  }


  async exportWithTemplate() {

    const selected = this.gridApi.getSelectedRows();
    if (!selected.length) {
      alert('Please select at least one row to export.');
      return;
    }

    // 1) fetch your template
    const res = await fetch('assets/files/cw_va_branded.xlsx');
    const buf = await res.arrayBuffer();

    // 2) load into ExcelJS
    const wb = new ExcelJS.Workbook();
    await wb.xlsx.load(buf);

    // 3) pick your sheet
    const ws = wb.getWorksheet('Appraisal Report') || wb.worksheets[0];

    // —–––––––––––––––––––––––––––––––––––––––––––––––––
    // 4a) write the header row (row 2 in this example)
    const headerRow = ws.getRow(2);
    this.columnDefs.forEach((colDef, colIndex) => {
      // use headerName if supplied, otherwise fallback to field
      headerRow.getCell(colIndex + 1).value = colDef.headerName ?? colDef.field;
    });
    headerRow.commit();

    // 4b) write your AG Grid data starting at row 3
    const allRows = this.gridApi.getRenderedNodes().map(n => n.data);
    allRows.forEach((rowData, rowIndex) => {
      const excelRow = ws.getRow(rowIndex + 3);

      this.columnDefs.forEach((colDef, colIndex) => {
        let val: any;

        if (colDef.valueGetter) {
          // still pass a dummy node so you don't hit params.node.group
          val = colDef.valueGetter({
            data: rowData,
            node: { group: false },
            column: { getColId: () => colDef.field }
          } as any);
        } else {
          val = (rowData as any)[colDef.field!];
        }

        excelRow.getCell(colIndex + 1).value = val != null ? val : '';
      });

      excelRow.commit();
    });

    // 5) save it
    const outBuf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([outBuf]), `GridExport_${new Date().toISOString()}.xlsx`);
  }

  async exportCppib() {
    const selectedAndVisibleRows = this.gridApi.getSelectedNodes().filter(node => node.displayed).map(node => node.data);
    const workbook = new ExcelJS.Workbook();

    // Load template from assets
    const dataUrl = 'assets/files/CPPIB.xlsx';
    const response = await fetch(dataUrl);
    const arrayBuffer = await response.arrayBuffer();

    await workbook.xlsx.load(arrayBuffer);
    const worksheet = workbook.getWorksheet(1); // Get first sheet

    const calculateDelta = (current: any, prior: any): number | string => {
      const cur = toNumber(current);
      const prv = toNumber(prior);
      if (typeof cur === 'number' && typeof prv === 'number') {
        return cur - prv;
      }
      return '';
    };

    const calculateDeltaPercentage = (current: any, prior: any): number | string => {
      const cur = toNumber(current);
      const prv = toNumber(prior);
      if (typeof cur === 'number' && typeof prv === 'number' && prv != 0) {
        return (cur - prv) / prv;
      } else {
        return '';
      }
    };

    const calculateAvg = (index1: any, index2: any, index3: any, index4: any, index5: any): number => {
      const values = [index1, index2, index3, index4, index5].map(v =>
        Number(String(v).replace(/[^0-9.-]+/g, '')) || 0
      );
      const sum = values.reduce((acc, x) => acc + x, 0);
      const avg = sum / values.length;
      return avg;
    };

    const calculatePSF = (finalValue: any, ImprovementArea: any): number | string => {
      const val = toNumber(finalValue);
      const area = toNumber(ImprovementArea);
      if (typeof val === 'number' && typeof area === 'number' && area != 0) {
        return val / area;
      } else {
        return ''
      }
    };

    const calculateContractPerUnit = (ctr: any, piv: any): number | string => {
      const area = toNumber(ctr);
      const improvementValue = toNumber(piv);
      if (typeof area === 'number' && typeof improvementValue === 'number' && improvementValue != 0) {
        return area / improvementValue;
      } else {
        return ''
      }
    }

    const calculateLargestTenantAreaPercentage = (lgt: any, piv: any): number | string => {
      const area = toNumber(lgt);
      const improvementValue = toNumber(piv);
      if (typeof area === 'number' && typeof improvementValue === 'number' && improvementValue != 0) {
        return area / improvementValue;
      } else {
        return ''
      }
    }

    const calculateUnitMultifamily = (finalValue: any, ImprovementArea: any): number | string => {
      const cur = Number(String(finalValue).replace(/[^0-9.-]+/g, '')) || 0;
      const prv = Number(String(ImprovementArea).replace(/[^0-9.-]+/g, '')) || 0;
      return cur / prv;
    };

    const sanitizeExcelString = (value: string): string => {
      // Remove control characters not allowed in XLSX XML content.
      return value.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '');
    };

    const toNumber = (value: any | null | undefined): number | string => {
      if (typeof value === 'string' && value !== '-' && value !== '.' && value !== '') {
        const parsed = Number(value.trim().replace(/[^0-9.-]+/g, ''));
        return Number.isFinite(parsed) ? parsed : '';
      } else if (typeof value === 'number') {
        return Number.isFinite(value) ? value : '';
      }
      else {
        return '';
      }
    };

    const toString = (value: any | null | undefined): string => {
      if (typeof value === 'string') {
        return sanitizeExcelString(value);
      } else {
        return '';
      }
    };

    const withDefaultValues = (value: any | null | undefined, expectedType: string, defaultValue: number | string): number | string => {
      if (expectedType === 'string') {
        const stringValue = toString(value);
        return stringValue.trim() === '' ? defaultValue : stringValue;
      } else if (expectedType === 'number') {
        const numberVal = toNumber(value);
        return numberVal === '' ? defaultValue : numberVal;
      } else {
        return '';
      }
    }
    const invalidActivityNumber = this.inValidSelectedRowActivityNumberFirstOccurrence();
    if (invalidActivityNumber !== '') {
      const proceed = await this.confirmDialog.open();        
      if (proceed === false) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/activity-details', invalidActivityNumber])
        );
        window.open(url, '_blank');
        return;       
      }
      if (proceed === null) {
        // User dismissed the dialog without making a choice (e.g., clicked outside the dialog)
        return;
      } 
    }

    const countryAbbs: LookupItem[] = this.fullLookupValues["CountryName"];
    const stateAbbs: LookupItem[] = this.fullLookupValues["StateName"];
    const partnerInfo: LookupItem[] = this.fullLookupValues["Partner"];
    // Example: Fill starting from row 2 (assuming row 1 is header)
    selectedAndVisibleRows.forEach((row, index) => {
      const rowNumber = index + 2;
      const excelRow = worksheet?.getRow(rowNumber);
      if (!excelRow) return;

      const get = (path: string) => path.split('.').reduce((acc, key) => acc?.[key], row) ?? '';
      const rawCountry = get('subjectPropertyLocation.country');
      const rawState = get('subjectPropertyLocation.state');
      const rawPropertyId = get('subjectPropertyLocation.propertyId');

      const countryCode: string = countryAbbs.find(item => item.value === rawCountry)?.acronym ?? rawCountry;
      const stateCode: string = stateAbbs.find(item => item.value === rawState)?.acronym ?? rawState;

      excelRow.getCell(1).value = withDefaultValues(countryCode, 'string', 'N/A');
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.propertyName'), 'string', 'N/A');                    // Property Name
      excelRow.getCell(3).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType'), 'string', 'N/A');                     // Property Type
      excelRow.getCell(4).value = withDefaultValues(get('subjectPropertyLocation.addressLine1'), 'string', 'N/A');                    // Address
      excelRow.getCell(5).value = withDefaultValues(get('subjectPropertyLocation.city'), 'string', 'N/A');                            // City
      excelRow.getCell(6).value = withDefaultValues(stateCode, 'string', 'N/A');
      excelRow.getCell(7).value = withDefaultValues(get('externalReferenceId'), 'string', '');                                     // AID Code
      excelRow.getCell(8).value = withDefaultValues(get('jobCenterActivity.firstName') + ' ' + get('jobCenterActivity.lastName'), 'string', 'N/A');                   // Appraiser Name

      const partner: string = partnerInfo.find(item => item.acronym === rawPropertyId)?.value ?? '';
      excelRow.getCell(9).value = withDefaultValues(partner, 'string', '');                                      // Partner
      const yearBuilt = parseInt(get('improvementInformation.yearBuilt'));
      excelRow.getCell(10).value = withDefaultValues(yearBuilt > 1900 ? yearBuilt : null, 'number', 'N/A');
      const buildingAreaPrior = get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family' ?
        toNumber(get('improvementInformation.secondaryImprovementPriorValue')) :
        toNumber(get('improvementInformation.primaryImprovementPriorValue'));
      excelRow.getCell(11).value = typeof buildingAreaPrior === 'number' ? buildingAreaPrior : 0;    // Building Area Prior Q 
      const buildingAreaCurrent = get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family' ?
        toNumber(get('improvementInformation.secondaryImprovementValue')) :
        toNumber(get('improvementInformation.primaryImprovementValue'));
      excelRow.getCell(12).value = typeof buildingAreaCurrent === 'number' ? buildingAreaCurrent : 0;          // Building Area Current Q

      if (typeof buildingAreaCurrent === 'number' && typeof buildingAreaPrior === 'number' && buildingAreaPrior != 0) {
        excelRow.getCell(13).value = ((buildingAreaCurrent - buildingAreaPrior) / buildingAreaPrior);    // QoQ Building Area
      } else {
        excelRow.getCell(13).value = 0;
      }
      const priorOccupancyPercentage = toNumber(get('improvementInformation.priorOccupancy'));
      if (typeof priorOccupancyPercentage === 'number') {
        excelRow.getCell(14).value = priorOccupancyPercentage / 100;                                                            // Anchor GLA (%)
      } else {
        excelRow.getCell(14).value = '';
      }               // M1 Occupancy Prior Q
      const occupancyPercentage = toNumber(get('improvementInformation.occupancy'));
      if (typeof occupancyPercentage === 'number') {
        excelRow.getCell(15).value = occupancyPercentage / 100;                                                            // Anchor GLA (%)
      } else {
        excelRow.getCell(15).value = '';
      }                     // M1 Occupancy Current Q

      excelRow.getCell(16).value = withDefaultValues(get('valuationSummary.asIsScenario.priorFinalValue'), 'number', 0);             // Final Market Value Prior Q
      excelRow.getCell(17).value = withDefaultValues(get('valuationSummary.asIsScenario.finalValue'), 'number', 0);                  // Final Market Value Current Q

      excelRow.getCell(18).value = withDefaultValues(calculateDeltaPercentage(get('valuationSummary.asIsScenario.finalValue'),
        get('valuationSummary.asIsScenario.priorFinalValue')), 'number', 0);                                                            // Δ Final Market Value(100% local)

      excelRow.getCell(19).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType') != 'Living' &&
        get('propertyTypeAndTenancy.propertyType') != 'Multi-Family' ?
        calculatePSF(get('valuationSummary.asIsScenario.priorFinalValue'),
          get('improvementInformation.primaryImprovementPriorValue')) : '', 'number', 0);                                                            // $ PSF Prior Quarter
      excelRow.getCell(20).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType') != 'Living' &&
        get('propertyTypeAndTenancy.propertyType') != 'Multi-Family' ?
        calculatePSF(get('valuationSummary.asIsScenario.finalValue'),
          get('improvementInformation.primaryImprovementValue')) : '', 'number', 0);                                                            // $ PSF Current Quarter
      excelRow.getCell(21).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family' ?
        calculatePSF(get('valuationSummary.asIsScenario.priorFinalValue'),
          get('improvementInformation.primaryImprovementPriorValue')) : '', 'number', 0);                                                              // $/Unit (Multifamily) Prior Q
      excelRow.getCell(22).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family' ?
        calculatePSF(get('valuationSummary.asIsScenario.finalValue'),
          get('improvementInformation.primaryImprovementValue')) : '', 'number', 0);                                      // $/Unit (Multifamily)Current Q
      excelRow.getCell(23).value = withDefaultValues(get('valuationSummary.asIsScenario.priorInternalRateOfReturn'), 'number', '');   // IRR/DR Prior Q
      excelRow.getCell(24).value = withDefaultValues(get('valuationSummary.asIsScenario.internalRateOfReturn'), 'number', '');        // IRR/DR Current Q
      excelRow.getCell(25).value = withDefaultValues(calculateDelta(get('valuationSummary.asIsScenario.internalRateOfReturn'),
        get('valuationSummary.asIsScenario.priorInternalRateOfReturn')), 'number', 'N/A');                                                            // Δ IRR/DR
      excelRow.getCell(26).value = withDefaultValues(get('valuationSummary.asIsScenario.priorTerminalCapitalizationRate'), 'number', '');   // TCR Prior Q
      excelRow.getCell(27).value = withDefaultValues(get('valuationSummary.asIsScenario.terminalCapitalizationRate'), 'number', '');  // TCR Current Q
      excelRow.getCell(28).value = withDefaultValues(calculateDelta(get('valuationSummary.asIsScenario.terminalCapitalizationRate'),
        get('valuationSummary.asIsScenario.priorTerminalCapitalizationRate')), 'number', 'N/A');                                                            // Δ TCR
      excelRow.getCell(29).value = withDefaultValues(get('valuationSummary.asIsScenario.priorCapitalizationRate'), 'number', '');     // OCRR Prior Q
      excelRow.getCell(30).value = withDefaultValues(get('valuationSummary.asIsScenario.capitalizationRate'), 'number', '');          // OCR Current Q
      excelRow.getCell(31).value = withDefaultValues(calculateDelta(get('valuationSummary.asIsScenario.capitalizationRate'),
        get('valuationSummary.asIsScenario.priorCapitalizationRate')), 'number', 'N/A');                                                            // Δ OCR
      excelRow.getCell(32).value = withDefaultValues(get('propertyTypeAndTenancy.tenancy'), 'string', '');                         // Single/Multi-Tenant
      excelRow.getCell(33).value = withDefaultValues(get('cashflow.priorWalt'), 'number', '');                                     // WALT Prior Q
      excelRow.getCell(34).value = withDefaultValues(get('cashflow.walt'), 'number', '');                                          // WALT Current Q
      excelRow.getCell(35).value = withDefaultValues(get('improvementInformationRetail.totalAnchorsArea'), 'number', 0);                                                           // Anchor (SF)
      const anchorGLAPercentage = toNumber(get('improvementInformationRetail.totalAnchorsGrossLeasableAreaPercentage'));
      if (typeof anchorGLAPercentage === 'number') {
        excelRow.getCell(36).value = anchorGLAPercentage / 100;                                                            // Anchor GLA (%)
      } else {
        excelRow.getCell(36).value = 0;
      }
      excelRow.getCell(37).value = withDefaultValues(get('tenantInformation.largestTenant'), 'string', '');                       // Largest Tenant
      excelRow.getCell(38).value = withDefaultValues(get('tenantInformation.largestTenantArea'), 'number', 0);                    // Largest Tenant (SF)
      excelRow.getCell(39).value = withDefaultValues(calculateLargestTenantAreaPercentage(
        get('tenantInformation.largestTenantArea'), get('improvementInformation.primaryImprovementValue')), 'number', 0);                                                            // Largest Tenant (%)
      excelRow.getCell(40).value = withDefaultValues(get('assumptions.priorMarketInflationYears1_5'), 'number', 0);               // Market Inflation Prior Q
      excelRow.getCell(41).value = withDefaultValues(get('assumptions.marketInflationYears1_5'), 'number', 0);                    // Market Inflation Current Q
      excelRow.getCell(42).value = withDefaultValues(get('assumptions.priorExpenseInflationYears1_5'), 'number', 0);         // Expense Inflation Pror Q                                  // Expense Inflation Prior Q
      excelRow.getCell(43).value = withDefaultValues(get('assumptions.expenseInflationYears1_5'), 'number', 0);              // Expense Inflation Current Q
      excelRow.getCell(44).value = withDefaultValues(!(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family') ?
        toNumber(get('contractMonthRent.priorAverageContractRentPSF')) : '', 'number', 0);           // M1 Contract PSF Prior Q
      excelRow.getCell(45).value = withDefaultValues(!(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family') ?
        toNumber(get('contractMonthRent.averageContractRentPSF')) : '', 'number', 0);                // M1 Contract PSF Current Q
      excelRow.getCell(46).value = withDefaultValues(!(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family') ? calculateDeltaPercentage(get('contractMonthRent.averageContractRentPSF'),
          get('contractMonthRent.priorAverageContractRentPSF')) : '', 'number', 0);                                                             // QoQ Contract Rent Δ
      excelRow.getCell(47).value = withDefaultValues(get('contractMonthRent.priorAverageMarketRentPSF'), 'number', 0);            // M1 Market PSF Prior Q
      excelRow.getCell(48).value = withDefaultValues(get('contractMonthRent.averageMarketRentPSF'), 'number', 0);                 // M1 Market PSF Current Q
      excelRow.getCell(49).value = withDefaultValues(calculateDeltaPercentage(get('contractMonthRent.averageMarketRentPSF'), get('contractMonthRent.priorAverageMarketRentPSF')), 'number', 0);                                                            // QoQ Market Rent Δ
      excelRow.getCell(50).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family' ?
        toNumber(get('contractMonthRent.priorAverageContractRentPSF')) : '', 'number', 0);              // M1 Contract Per Unit Prior Q
      excelRow.getCell(51).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType') == 'Living' ||
        get('propertyTypeAndTenancy.propertyType') == 'Multi-Family' ?
        toNumber(get('contractMonthRent.averageContractRentPSF')) : '', 'number', 0);                   // M1 Contract Per Unit Current Q
      excelRow.getCell(52).value = withDefaultValues(calculateDeltaPercentage(get('contractMonthRent.averageMonthlyRent'), get('contractMonthRent.priorAverageMonthlyRent')), 'number', 0);                                                          // QoQ CR Per Unit Δ
      excelRow.getCell(53).value = withDefaultValues(get('valuationSummary.asIsScenario.priorHoldingPeriod'), 'number', 0);          // Hold Period Prior Q
      excelRow.getCell(54).value = withDefaultValues(get('valuationSummary.asIsScenario.holdingPeriod'), 'number', 0);               // Hold Period Current Q
      excelRow.getCell(55).value = withDefaultValues(calculateDeltaPercentage(get('valuationSummary.asIsScenario.holdingPeriod'), get('valuationSummary.asIsScenario.priorHoldingPeriod')), 'number', 0);                                                             // QoQ Hold Period
      excelRow.getCell(56).value = withDefaultValues(get('improvementInformation.priorVacancy'), 'number', '');                                  // Vacancy Prior Q
      excelRow.getCell(57).value = withDefaultValues(get('improvementInformation.vacancy'), 'number', '');                                       // Vacancy Current Q
      excelRow.getCell(58).value = withDefaultValues(calculateDeltaPercentage(get('improvementInformation.vacancy'), get('improvementInformation.priorVacancy')), 'number', 0);                                                               // QoQ Vacancy
      excelRow.getCell(59).value = withDefaultValues(get('cashflow.priorCollectionLoss'), 'number', 0);                           // Collection Loss Prior Q
      excelRow.getCell(60).value = withDefaultValues(get('cashflow.collectionLoss'), 'number', 0);                                // Collection Loss Current Q
      excelRow.getCell(61).value = withDefaultValues(calculateDeltaPercentage(get('cashflow.collectionLoss'), get('cashflow.priorCollectionLoss')), 'number', 0);                                                              // QoQ Collection Loss
      excelRow.getCell(62).value = withDefaultValues(get('cashflow.priorConcessions'), 'number', 0);                              // Concessions Prior Q
      excelRow.getCell(63).value = withDefaultValues(get('cashflow.concessions'), 'number', 0);                                   // Concessions Current Q
      excelRow.getCell(64).value = withDefaultValues(calculateDeltaPercentage(get('cashflow.concessions'), get('cashflow.priorConcessions')), 'number', 0);                                                            // QoQ Concessions
      excelRow.getCell(65).value = withDefaultValues(get('cashflow.year1NOIPSF'), 'number', 0);                                   // Y1 NOI PSF
      excelRow.getCell(66).value = withDefaultValues(get('cashflow.impliedOverallRate.year1'), 'number', 'N/A');          // Y1 NOI % Yield
      excelRow.getCell(67).value = withDefaultValues(calculateAvg(get('cashflow.impliedOverallRate.year1'),
        get('cashflow.impliedOverallRate.year2'), get('cashflow.impliedOverallRate.year3'),
        get('cashflow.impliedOverallRate.year4'), get('cashflow.impliedOverallRate.year5')), 'number', 'N/A');        // Y1-5 NOI % Yield
      excelRow.getCell(68).value = withDefaultValues(calculateAvg(get('cashflow.impliedOverallRate.year6'),
        get('cashflow.impliedOverallRate.year7'), get('cashflow.impliedOverallRate.year8'),
        get('cashflow.impliedOverallRate.year9'), get('cashflow.impliedOverallRate.year10')), 'number', 'N/A');     // Y6-10 NOI % Yield
      excelRow.getCell(69).value = withDefaultValues(get('cashflow.impliedOverallRate.year10'), 'number', 'N/A');         // Y10 NOI Yield
      excelRow.getCell(70).value = withDefaultValues(get('cashflow.netOperationIncome.year1'), 'number', 'N/A');                    // Year 1
      excelRow.getCell(71).value = withDefaultValues(get('cashflow.netOperationIncome.year2'), 'number', 'N/A');                    // Year 2
      excelRow.getCell(72).value = withDefaultValues(get('cashflow.netOperationIncome.year3'), 'number', 'N/A');                    // Year 3
      excelRow.getCell(73).value = withDefaultValues(get('cashflow.netOperationIncome.year4'), 'number', 'N/A');                    // Year 4
      excelRow.getCell(74).value = withDefaultValues(get('cashflow.netOperationIncome.year5'), 'number', 'N/A');                    // Year 5
      excelRow.getCell(75).value = withDefaultValues(get('cashflow.netOperationIncome.year6'), 'number', 'N/A');                    // Year 6
      excelRow.getCell(76).value = withDefaultValues(get('cashflow.netOperationIncome.year7'), 'number', 'N/A');                    // Year 7
      excelRow.getCell(77).value = withDefaultValues(get('cashflow.netOperationIncome.year8'), 'number', 'N/A');                    // Year 8
      excelRow.getCell(78).value = withDefaultValues(get('cashflow.netOperationIncome.year9'), 'number', 'N/A');                    // Year 9
      excelRow.getCell(79).value = withDefaultValues(get('cashflow.netOperationIncome.year10'), 'number', 'N/A');                   // Year 10
      excelRow.getCell(80).value = withDefaultValues(get('cashflow.netOperationIncome.year11'), 'number', 'N/A');                   // Year 11

      excelRow.commit();
    });

    // Save the file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Appraisal_Extract_${new Date().toISOString()}.xlsx`);
  }

  async exportBuds() {
    const selectedAndVisibleRows = this.gridApi.getSelectedRows();

    if (!selectedAndVisibleRows.length) {
      alert('No property record seleted');
      return;
    }

    if (selectedAndVisibleRows.length > 1) {
      alert('Please select only one property record to export.');
      return;
    }

    if (this.isAnySelectedRowInvalid()) {
      const proceed = await this.confirmDialog.open();        
      if (proceed === false) {
        const row = selectedAndVisibleRows[0];
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/activity-details', row.activityNumber])
        );
        window.open(url, '_blank');
        return;       
      }
      if (proceed === null) {
        // User dismissed the dialog without making a choice (e.g., clicked outside the dialog)
        return;
      } 
    }

    const externalReferenceIds: string[] = selectedAndVisibleRows.map(item => item.externalReferenceId);
    
    const workbook = new ExcelJS.Workbook();

    // Load template from assets
    const dataUrl = 'assets/files/BRAVE.xlsx';
    const response = await fetch(dataUrl);
    const arrayBuffer = await response.arrayBuffer();

    await workbook.xlsx.load(arrayBuffer);
    const worksheet = workbook.getWorksheet(1); // Get first sheet   

    const toNumber = (value: any | null | undefined): number | string => {
      if (typeof value === 'string' && value !== '-' && value !== '.' && value !== '') {
        const numVal = value.trim().replace(/[^0-9.-]+/g, '');
        return numVal === '' ? numVal : Number(numVal);
      } else if (typeof value === 'number') {
        return value;
      }
      else {
        return '';
      }
    };

    const toString = (value: any | null | undefined): string => {
      if (typeof value === 'string') {
        return value;
      } else {
        return '';
      }
    };

    const withDefaultValues = (value: any | null | undefined, expectedType: string, defaultValue: number | string): number | string => {      
      const excelErrorValues = ['#REF!', '#DIV/0!', '#VALUE!', '#NAME?', '#NUM!', '#N/A', '#NULL!', '#SPILL!', '#CALC!', '#GETTING_DATA' ]
      
      if (expectedType === 'string') {
        const stringValue = toString(value);
        if (excelErrorValues.includes(value))
          return defaultValue;
        return stringValue.trim() === '' ? defaultValue : stringValue;
      } else if (expectedType === 'number') {
        const numberVal = toNumber(value);
        return numberVal === '' ? defaultValue : numberVal;
      } else if (expectedType === 'percentage') {
        const numberVal = toNumber(value);
        return numberVal === '' ? defaultValue : Number(numberVal) / 100;
      } else {
        return '';
      }
    }

    const resolveDevelopmentStatus = (value: any | null | undefined) : string | null => {
      const developmentStatus = toString(value).toLowerCase();
      if (developmentStatus === 'yes' || developmentStatus === 'no'){
        return 'Existing';        
      } else if (developmentStatus === 'proposed') {
        return 'Proposed'
      } else {
        return null;
      }      
    }

    type AreaUnit = 'acre' | 'hectare' | 'sqm' | 'sqft';
    const conversionToSqm : Record<AreaUnit, number> =  {
      acre : 4046.8564224 ,
      hectare: 10000,
      sqm: 1,
      sqft: 0.092903
    };

  const convert = (value: number | string, from: AreaUnit, to: AreaUnit) : number | string => {
    
    if (typeof value != 'number' || (!value && value !== 0) ) return '';

    if (!(from in conversionToSqm) || !(to in conversionToSqm)) {
      return '';
    }

    if (from == to){
      return value;
    }

    // Convert to square meters first
    const valueInSqm = value * conversionToSqm[from];

    // Convert from square meters to target
    return valueInSqm / conversionToSqm[to];
  }

  const populateHorizontalFields = (excelRow: any ,values: any[] | null | undefined, fieldName: string, expectedType: string, defaultValue: number | string ) : void => {
    values?.forEach((value, index) => {   
      excelRow.getCell(2 + index).value = withDefaultValues(value[fieldName], expectedType, defaultValue); // Populate from 2nd column
    });
  }

  const stateAbbs: LookupItem[] = this.fullLookupValues["StateName"];

    let rowNumber = 2;
    // Example: Fill starting from row 2 (assuming row 1 is header)
    let clientRef: String | Number = "";

    selectedAndVisibleRows.forEach((row, index) => {      
      let excelRow = worksheet?.getRow(rowNumber++);
      if (!worksheet || !excelRow) return;

      const get = (path: string) => path.split('.').reduce((acc, key) => acc?.[key], row) ?? '';

      clientRef = withDefaultValues(get('externalReferenceId'), 'string', ''); // Job.ClientRef

      if (clientRef === '') {
        alert('Invalid file name. Generated files must use the client reference number in this format: [YYYY_MM_DD]_[Job.ClientRef]_BRAVEv[version#]');
        return;
      }
      
      const rawState = get('subjectPropertyLocation.state');      
      const stateCode: string = stateAbbs.find(item => item.value === rawState)?.acronym ?? rawState;

      const valuationSummary = get('valuationSummary');
      const revenueAndExpense = get('revenueAndExpense') || {};
      const applicableScenarios = valuationSummary.scenarios.filter((scenario: { includeScenario: string; }) => scenario.includeScenario === 'Yes');

      excelRow.getCell(2).value = clientRef.toString(); // Job.ClientRef
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('valuations.dateOfReport'), 'string', '');// Job.ReportDate
      excelRow.commit();
      
      // generated
      
      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('valuations.currency'), 'string', ''); // Job.CurrencyType
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.propertyName'), 'string', ''); // Property.Name
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.addressLine1'), 'string', ''); // Property.AddressStreet
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.city'), 'string', ''); // Property.AddressCity
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(stateCode, 'string', ''); // Property.AddressState
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.zipCode'), 'number', ''); // Property.AddressPostalCode
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.county'), 'string', ''); // Property.AddressCounty
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.country'), 'string', ''); // Property.AddressCountry
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.latitude'), 'number', ''); // Property.Latitude
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('subjectPropertyLocation.longitude'), 'number', ''); // Property.Longitude
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = '' // Property.LegalDescription
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);      
      excelRow.getCell(2).value = resolveDevelopmentStatus(get('constructionDetails.constructionStatus')); // Property.DevelopmentStatus
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('tenantInformation.numberOfTenants'), 'number', ''); // Property.NumTenantsCount
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('propertyTypeAndTenancy.propertyType'), 'string', ''); // Property.Type
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('propertyTypeAndTenancy.propertySubtype'), 'string', ''); // Property.Subtype
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('ownership.propertyOwnershipEntity'), 'string', ''); // Property.Owner
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = get('ownership.saleDate'); // Property.RecentSaleDate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('ownership.soldInLastThreeYears'), 'string', ''); // Property.SoldLastThreeYrs
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('ownership.salePrice'), 'number', ''); // Property.RecentSalePrice
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('ownership.listPrice'), 'number', ''); // Property.CurrentListPrice
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('ownership.contractPrice'), 'number', ''); // Property.CurrentSalePrice
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.currentTaxYear'), 'number', ''); // Property.Tax.Year
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.landAssessedValue'), 'number', ''); // Property.Tax.LandValue
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.improvementsAssessedValue'), 'number', ''); // Property.Tax.ImprovedValue
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.totalTaxExemptions'), 'number', ''); // Property.Tax.Exemptions
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.totalAssessedValue'), 'number', ''); // Property.Tax.AssessedValueTotal
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.assessorsMarketValue'), 'number', ''); // Property.Tax.MarketValueTotal
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      const cell = excelRow.getCell(2);
      const totalTaxRate = withDefaultValues(get('taxes.totalTaxRate'), 'number', ''); 
      if (typeof totalTaxRate === 'number'){
        const totalTaxRatePercentage = totalTaxRate / 100; // Convert percentage to actual
        cell.value = totalTaxRatePercentage;  // Property.Tax.RateAmount  
        if (totalTaxRatePercentage < 0 || totalTaxRatePercentage > 1) {
          // Change cell background color
          cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFF0000' } // red color
          };
          // Add note/comment
          cell.note = 'Must be a numeric value between 0.0000 and 100.0000. Rounded four decimal places.';
        } 
      } 
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('taxes.totalPropertyTaxes'), 'number', ''); // Property.TaxTotalTaxes
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Property.ParcelCount
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('parcelInformation.assessorsParcelNumber'), 'string', ''); // Property.ParcelNumbers       
      excelRow.commit();

      const siteInformation = get('siteInformation');
      let landAreaSF = '';
      let landAreaAC = '';
      let landAreaUsableSF = '';
      let landAreaUsableAC = '';

      const primaryLandValue = toNumber(siteInformation.primaryLandValue);
      const secondaryLandValue = toNumber(siteInformation?.secondaryLandValue);

      if (siteInformation.primaryLandMeasure.toLowerCase() == 'gross land area') {
        if (siteInformation.primaryLandUnit.toLowerCase() == 'square feet'){
          landAreaSF = '' + convert(primaryLandValue, 'sqft', 'sqft');
          landAreaAC = '' + convert(primaryLandValue, 'sqft', 'acre');
        } else if (siteInformation.primaryLandUnit.toLowerCase() == 'acres'){
          landAreaSF = '' + convert(primaryLandValue, 'acre', 'sqft');
          landAreaAC = '' + convert(primaryLandValue, 'acre', 'acre');
        }          
      }
        
      else if (siteInformation.secondaryLandMeasure.toLowerCase() == 'gross land area') {
        if (siteInformation.secondaryLandUnit.toLowerCase() == 'square feet'){
          landAreaSF = '' + convert(secondaryLandValue, 'sqft', 'sqft');
          landAreaAC = '' + convert(secondaryLandValue, 'sqft', 'acre');
        } else if (siteInformation.secondaryLandUnit.toLowerCase() == 'acres'){
          landAreaSF = '' + convert(secondaryLandValue, 'acre', 'sqft');
          landAreaAC = '' + convert(secondaryLandValue, 'acre', 'acre');
        }
      }

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(landAreaSF, 'number', ''); // Property.LandAreaSF
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(landAreaAC, 'number', ''); // Property.LandAreaAC
      excelRow.commit();
      
      if (siteInformation.primaryLandMeasure?.toLowerCase() == 'net land area') {
        if (siteInformation.primaryLandUnit?.toLowerCase() == 'square feet'){
          landAreaUsableSF = '' + convert(primaryLandValue, 'sqft', 'sqft');
          landAreaUsableAC = '' + convert(primaryLandValue, 'sqft', 'acre');
        } else if (siteInformation.primaryLandUnit?.toLowerCase() == 'acres') {
          landAreaUsableSF = '' + convert(primaryLandValue, 'acre', 'sqft');
          landAreaUsableAC = '' + convert(primaryLandValue, 'acre', 'acre');
        }          
      } else if (siteInformation.secondaryLandMeasure?.toLowerCase() == 'net land area') {
        if (siteInformation.secondaryLandUnit?.toLowerCase() == 'square feet') {
          landAreaUsableSF = '' + convert(secondaryLandValue, 'sqft', 'sqft');
          landAreaUsableAC = '' + convert(secondaryLandValue, 'sqft', 'acre');
        } else if (siteInformation.secondaryLandUnit?.toLowerCase() == 'acres') {
          landAreaUsableSF = '' + convert(secondaryLandValue, 'acre', 'sqft');
          landAreaUsableAC = '' + convert(secondaryLandValue, 'acre', 'acre');
        }          
      }

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(landAreaUsableSF, 'number', ''); // Property.LandAreaUsableSF
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(landAreaUsableAC, 'number', ''); // Property.LandAreaUsableAC
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('zoning.currentZoning'), 'string', ''); // Property.Zoning
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('siteInformation.topography'), 'string', ''); // Property.SiteTopography
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('floodZoneInformation.floodZone'), 'string', ''); // Property.SiteFloodZone
      excelRow.commit();

      const improvementInformation = get('improvementInformation');
      let grossBuildingArea = '';
      let netRentableArea = '';
      if (improvementInformation.primaryImprovementMeasure?.toLowerCase() == 'gross building area')
        grossBuildingArea = improvementInformation.primaryImprovementValue;
      else if (improvementInformation.secondaryImprovementMeasure?.toLowerCase() == 'gross building area')
        grossBuildingArea = improvementInformation.secondaryImprovementValue;
      else if (improvementInformation.tertiaryImprovementMeasure?.toLowerCase() == 'gross building area')
        grossBuildingArea = improvementInformation.tertiaryImprovementValue;

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(grossBuildingArea, 'number', ''); // Property.GrossBuildingArea
      excelRow.commit();

      if (improvementInformation?.primaryImprovementMeasure?.toLowerCase() == 'net rentable area')
        netRentableArea = improvementInformation.primaryImprovementValue;
      else if (improvementInformation?.secondaryImprovementMeasure?.toLowerCase() == 'net rentable area')
        netRentableArea = improvementInformation.secondaryImprovementValue;
      else if (improvementInformation?.tertiaryImprovementMeasure?.toLowerCase() == 'net rentable area')
        netRentableArea = improvementInformation.tertiaryImprovementValue;

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(netRentableArea, 'number', ''); // Property.NetRentableArea
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformationLiving.numberOfUnits'), 'number', ''); // Property.UnitsCount      
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.numberOfBuildings'), 'number', ''); // Property.BuildingsCount
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.numberOfStories'), 'number', ''); // Property.FloorsCount
      excelRow.commit();

      let elevators = Number(toNumber(get('mechanicalDetails.numberofPassengerElevators'))) 
                                        + Number(toNumber(get('mechanicalDetails.numberofFreightElevators')));      
      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(elevators, 'number', ''); // Property.Elevator
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.propertyClass'), 'string', ''); // Property.BuildingClass
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Property.ConstructionClass
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.buildingQuality'), 'string', ''); // Property.Quality
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.buildingCondition'), 'string', ''); // Property.Condition
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('parking.parkingTypeOne'), 'string', ''); // Property.ParkingType
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('parking.parkingTypeOneNoOfSpaces'), 'number', ''); // Property.ParkingSpacesCount
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.yearBuilt'), 'number', ''); // Property.YearBuilt
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.yearRenovated'), 'number', ''); // Property.YearRenovated
      excelRow.commit();

      let economicLifeRemain = Number(toNumber(get('improvementInformation.economicLife'))) 
                                        - Number(toNumber(get('improvementInformation.effectiveAge'))); 
      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(economicLifeRemain, 'number', ''); // Property.EconomicLifeRemain
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.baseRentalRevenue, 'number', ''); // Income.RentalIncome
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.totalOtherIncome, 'number', ''); // Income.OtherIncome
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.potentialGrossRevenue, 'number', ''); // Income.PotentialGrossIncome
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.vacancyandCollectionLoss, 'number', ''); // Income.VacancyLoss
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.effectiveGrossRevenue, 'number', ''); // Income.EffectiveGrossIncome
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.groundRent, 'number', ''); // Income.GroundLease
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.totalExpenses, 'number', ''); // Income.OperatingExpenses
      excelRow.commit();

      var replacementReserves = toNumber(revenueAndExpense?.stabilizedYear?.replacementReserves);
      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(replacementReserves, 'number', ''); // Income.Reserves
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = typeof replacementReserves === 'number' && replacementReserves > 0 ? 'Yes' : 'No'; // Income.ReservesIncluded
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('siteInformation.groundLeases'), 'string', ''); // Income.GroundLeaseIncluded
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(revenueAndExpense?.stabilizedYear?.noiTotalAmount, 'number', ''); // Income.NetOperatingIncome
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.occupancy'), 'percentage', ''); // Income.OccupancyRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('improvementInformation.vacancy'), 'percentage', ''); // Income.VacancyRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('assumptions.marketInflationYears1_5'), 'percentage', ''); // Income.RentGrowthRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('assumptions.expenseInflationYears1_5'), 'percentage', ''); // Income.ExpenseGrowthRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('cashflow.realEstateTaxGrowthRate'), 'percentage', ''); // Income.RETaxGrowthRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'valueCondition', 'string', ''); // Value.Name
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'dateOfValue', 'string', ''); // Value.Date
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'interestAppraised', 'string', ''); // Value.Interest
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);      
      populateHorizontalFields(excelRow, applicableScenarios, 'costApproachIndicatedValue', 'string', ''); // Value.CostApproach
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('constructionCosts.buildingImprovementCosts'), 'number', ''); // Value.CostDirect
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('constructionCosts.softCosts'), 'number', ''); // Value.CostIndirect
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('constructionCosts.totalEntrepreneurialProfit'), 'number', ''); // Value.CostApproachProfit
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('constructionCosts.siteImprovementCost'), 'number', ''); // Value.CostSiteImpv
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'totalDepreciation', 'number', ''); // Value.CostDepreciation
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'landValue', 'number', ''); // Value.LandSalesApproach
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'excessLandValue', 'number', ''); // Value.ExcessLand
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'salesComparisonApproachIndicatedValue', 'number', ''); // Value.SalesApproach
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'incomeCapitalizationApproach', 'number', ''); // Value.IncomeApproach
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'capitalizationRate', 'percentage', ''); // Value.CapRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'directCapitalizationIndicatedValue', 'number', ''); // Value.CapitalizationValue
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'yieldCapitalizationIndicatedValue', 'number', ''); // Value.CashFlowValue
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'internalRateOfReturn', 'percentage', ''); // Value.DiscountRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'terminalCapitalizationRate', 'percentage', ''); // Value.TerminalCapRate
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'finalValue', 'number', ''); // Value.ReconciledFinal
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      populateHorizontalFields(excelRow, applicableScenarios, 'insurableReplacementCost', 'number', ''); // Value.InsurableCost
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(get('constructionCosts.furnitureFixturesandEquipment'), 'number', ''); // Value.FFE
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Value.BEV
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Value.BulkMarketValue
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = '' // Value.AggregateRetailSum
      excelRow.commit();
      const jobCenterInfo = get('jobCenterActivity');
      const appraiserName = ((jobCenterInfo?.firstName ?? '').trim() + ' ' + (jobCenterInfo?.lastName ?? '').trim()).trim();
      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = withDefaultValues(appraiserName, 'string', ''); // Appraiser.Name
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Appraiser.LicenseState
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Appraiser.LicenseNum
      excelRow.commit();

      excelRow = worksheet.getRow(rowNumber++);
      excelRow.getCell(2).value = ''; // Appraiser.LicenseExpiration
      excelRow.commit();

    });
    
    // Save the file
    if (clientRef !== '') {       
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `${this.datePipe.transform(new Date(), 'yyyy_MM_dd')}_${clientRef.toString()}_BRAVEv1.0.xlsx`);
    }    
  }

  @ViewChild('approvalModal') approvalModal!: SaveModalPopupComponent;
  @ViewChild('confirmDialog') confirmDialog!: ConfirmDialogComponent;

  approveSelected(): void {
    if (this.isAnySelectedRowInvalid()) {
      alert('One or more selected rows have validation errors. Please correct them before proceeding.');
      return;
    }
    this.approvalModal.open('Approve');
  }

  rejectSelected(): void {
    if (this.isAnySelectedRowInvalid()) {
      alert('One or more selected rows have validation errors. Please correct them before proceeding.');
      return;
    }
    this.approvalModal.open('Reject');
  }

  handleModalAction(event: { action: string, comments: string }) {
    if (event.action === 'Approve') {
      this.performApproval(event.comments);
    } else if (event.action === 'Reject') {
      this.performRejection(event.comments);
    }
  }

  performApproval(comments: string) {
    this.approveSelectedWithComments(comments);
  }

  performRejection(comments: string) {
    this.rejectSelectedWithComments(comments);
  }

  openSavePreferencesModal() {
    this.approvalModal.open('Enter a name for your view'); // Make sure your modal supports dynamic titles or messages
  }

  printState(): void {
    console.log("Grid state", this.gridApi.getState());
  }

  isBookmarksPanelOpen: boolean = false;
  ontoggleBookmarkSidenav() {
    let state = this.gridApi.getState();
    this.appraisalDataService.setGridStateData(state);
    this.isBookmarksPanelOpen = !this.isBookmarksPanelOpen;
  }
  onStateUpdated(): void {
    let state = this.gridApi.getState();
    this.appraisalDataService.setGridStateData(state);
  }
  loadBookmark() {
    let state = this.appraisalDataService.getGridStateData();
    this.gridApi.setState(state);
  }
  async fetchImageAsBase64(url: string): Promise<string> {
    return fetch(url)
      .then(resp => resp.blob())
      .then(blob => new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
          // reader.result is something like "data:image/jpeg;base64,/9j/4AAQ…"
          const dataUrl = reader.result as string;
          // strip off the prefix
          const base64 = dataUrl.substring(dataUrl.indexOf(',') + 1);
          resolve(dataUrl);
        };
        reader.readAsDataURL(blob);
      }));
  }

  private groupHeaderNameOverrides: Record<string, string> = {
    contractMonthRent: 'Contract & Market Rent Information',
  };
}
